// brandcaddie Logo-Konfigurator Bundle v1.3
// EINZIGE QUELLE des Konfigurators (die Module unter 03_SHOP/konfigurator/js/ sind veraltet).
// Markup: sections/konfigurator.liquid · Styles: assets/konfigurator.css
// Property-Vertrag (Cart, Worker-Mail, Korrekturabzug-PDF): 03_SHOP/konfigurator/README.md — nur additiv aendern.
// Symbole: Phosphor Icons "Fill" (MIT, Copyright (c) 2023 Phosphor Icons), Master-SVGs + Lizenz in 03_SHOP/konfigurator/symbols/.
(function () {
"use strict";

// ==========================================================================
// roundRect POLYFILL (Safari <15.4)
// ==========================================================================
if (typeof CanvasRenderingContext2D !== 'undefined' && !CanvasRenderingContext2D.prototype.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, radii) {
    var r = typeof radii === 'number' ? radii : (Array.isArray(radii) ? radii[0] : 0);
    this.beginPath(); this.moveTo(x + r, y); this.lineTo(x + w - r, y);
    this.quadraticCurveTo(x + w, y, x + w, y + r); this.lineTo(x + w, y + h - r);
    this.quadraticCurveTo(x + w, y + h, x + w - r, y + h); this.lineTo(x + r, y + h);
    this.quadraticCurveTo(x, y + h, x, y + h - r); this.lineTo(x, y + r);
    this.quadraticCurveTo(x, y, x + r, y); this.closePath(); return this;
  };
}

// ==========================================================================
// ROOT + DATEN AUS DER SECTION
// ==========================================================================
var root = document.getElementById('shank-konfigurator');
if (!root || root._bcInit) return;
root._bcInit = true;

function readJSON(attr) {
  try { return JSON.parse(root.getAttribute(attr) || '{}'); }
  catch (e) { console.error('[bc] JSON-Fehler in ' + attr, e); return {}; }
}

var VARIANT_MAP = readJSON('data-variant-map');
var PRICE_MAP = readJSON('data-price-map');
var IMAGE_MAP = readJSON('data-product-images');
var ASSETS = readJSON('data-assets');
// Shopifys t-Filter maskiert HTML (& -> &amp;); die Texte landen per textContent im DOM -> einmal dekodieren
function decodeEntities(o) {
  var ta = document.createElement('textarea');
  (function walk(x) {
    Object.keys(x).forEach(function (k) {
      if (x[k] && typeof x[k] === 'object') walk(x[k]);
      else if (typeof x[k] === 'string' && x[k].indexOf('&') >= 0) { ta.innerHTML = x[k]; x[k] = ta.value; }
    });
  })(o);
  return o;
}
var I18N = decodeEntities(readJSON('data-i18n'));
var LOCALE = (root.getAttribute('data-locale') || 'de').toLowerCase();
var CURRENCY = root.getAttribute('data-currency') || 'EUR';
var QUOTE_URL = root.getAttribute('data-quote-url') || '';
var IS_EN = LOCALE.indexOf('en') === 0;
var DPR = Math.min(window.devicePixelRatio || 1, 2);
var REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

var BALL_MODE = (function () {
  var q = null;
  try { q = new URLSearchParams(window.location.search).get('ball'); } catch (e) { /* alte Browser */ }
  if (q === 'webgl') return 'webgl';
  if (q === 'photo') return 'photo_procedural';
  if (q === 'hybrid') return 'hybrid';
  var a = root.getAttribute('data-ball-preview');
  return a === 'webgl' || a === 'hybrid' ? a : 'photo_procedural';
})();

// Deutsche Fallbacks, falls ein Locale-Key fehlt (Section liefert sonst alles ueber data-i18n).
var FALLBACK = {
  change: 'Ändern', colorWhite: 'Weiß', colorYellow: 'Gelb',
  specConstruction: 'Konstruktion', specCover: 'Cover', specCompression: 'Kompression', specCategory: 'Kategorie',
  chipAreaCircle: 'Druckfläche Ø 25 mm', chipAreaSquare: 'Druckfläche 18,5 × 18,5 mm',
  tierUnit: 'Dutzend', tierNext: 'Ab {qty} Dutzend: {price} je Dutzend',
  ctaNextDesign: 'Weiter zur Gestaltung', ctaNextQuantity: 'Weiter zur Menge', ctaAdd: 'In den Warenkorb',
  reasonDesign: 'Logo hochladen oder Text bzw. Symbol wählen', reasonRights: 'Bitte Nutzungsrechte am Logo bestätigen',
  reasonPrice: 'Preis derzeit nicht verfügbar', addedText: '{qty} Dutzend {model} wurden hinzugefügt.',
  errorUpload: 'Die Logo-Datei konnte nicht übertragen werden. Bitte erneut versuchen.',
  errorCart: 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.',
  pdfNote: 'PDF-Logo: Die Vorschau folgt im Korrekturabzug.', dragHint: 'Ball ziehen, um ihn zu drehen',
  positionHint: 'Zum Verschieben die Ansicht „Druckfläche“ öffnen und das Logo ziehen.',
  errFormat: 'Bitte PNG, JPG, SVG oder PDF hochladen.', errSize: 'Datei zu groß ({size} MB). Max. 10 MB.',
  errMime: 'Dateiformat nicht erkannt.',
  errSignature: 'Dateiinhalt passt nicht zur Dateiendung. Bitte eine echte PNG-, JPG-, SVG- oder PDF-Datei hochladen.',
  errLoad: 'Datei konnte nicht geladen werden.', errPx: 'Bild zu groß ({w} × {h} px). Max. {max} px.',
  warnSmall: 'Bild sehr klein ({w} × {h} px). Die Druckqualität könnte leiden.',
  infoSvg: 'SVG erkannt: optimale Qualität für jeden Druckbereich.',
  infoPdf: 'PDF wird von unserem Team geprüft und für den Druck aufbereitet.',
  infoTransparent: 'Transparenter Hintergrund erkannt',
  dpiBad: '~{dpi} DPI: Auflösung zu niedrig für scharfen Druck', dpiWarn: '~{dpi} DPI: Auflösung grenzwertig',
  dpiGood: '~{dpi} DPI: optimale Druckqualität', badgeSvg: 'SVG: optimale Qualität', badgePdf: 'PDF: manuelle Prüfung',
  priceFrom: 'ab {price} je Dutzend', perDozen: 'je Dutzend', qtyWithBalls: '{qty} Dutzend ({balls} Bälle)',
  symbolNone: 'Kein Symbol',
  inkHint: 'Text und Symbol werden in Schwarz gedruckt. Eine Sonderfarbe stimmen wir im Korrekturabzug mit Ihnen ab.',
  inkHintFlag: 'Flaggen werden in Originalfarben gedruckt (Tampondruck, max. 4 Farben inkl. schwarzer Kontur). Text bleibt schwarz.'
};

function t(key, vars) {
  var s = I18N[key];
  if (typeof s !== 'string' || !s) s = FALLBACK[key] || key;
  if (vars) {
    Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(String(vars[k])); });
  }
  return s;
}

function symbolLabel(id) {
  var m = I18N.symbols && I18N.symbols[id];
  return m || (SYMBOLS[id] ? SYMBOLS[id].de : id);
}
var SYMBOL_GROUP_DE = { classic: 'Klassisch', golf: 'Golf & Sport', party: 'Feiern & Anlässe', nature: 'Natur & Tiere', flags: 'Flaggen' };
function symbolGroupLabel(id) {
  var m = I18N.symbolGroups && I18N.symbolGroups[id];
  return m || SYMBOL_GROUP_DE[id] || id;
}
// Druckhinweis: Text/Icons schwarz, Flaggen in Originalfarben
function updateInkHint() {
  var p = $('#inkHint');
  if (p) p.textContent = isFlag(state.symbol.id) ? t('inkHintFlag') : t('inkHint');
}

// ==========================================================================
// DRUCKFLAECHEN (Werte unveraendert gegenueber v1.2 — Export und Worker haengen daran)
// ==========================================================================
// Golfball = 42,67 mm; Canvas-Ball = size * 0.76 (Radius 0.38)
var printAreasConfig = {
  circle: {
    shape: 'circle',
    diameter: 0.445,          // 25mm / 42.67mm * 0.76
    centerX: 0.5,
    centerY: 0.48,
    maxLogoDiameter: 0.40,    // ~90 % der Druckflaeche
    physicalDiameterMM: 25
  },
  square: {
    shape: 'square',
    width: 0.329,             // 18.5mm / 42.67mm * 0.76
    height: 0.329,
    centerX: 0.5,
    centerY: 0.48,
    maxLogoWidth: 0.30,
    maxLogoHeight: 0.30,
    physicalWidthMM: 18.5,
    physicalHeightMM: 18.5
  }
};
var BALL_RADIUS_MM = 42.67 / 2;

// Gemeinsame Rahmung aller Ball-Ansichten (Foto, prozedural, WebGL): Anteile der Canvas-Kante
var BALL = { cx: 0.5, cy: 0.47, r: 0.38 };

// ==========================================================================
// SCHRIFTEN (Text & Symbol)
// ==========================================================================
var fontPresets = {
  klassisch: { id: 'klassisch', label: 'Klassisch', family: "'Playfair Display', serif", weight: '700' },
  modern: { id: 'modern', label: 'Modern', family: "'Inter', sans-serif", weight: '700' },
  elegant: { id: 'elegant', label: 'Elegant', family: "'Dancing Script', cursive", weight: '700' }
};
var TEXT_MAX_CHARS = 15;

// ==========================================================================
// PRODUKTE (Specs hier, Preise ausschliesslich aus Shopify via data-price-map)
// ==========================================================================
var TIERS = [
  { min: 12, max: 23 }, { min: 24, max: 47 }, { min: 48, max: 95 }, { min: 96, max: 200 },
  { min: 201, max: 300 }, { min: 301, max: 500 }, { min: 501, max: 999 }
];
TIERS.forEach(function (tier) { tier.label = tier.min + '–' + tier.max + ' Dutzend'; });

var DRUCK = 'Tampondruck, bis 4 Farben, 300 DPI';
var products = [
  { id: 'tour-response', shopifyHandle: 'tour-response-logo', name: 'Tour Response',
    specs: { schichten: '3-Schicht', cover: 'Cast Urethane', kategorie: 'Tour', kompression: 'Mittel', druck: DRUCK },
    specsEn: { schichten: '3-piece', cover: 'Cast urethane', kategorie: 'Tour', kompression: 'Medium' } },
  { id: 'tp5', shopifyHandle: 'tp5-logo', name: 'TP5',
    specs: { schichten: '5-Schicht', cover: 'Cast Urethane', kategorie: 'Tour Premium', kompression: 'Mittel-Hoch', druck: DRUCK },
    specsEn: { schichten: '5-piece', cover: 'Cast urethane', kategorie: 'Tour Premium', kompression: 'Medium-high' } },
  { id: 'tp5x', shopifyHandle: 'tp5x-logo', name: 'TP5x',
    specs: { schichten: '5-Schicht', cover: 'Cast Urethane (steif)', kategorie: 'Tour Premium', kompression: 'Hoch', druck: DRUCK },
    specsEn: { schichten: '5-piece', cover: 'Cast urethane (firm)', kategorie: 'Tour Premium', kompression: 'High' } },
  { id: 'speedsoft', shopifyHandle: 'speedsoft-logo', name: 'SpeedSoft',
    specs: { schichten: '2-Schicht', cover: 'Ionomer', kategorie: 'Soft', kompression: 'Niedrig (~40)', druck: DRUCK },
    specsEn: { schichten: '2-piece', cover: 'Ionomer', kategorie: 'Soft', kompression: 'Low (~40)' } },
  { id: 'distance-plus', shopifyHandle: 'distance-logo', name: 'Distance+',
    specs: { schichten: '2-Schicht', cover: 'Ionomer', kategorie: 'Distance', kompression: 'Mittel', druck: DRUCK },
    specsEn: { schichten: '2-piece', cover: 'Ionomer', kategorie: 'Distance', kompression: 'Medium' } }
];
products.forEach(function (p) {
  p.printAreas = printAreasConfig;
  p.exportSettings = { dpi: 300, format: 'png', background: 'transparent' };
});

// ==========================================================================
// STATE
// ==========================================================================
var DEFAULT_PLACEMENT = { x: 0.5, y: 0.48, scale: 0.7 };
var MOQ = 12, MAX_QTY = 999;

var state = {
  product: products[0],
  color: 'white',
  mode: 'logo',                 // 'logo' | 'text' (Text & Symbol)
  printShape: 'circle',
  logo: null,                   // { file, image, dataUrl, width, height, dpi, format, isPDF }
  placement: { x: DEFAULT_PLACEMENT.x, y: DEFAULT_PLACEMENT.y, scale: DEFAULT_PLACEMENT.scale },
  quantity: MOQ,
  text: { lines: ['', '', ''], font: 'klassisch', enabled: false },
  symbol: { id: null, layout: 'above' },
  colorWish: '',
  wishDate: '',
  rightsConfirmed: false,
  view: 'real',                 // 'real' | 'print' | 'size'
  angle: 0,                     // V1: 0..90 Grad
  step: 1,
  designVersion: 0,
  ui: { dragging: false, busy: false }
};

// ==========================================================================
// EVENT BUS
// ==========================================================================
var bus = {
  _l: {},
  on: function (ev, fn) { (this._l[ev] || (this._l[ev] = [])).push(fn); },
  emit: function (ev, data) { (this._l[ev] || []).forEach(function (fn) { fn(data); }); }
};

function designChanged() {
  state.designVersion++;
  bus.emit('design:changed');
}

// ==========================================================================
// PREISE
// ==========================================================================
function getTierForQuantity(qty) {
  for (var i = 0; i < TIERS.length; i++) if (qty >= TIERS[i].min && qty <= TIERS[i].max) return TIERS[i];
  return TIERS[TIERS.length - 1];
}
function variantKey(product, color, tier) {
  return product.shopifyHandle + '-' + (color === 'yellow' ? 'gelb' : 'weiss') + '-' + tier.min;
}
function tierPrice(product, color, tier) {
  var c = PRICE_MAP[variantKey(product, color, tier)];
  return (typeof c === 'number' && c > 0) ? c / 100 : null;
}
function currentPricePerDozen() {
  return tierPrice(state.product, state.color, getTierForQuantity(state.quantity));
}
var _fmtUi = null, _fmtDe = null;
function formatPrice(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return '—';
  if (!_fmtUi) _fmtUi = new Intl.NumberFormat(IS_EN ? 'en-GB' : 'de-DE', { style: 'currency', currency: CURRENCY });
  return _fmtUi.format(amount);
}
// Property-Werte bleiben deutsch formatiert (Produktion, Worker, Bestellmail).
function formatPriceDE(amount) {
  if (!_fmtDe) _fmtDe = new Intl.NumberFormat('de-DE', { style: 'currency', currency: CURRENCY });
  return _fmtDe.format(amount);
}

function getActivePrintArea() {
  return state.product.printAreas[state.printShape];
}
// Halber Druckflaechen-Winkel auf der Kugel (Bogenlaenge / Radius)
function printHalfAngle(pa) {
  var half = pa.shape === 'circle' ? pa.physicalDiameterMM / 2 : pa.physicalWidthMM / 2;
  return half / BALL_RADIUS_MM;
}

// ==========================================================================
// DOM HELPERS
// ==========================================================================
function $(sel) { return root.querySelector(sel); }
function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }
function setChecked(btns, pred) {
  btns.forEach(function (b) { b.setAttribute('aria-checked', pred(b) ? 'true' : 'false'); });
}
function el(tag, cls, text) {
  var e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text !== undefined) e.textContent = text;
  return e;
}

// ==========================================================================
// SYMBOLE — Phosphor Icons "Fill" (MIT), viewBox 0 0 256 256, je ein Pfad; dazu Landesflaggen (farbig).
// "de" ist der Property-Wert (Produktion), die UI-Bezeichnung kommt aus den Locales. Gruppen = Reiter im Picker.
// Erzeugt aus einer Tabelle (Symbole + Locales + Section-i18n gemeinsam pflegen).
// ==========================================================================
var SYMBOLS = {
  "clover": { file: 'clover', group: 'classic', de: "Kleeblatt", d: 'M228,120c0,22.63-6,36.72-17.93,41.87a27.3,27.3,0,0,1-11,2.13,41.75,41.75,0,0,1-8.4-.93,4.05,4.05,0,0,1-2.52-1.64,368.49,368.49,0,0,0-47.75-55.26,8,8,0,0,0-11,11.62c14.84,13.91,64.13,63.49,78.32,120.27a8,8,0,0,1-5.82,9.7A8.13,8.13,0,0,1,200,248a8,8,0,0,1-7.75-6.06c-4.12-16.47-11.65-32.48-20.46-47.09a25.85,25.85,0,0,1-1.9,7.21C164.72,214,150.63,220,128,220s-36.72-6-41.88-17.94c-5.45-12.58-.39-30.82,15-54.21.68-1,1.36-2,2-3l-3,2C82.84,158.27,68.35,164,56.89,164a27.3,27.3,0,0,1-11-2.13C34,156.72,28,142.63,28,120s6-36.72,17.93-41.88c12.59-5.45,30.83-.39,54.22,15l3,2q-1-1.5-2-3c-15.41-23.39-20.47-41.63-15-54.22C91.28,26,105.37,20,128,20s36.72,6,41.88,17.93c5.45,12.59.39,30.83-15,54.22q-1,1.53-2,3l3-2c23.39-15.41,41.63-20.47,54.22-15C222,83.28,228,97.37,228,120Z' },
  "star": { file: 'star', group: 'classic', de: "Stern", d: 'M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z' },
  "heart": { file: 'heart', group: 'classic', de: "Herz", d: 'M240,102c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,228.66,16,172,16,102A62.07,62.07,0,0,1,78,40c20.65,0,38.73,8.88,50,23.89C139.27,48.88,157.35,40,178,40A62.07,62.07,0,0,1,240,102Z' },
  "spade": { file: 'spade', group: 'classic', de: "Pik", d: 'M232,136a56,56,0,0,1-83.4,48.82l11.06,36.88A8,8,0,0,1,152,232H104a8,8,0,0,1-7.66-10.3l11.06-36.88A56,56,0,0,1,24,136c0-32,17.65-62.84,51-89.27a234.14,234.14,0,0,1,49.89-30.11,7.93,7.93,0,0,1,6.16,0A234.14,234.14,0,0,1,181,46.73C214.35,73.16,232,104,232,136Z' },
  "club": { file: 'club', group: 'classic', de: "Kreuz", d: 'M240,144a56,56,0,0,1-84.81,48h-4.44l8.91,29.7A8,8,0,0,1,152,232H104a8,8,0,0,1-7.66-10.3l8.91-29.7h-4.44A56,56,0,1,1,72,88c.78,0,1.55,0,2.33,0a56,56,0,1,1,107.34,0c.77,0,1.55,0,2.33,0A56.06,56.06,0,0,1,240,144Z' },
  "diamond": { file: 'diamond', group: 'classic', de: "Karo", d: 'M240,128a15.85,15.85,0,0,1-4.67,11.28l-96.05,96.06a16,16,0,0,1-22.56,0h0l-96-96.06a16,16,0,0,1,0-22.56l96.05-96.06a16,16,0,0,1,22.56,0l96.05,96.06A15.85,15.85,0,0,1,240,128Z' },
  "crown": { file: 'crown', group: 'classic', de: "Krone", d: 'M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z' },
  "crown-simple": { file: 'crown-simple', group: 'classic', de: "Krone schlicht", d: 'M239.75,90.81c0,.11,0,.21-.07.32L217,195a16,16,0,0,1-15.72,13H54.71A16,16,0,0,1,39,195L16.32,91.13c0-.11-.05-.21-.07-.32A16,16,0,0,1,44,77.39l33.67,36.29,35.8-80.29a1,1,0,0,0,0-.1,16,16,0,0,1,29.06,0,1,1,0,0,0,0,.1l35.8,80.29L212,77.39a16,16,0,0,1,27.71,13.42Z' },
  "gem": { file: 'sketch-logo', group: 'classic', de: "Diamant", d: 'M246,98.73l-56-64A8,8,0,0,0,184,32H72a8,8,0,0,0-6,2.73l-56,64a8,8,0,0,0,.17,10.73l112,120a8,8,0,0,0,11.7,0l112-120A8,8,0,0,0,246,98.73ZM222.37,96H180L144,48h36.37ZM74.58,112l30.13,75.33L34.41,112Zm106.84,0h40.17l-70.3,75.33ZM75.63,48H112L76,96H33.63Z' },
  "shield": { file: 'shield', group: 'classic', de: "Wappenschild", d: 'M224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Z' },
  "euro": { file: 'currency-eur', group: 'classic', de: "Euro", d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,80a8,8,0,0,1,0,16H88v16h24a8,8,0,0,1,0,16H88.81a40,40,0,0,0,65.86,21.82,8,8,0,1,1,10.66,11.92A56,56,0,0,1,72.58,152H64a8,8,0,0,1,0-16h8V120H64a8,8,0,0,1,0-16h8.58a56,56,0,0,1,92.75-33.74,8,8,0,1,1-10.66,11.92A40,40,0,0,0,88.81,104Z' },
  "dollar": { file: 'currency-dollar', group: 'classic', de: "Dollar", d: 'M160,152a16,16,0,0,1-16,16h-8V136h8A16,16,0,0,1,160,152Zm72-24A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-56,24a32,32,0,0,0-32-32h-8V88h4a16,16,0,0,1,16,16,8,8,0,0,0,16,0,32,32,0,0,0-32-32h-4V64a8,8,0,0,0-16,0v8h-4a32,32,0,0,0,0,64h4v32h-8a16,16,0,0,1-16-16,8,8,0,0,0-16,0,32,32,0,0,0,32,32h8v8a8,8,0,0,0,16,0v-8h8A32,32,0,0,0,176,152Zm-76-48a16,16,0,0,0,16,16h4V88h-4A16,16,0,0,0,100,104Z' },
  "lightning": { file: 'lightning', group: 'classic', de: "Blitz", d: 'M213.85,125.46l-112,120a8,8,0,0,1-13.69-7l14.66-73.33L45.19,143.49a8,8,0,0,1-3-13l112-120a8,8,0,0,1,13.69,7L153.18,90.9l57.63,21.61a8,8,0,0,1,3,12.95Z' },
  "anchor": { file: 'anchor', group: 'classic', de: "Anker", d: 'M224,144c0,38.11-27.67,45.66-49.9,51.72C149.77,202.36,136,207.31,136,232a8,8,0,0,1-16,0c0-24.69-13.77-29.64-38.1-36.28C59.67,189.66,32,182.11,32,144a8,8,0,0,1,16,0c0,24.69,13.77,29.64,38.1,36.28,11.36,3.1,24.12,6.6,33.9,14.34V128H88a8,8,0,0,1,0-16h32V82.83a28,28,0,1,1,16,0V112h32a8,8,0,0,1,0,16H136v66.62c9.78-7.74,22.54-11.24,33.9-14.34C194.23,173.64,208,168.69,208,144a8,8,0,0,1,16,0Z' },
  "airplane": { file: 'airplane', group: 'classic', de: "Flugzeug", d: 'M240,136v32a8,8,0,0,1-8,8,7.61,7.61,0,0,1-1.57-.16L156,161v23.73l17.66,17.65A8,8,0,0,1,176,208v24a8,8,0,0,1-11,7.43l-37-14.81L91,239.43A8,8,0,0,1,80,232V208a8,8,0,0,1,2.34-5.66L100,184.69V161L25.57,175.84A7.61,7.61,0,0,1,24,176a8,8,0,0,1-8-8V136a8,8,0,0,1,4.42-7.16L100,89.06V44a28,28,0,0,1,56,0V89.06l79.58,39.78A8,8,0,0,1,240,136Z' },
  "rocket": { file: 'rocket', group: 'classic', de: "Rakete", d: 'M152,224a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,224Zm71.62-68.17-12.36,55.63a16,16,0,0,1-25.51,9.11L158.51,200h-61L70.25,220.57a16,16,0,0,1-25.51-9.11L32.38,155.83a16.09,16.09,0,0,1,3.32-13.71l28.56-34.26a123.07,123.07,0,0,1,8.57-36.67c12.9-32.34,36-52.63,45.37-59.85a16,16,0,0,1,19.6,0c9.34,7.22,32.47,27.51,45.37,59.85a123.07,123.07,0,0,1,8.57,36.67l28.56,34.26A16.09,16.09,0,0,1,223.62,155.83Zm-139.23,34Q68.28,160.5,64.83,132.16L48,152.36,60.36,208l.18-.13ZM140,100a12,12,0,1,0-12,12A12,12,0,0,0,140,100Zm68,52.36-16.83-20.2q-3.42,28.28-19.56,57.69l23.85,18,.18.13Z' },
  "golf": { file: 'golf', group: 'golf', de: "Golfball auf Tee", d: 'M175.47,197.14a8,8,0,0,1-4.61,10.33A125.91,125.91,0,0,1,136,215.68V248a8,8,0,0,1-16,0V215.68a125.91,125.91,0,0,1-34.86-8.21,8,8,0,1,1,5.72-14.94C104,197.56,116.15,200,128,200s24-2.44,37.14-7.47A8,8,0,0,1,175.47,197.14ZM216,96A88,88,0,1,1,128,8,88.1,88.1,0,0,1,216,96Zm-72,36a12,12,0,1,0-12,12A12,12,0,0,0,144,132Zm32-32a12,12,0,1,0-12,12A12,12,0,0,0,176,100Z' },
  "flag": { file: 'flag', group: 'golf', de: "Fahne", d: 'M232,56V176a8,8,0,0,1-2.76,6c-15.28,13.23-29.89,18-43.82,18-18.91,0-36.57-8.74-53-16.85C105.87,170,82.79,158.61,56,179.77V224a8,8,0,0,1-16,0V56a8,8,0,0,1,2.77-6h0c36-31.18,68.31-15.21,96.79-1.12C167,62.46,190.79,74.2,218.76,50A8,8,0,0,1,232,56Z' },
  "pennant": { file: 'flag-pennant', group: 'golf', de: "Wimpel", d: 'M248,104a8,8,0,0,1-5.37,7.56L64,173.69V216a8,8,0,0,1-16,0V40a8,8,0,0,1,10.63-7.56l184,64A8,8,0,0,1,248,104Z' },
  "flag-checkered": { file: 'flag-checkered', group: 'golf', de: "Zielflagge", d: 'M227.32,48.75A8,8,0,0,0,218.76,50c-28,24.22-51.72,12.48-79.21-1.13C111.07,34.76,78.78,18.79,42.76,50h0A8,8,0,0,0,40,56V224a8,8,0,0,0,16,0V179.77c26.79-21.16,49.87-9.75,76.45,3.41,16.4,8.11,34.06,16.85,53,16.85,13.93,0,28.54-4.75,43.82-18a8,8,0,0,0,2.76-6V56A8,8,0,0,0,227.32,48.75ZM56,160.44V109.88c16.85-11.28,32.64-11.59,48-7.34v51.74C88.87,150.47,72.87,150.71,56,160.44ZM104,50.87c9.25,2.83,18.61,7.45,28.45,12.32,11.26,5.57,23.11,11.43,35.55,14.56v51.74c15.35,4.25,31.14,3.94,48-7.35v50.11c-16.87,13.32-32.27,13.72-48,8.91V129.49c-21.62-6-42.38-21-64-26.95Z' },
  "trophy": { file: 'trophy', group: 'golf', de: "Pokal", d: 'M232,64H208V48a8,8,0,0,0-8-8H56a8,8,0,0,0-8,8V64H24A16,16,0,0,0,8,80V96a40,40,0,0,0,40,40h3.65A80.13,80.13,0,0,0,120,191.61V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.58c31.94-3.23,58.44-25.64,68.08-55.58H208a40,40,0,0,0,40-40V80A16,16,0,0,0,232,64ZM48,120A24,24,0,0,1,24,96V80H48v32q0,4,.39,8ZM232,96a24,24,0,0,1-24,24h-.5a81.81,81.81,0,0,0,.5-8.9V80h24Z' },
  "medal": { file: 'medal', group: 'golf', de: "Medaille", d: 'M216,96A88,88,0,1,0,72,163.83V240a8,8,0,0,0,11.58,7.16L128,225l44.43,22.21A8.07,8.07,0,0,0,176,248a8,8,0,0,0,8-8V163.83A87.85,87.85,0,0,0,216,96ZM56,96a72,72,0,1,1,72,72A72.08,72.08,0,0,1,56,96Zm16,0a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z' },
  "target": { file: 'target', group: 'golf', de: "Zielscheibe", d: 'M221.87,83.16A104.1,104.1,0,1,1,195.67,49l22.67-22.68a8,8,0,0,1,11.32,11.32L167.6,99.71h0l-37.71,37.71-23.95,23.95a40,40,0,0,0,62-35.67,8,8,0,1,1,16-.9,56,56,0,0,1-95.5,42.79h0a56,56,0,0,1,73.13-84.43L184.3,60.39a87.88,87.88,0,1,0,23.13,29.67,8,8,0,0,1,14.44-6.9Z' },
  "timer": { file: 'timer', group: 'golf', de: "Stoppuhr", d: 'M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm45.66,61.66-40,40a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,11.32ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z' },
  "soccer-ball": { file: 'soccer-ball', group: 'golf', de: "Fußball", d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm8,39.38,24.79-17.05a88.41,88.41,0,0,1,36.18,27l-8,26.94c-.2,0-.41.1-.61.17l-22.82,7.41a7.59,7.59,0,0,0-1,.4L136,88.62c0-.2,0-.41,0-.62V64C136,63.79,136,63.58,136,63.38ZM95.24,46.33,120,63.38c0,.2,0,.41,0,.62V88c0,.21,0,.42,0,.62L91.44,108.29a7.59,7.59,0,0,0-1-.4l-22.82-7.41c-.2-.07-.41-.12-.61-.17l-8-26.94A88.41,88.41,0,0,1,95.24,46.33Zm-13,129.09H53.9a87.4,87.4,0,0,1-13.79-43.07l22-16.88a5.77,5.77,0,0,0,.58.22l22.83,7.42a7.83,7.83,0,0,0,.93.22l10.79,31.42c-.15.18-.3.36-.44.55L82.7,174.71A7.8,7.8,0,0,0,82.24,175.42ZM150.69,213a88.16,88.16,0,0,1-45.38,0L95.25,184.6c.13-.16.27-.31.39-.48l14.11-19.42a7.66,7.66,0,0,0,.46-.7h35.58a7.66,7.66,0,0,0,.46.7l14.11,19.42c.12.17.26.32.39.48Zm23.07-37.61a7.8,7.8,0,0,0-.46-.71L159.19,155.3c-.14-.19-.29-.37-.44-.55l10.79-31.42a7.83,7.83,0,0,0,.93-.22l22.83-7.42a5.77,5.77,0,0,0,.58-.22l22,16.88a87.4,87.4,0,0,1-13.79,43.07Z' },
  "tennis-ball": { file: 'tennis-ball', group: 'golf', de: "Tennisball", d: 'M24.81,115.41a103.9,103.9,0,0,1,90.6-90.65,4,4,0,0,1,4.47,3.79,87.82,87.82,0,0,1-91.27,91.33A4,4,0,0,1,24.81,115.41Zm202.54,20.7c-1.12,0-2.23-.07-3.35-.07a87.84,87.84,0,0,0-87.88,91.41,4,4,0,0,0,4.47,3.79,103.9,103.9,0,0,0,90.6-90.66A4,4,0,0,0,227.35,136.11Zm-76.89,14.35A103.33,103.33,0,0,1,224,120c1,0,2.06,0,3.09,0a4,4,0,0,0,4.12-4.43,103.91,103.91,0,0,0-90.88-90.89,4,4,0,0,0-4.43,4.12,103.72,103.72,0,0,1-30.36,76.7A103.33,103.33,0,0,1,32,136c-1,0-2.06,0-3.09,0a4,4,0,0,0-4.12,4.43,103.91,103.91,0,0,0,90.88,90.89,4,4,0,0,0,4.43-4.12A103.72,103.72,0,0,1,150.46,150.46Z' },
  "basketball": { file: 'basketball', group: 'golf', de: "Basketball", d: 'M63.6,46.39a103.48,103.48,0,0,1,52-21.65,4,4,0,0,1,4.45,4V120H95.7A103.77,103.77,0,0,0,63.38,52.44,4,4,0,0,1,63.6,46.39ZM46,64.07a103.51,103.51,0,0,0-21.29,51.46,4,4,0,0,0,4,4.47H79.63A87.86,87.86,0,0,0,51.89,63.59,4,4,0,0,0,46,64.07ZM192.4,46.39a103.48,103.48,0,0,0-52-21.65,4,4,0,0,0-4.45,4V120h24.3a103.77,103.77,0,0,1,32.32-67.56A4,4,0,0,0,192.4,46.39Zm38.86,69.14A103.51,103.51,0,0,0,210,64.07a4,4,0,0,0-5.86-.48A87.86,87.86,0,0,0,176.37,120h50.91A4,4,0,0,0,231.26,115.53ZM24.74,140.47A103.51,103.51,0,0,0,46,191.93a4,4,0,0,0,5.86.48A87.86,87.86,0,0,0,79.63,136H28.72A4,4,0,0,0,24.74,140.47ZM210,191.93a103.51,103.51,0,0,0,21.29-51.46,4,4,0,0,0-4-4.47H176.37a87.86,87.86,0,0,0,27.74,56.41A4,4,0,0,0,210,191.93ZM63.6,209.61a103.48,103.48,0,0,0,52,21.65,4,4,0,0,0,4.45-4V136H95.7a103.77,103.77,0,0,1-32.32,67.56A4,4,0,0,0,63.6,209.61ZM160.3,136H136v91.28a4,4,0,0,0,4.45,4,103.48,103.48,0,0,0,52-21.65,4,4,0,0,0,.22-6.05A103.77,103.77,0,0,1,160.3,136Z' },
  "bicycle": { file: 'bicycle', group: 'golf', de: "Fahrrad", d: 'M54.46,164.71,82.33,126.5a48,48,0,1,1-12.92-9.44L41.54,155.29a8,8,0,1,0,12.92,9.42ZM208,112a47.81,47.81,0,0,0-16.93,3.09L214.91,156A8,8,0,1,1,201.09,164l-23.83-40.86A48,48,0,1,0,208,112ZM165.93,72H192a8,8,0,0,1,8,8,8,8,0,0,0,16,0,24,24,0,0,0-24-24H152a8,8,0,0,0-6.91,12l11.65,20H99.26L82.91,60A8,8,0,0,0,76,56H48a8,8,0,0,0,0,16H71.41L85.12,95.51,69.41,117.06a47.87,47.87,0,0,1,12.92,9.44l11.59-15.9L125.09,164A8,8,0,1,0,138.91,156l-30.32-52h57.48l11.19,19.17a48.11,48.11,0,0,1,13.81-8.08Z' },
  "sailboat": { file: 'sailboat', group: 'golf', de: "Segelboot", d: 'M160,140V72.85a4,4,0,0,1,7-2.69l55,60.46a8,8,0,0,1,.43,10.26,8.24,8.24,0,0,1-6.58,3.12H164A4,4,0,0,1,160,140Zm87.21,32.53A8,8,0,0,0,240,168H144V8a8,8,0,0,0-14.21-5l-104,128A8,8,0,0,0,32,144h96v24H16a8,8,0,0,0-6.25,13l29.6,37a15.93,15.93,0,0,0,12.49,6H204.16a15.93,15.93,0,0,0,12.49-6l29.6-37A8,8,0,0,0,247.21,172.53Z' },
  "barbell": { file: 'barbell', group: 'golf', de: "Hantel", d: 'M200,64V192a16,16,0,0,1-16,16H168a16,16,0,0,1-16-16V136H104v56a16,16,0,0,1-16,16H72a16,16,0,0,1-16-16V64A16,16,0,0,1,72,48H88a16,16,0,0,1,16,16v56h48V64a16,16,0,0,1,16-16h16A16,16,0,0,1,200,64ZM36,72H32A16,16,0,0,0,16,88v32H8.27A8.18,8.18,0,0,0,0,127.47,8,8,0,0,0,8,136h8v32a16,16,0,0,0,16,16h4a4,4,0,0,0,4-4V76A4,4,0,0,0,36,72Zm220,55.47a8.18,8.18,0,0,0-8.25-7.47H240V88a16,16,0,0,0-16-16h-4a4,4,0,0,0-4,4V180a4,4,0,0,0,4,4h4a16,16,0,0,0,16-16V136h8A8,8,0,0,0,256,127.47Z' },
  "person-simple-run": { file: 'person-simple-run', group: 'golf', de: "Läufer", d: 'M120,56a32,32,0,1,1,32,32A32,32,0,0,1,120,56Zm103.28,74.08a8,8,0,0,0-10.6-4c-.25.12-26.71,10.72-72.18-20.19-52.29-35.54-88-7.77-89.51-6.57a8,8,0,1,0,10,12.48c.26-.21,25.12-19.5,64.07,3.27-4.25,13.35-12.76,31.82-25.25,47-18.56,22.48-41.11,32.56-67,30A8,8,0,0,0,31.2,208a92.29,92.29,0,0,0,9.34.47c27.38,0,52-12.38,71.63-36.18.57-.69,1.14-1.4,1.69-2.1C133.31,175.29,168,190.3,168,232a8,8,0,0,0,16,0c0-24.65-10.08-45.35-29.15-59.86a104.29,104.29,0,0,0-31.31-15.81A169.31,169.31,0,0,0,139,124c26.14,16.09,46.84,20,60.69,20,12.18,0,19.06-3,19.67-3.28A8,8,0,0,0,223.28,130.08Z' },
  "beer-stein": { file: 'beer-stein', group: 'party', de: "Bierkrug", d: 'M216,88H200V72a40,40,0,0,0-40-40H148.82c-11.91-10.2-28-16-44.82-16C68.71,16,40,41.12,40,72V208a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16v-8h16a24,24,0,0,0,24-24V112A24,24,0,0,0,216,88ZM104,184a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0ZM57,64c4.46-18.24,23.85-32,47-32,13.87,0,27.06,5,36.21,13.78A8,8,0,0,0,145.74,48H160a24,24,0,0,1,22.62,16ZM224,176a8,8,0,0,1-8,8H200V104h16a8,8,0,0,1,8,8Z' },
  "beer-bottle": { file: 'beer-bottle', group: 'party', de: "Bierflasche", d: 'M245.66,42.34l-32-32a8,8,0,0,0-11.32,11.32l1.48,1.47L148.65,64.51l-38.22,7.65a8.05,8.05,0,0,0-4.09,2.18L23,157.66a24,24,0,0,0,0,33.94L64.4,233a24,24,0,0,0,33.94,0l83.32-83.31a8,8,0,0,0,2.18-4.09l7.65-38.22,41.38-55.17,1.47,1.48a8,8,0,0,0,11.32-11.32ZM81.37,224a7.94,7.94,0,0,1-5.65-2.34L34.34,180.28a8,8,0,0,1,0-11.31L40,163.31,92.69,216,87,221.66A8,8,0,0,1,81.37,224ZM177.6,99.2a7.92,7.92,0,0,0-1.44,3.23l-7.53,37.63L160,148.69,107.31,96l8.63-8.63,37.63-7.53a7.92,7.92,0,0,0,3.23-1.44l58.45-43.84,6.19,6.19Z' },
  "wine": { file: 'wine', group: 'party', de: "Weinglas", d: 'M205.33,103.67,183.56,29.74A8,8,0,0,0,175.89,24H80.11a8,8,0,0,0-7.67,5.74L50.67,103.67a63.46,63.46,0,0,0,17.42,64.67A87.41,87.41,0,0,0,120,191.63V232H88a8,8,0,1,0,0,16h80a8,8,0,1,0,0-16H136V191.63a87.39,87.39,0,0,0,51.91-23.29A63.48,63.48,0,0,0,205.33,103.67ZM86.09,40h83.82L190,108.19c.09.3.17.6.25.9-21.42,7.68-45.54-1.6-58.63-8.23C106.43,88.11,86.43,86.49,71.68,88.93Z' },
  "champagne": { file: 'champagne', group: 'party', de: "Sektglas", d: 'M149.91,13.53A8,8,0,0,0,142.3,8H97.71a8,8,0,0,0-7.61,5.53,451,451,0,0,0-14.21,59.7c-7.26,44.25-4.35,75.76,8.65,93.66A40,40,0,0,0,112,183.42V232H96a8,8,0,1,0,0,16h48a8,8,0,0,0,0-16H128V183.42a39.94,39.94,0,0,0,27.46-16.53c13-17.9,15.92-49.41,8.66-93.66A451,451,0,0,0,149.91,13.53ZM93.8,64c3-15.58,6.73-29.81,9.79-40h32.83c3.06,10.19,6.77,24.42,9.8,40ZM232,52a12,12,0,1,1-12-12A12,12,0,0,1,232,52ZM184,20a12,12,0,1,1,12,12A12,12,0,0,1,184,20Zm24,80a12,12,0,1,1-12-12A12,12,0,0,1,208,100Z' },
  "martini": { file: 'martini', group: 'party', de: "Cocktail", d: 'M237.66,45.66A8,8,0,0,0,232,32H24a8,8,0,0,0-5.66,13.66L120,147.31V208H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V147.31Zm-25,2.34-16,16H59.31l-16-16Z' },
  "cake": { file: 'cake', group: 'party', de: "Torte", d: 'M208,88H136V79a32.06,32.06,0,0,0,24-31c0-28-26.44-45.91-27.56-46.66a8,8,0,0,0-8.88,0C122.44,2.09,96,20,96,48a32.06,32.06,0,0,0,24,31v9H48a24,24,0,0,0-24,24v23.33a40.84,40.84,0,0,0,8,24.24V200a24,24,0,0,0,24,24H200a24,24,0,0,0,24-24V159.57a40.84,40.84,0,0,0,8-24.24V112A24,24,0,0,0,208,88ZM112,48c0-13.57,10-24.46,16-29.79,6,5.33,16,16.22,16,29.79a16,16,0,0,1-32,0Zm104,87.33c0,13.25-10.46,24.31-23.32,24.66A24,24,0,0,1,168,136a8,8,0,0,0-16,0,24,24,0,0,1-48,0,8,8,0,0,0-16,0,24,24,0,0,1-24.68,24C50.46,159.64,40,148.58,40,135.33V112a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8Z' },
  "gift": { file: 'gift', group: 'party', de: "Geschenk", d: 'M216,72H180.92c.39-.33.79-.65,1.17-1A29.53,29.53,0,0,0,192,49.57,32.62,32.62,0,0,0,158.44,16,29.53,29.53,0,0,0,137,25.91a54.94,54.94,0,0,0-9,14.48,54.94,54.94,0,0,0-9-14.48A29.53,29.53,0,0,0,97.56,16,32.62,32.62,0,0,0,64,49.57,29.53,29.53,0,0,0,73.91,71c.38.33.78.65,1.17,1H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16h60a4,4,0,0,0,4-4V120H40V88h80v32h16V88h80v32H136v92a4,4,0,0,0,4,4h60a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM84.51,59a13.69,13.69,0,0,1-4.5-10A16.62,16.62,0,0,1,96.59,32h.49a13.69,13.69,0,0,1,10,4.5c8.39,9.48,11.35,25.2,12.39,34.92C109.71,70.39,94,67.43,84.51,59Zm87,0c-9.49,8.4-25.24,11.36-35,12.4C137.7,60.89,141,45.5,149,36.51a13.69,13.69,0,0,1,10-4.5h.49A16.62,16.62,0,0,1,176,49.08,13.69,13.69,0,0,1,171.49,59Z' },
  "confetti": { file: 'confetti', group: 'party', de: "Konfetti", d: 'M111.49,52.63a15.8,15.8,0,0,0-26,5.77L33,202.78A15.83,15.83,0,0,0,47.76,224a16,16,0,0,0,5.46-1l144.37-52.5a15.8,15.8,0,0,0,5.78-26ZM65.14,161.13l19.2-52.79,63.32,63.32-52.8,19.2ZM160,72a37.8,37.8,0,0,1,3.84-15.58C169.14,45.83,179.14,40,192,40c6.7,0,11-2.29,13.65-7.21A22,22,0,0,0,208,23.94,8,8,0,0,1,224,24c0,12.86-8.52,32-32,32-6.7,0-11,2.29-13.65,7.21A22,22,0,0,0,176,72.06,8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.66,82.34a8,8,0,1,1-11.32,11.31l-16-16a8,8,0,0,1,11.32-11.32Zm4.87-42.75-24,8a8,8,0,0,1-5.06-15.18l24-8a8,8,0,0,1,5.06,15.18Z' },
  "balloon": { file: 'balloon', group: 'party', de: "Luftballon", d: 'M128,16a88.1,88.1,0,0,0-88,88c0,23.43,9.4,49.42,25.13,69.5,12.08,15.41,26.5,26,41.91,31.09L96.65,228.85A8,8,0,0,0,104,240h48a8,8,0,0,0,7.35-11.15L149,204.59c15.4-5.07,29.83-15.68,41.91-31.09C206.6,153.42,216,127.43,216,104A88.1,88.1,0,0,0,128,16Zm49.32,87.89A8.52,8.52,0,0,1,176,104a8,8,0,0,1-7.88-6.68,41.29,41.29,0,0,0-33.43-33.43,8,8,0,1,1,2.64-15.78,57.5,57.5,0,0,1,46.57,46.57A8,8,0,0,1,177.32,103.89Z' },
  "smiley": { file: 'smiley', group: 'party', de: "Smiley", d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm82.92,60c-10.29,17.79-27.39,28-46.92,28s-36.63-10.2-46.92-28a8,8,0,1,1,13.84-8c7.47,12.91,19.21,20,33.08,20s25.61-7.1,33.08-20a8,8,0,1,1,13.84,8ZM164,120a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z' },
  "handshake": { file: 'handshake', group: 'party', de: "Handschlag", d: 'M254.3,107.91,228.78,56.85a16,16,0,0,0-21.47-7.15L182.44,62.13,130.05,48.27a8.14,8.14,0,0,0-4.1,0L73.56,62.13,48.69,49.7a16,16,0,0,0-21.47,7.15L1.7,107.9a16,16,0,0,0,7.15,21.47l27,13.51,55.49,39.63a8.06,8.06,0,0,0,2.71,1.25l64,16a8,8,0,0,0,7.6-2.1l40-40,15.08-15.08,26.42-13.21a16,16,0,0,0,7.15-21.46Zm-54.89,33.37L165,113.72a8,8,0,0,0-10.68.61C136.51,132.27,116.66,130,104,122L147.24,80h31.81l27.21,54.41Zm-41.87,41.86L99.42,168.61l-49.2-35.14,28-56L128,64.28l9.8,2.59-45,43.68-.08.09a16,16,0,0,0,2.72,24.81c20.56,13.13,45.37,11,64.91-5L188,152.66Zm-25.72,34.8a8,8,0,0,1-7.75,6.06,8.13,8.13,0,0,1-1.95-.24L80.41,213.33a7.89,7.89,0,0,1-2.71-1.25L51.35,193.26a8,8,0,0,1,9.3-13l25.11,17.94L126,208.24A8,8,0,0,1,131.82,217.94Z' },
  "music-notes": { file: 'music-notes', group: 'party', de: "Noten", d: 'M212.92,17.71a7.89,7.89,0,0,0-6.86-1.46l-128,32A8,8,0,0,0,72,56V166.1A36,36,0,1,0,88,196V102.25l112-28V134.1A36,36,0,1,0,216,164V24A8,8,0,0,0,212.92,17.71Z' },
  "fire": { file: 'fire', group: 'party', de: "Flamme", d: 'M143.38,17.85a8,8,0,0,0-12.63,3.41l-22,60.41L84.59,58.26a8,8,0,0,0-11.93.89C51,87.53,40,116.08,40,144a88,88,0,0,0,176,0C216,84.55,165.21,36,143.38,17.85Zm40.51,135.49a57.6,57.6,0,0,1-46.56,46.55A7.65,7.65,0,0,1,136,200a8,8,0,0,1-1.32-15.89c16.57-2.79,30.63-16.85,33.44-33.45a8,8,0,0,1,15.78,2.68Z' },
  "sparkle": { file: 'sparkle', group: 'party', de: "Funkeln", d: 'M208,144a15.78,15.78,0,0,1-10.42,14.94L146,178l-19,51.62a15.92,15.92,0,0,1-29.88,0L78,178l-51.62-19a15.92,15.92,0,0,1,0-29.88L78,110l19-51.62a15.92,15.92,0,0,1,29.88,0L146,110l51.62,19A15.78,15.78,0,0,1,208,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z' },
  "mountains": { file: 'mountains', group: 'nature', de: "Berg", d: 'M254.88,195.92l-54.56-92.08A15.87,15.87,0,0,0,186.55,96h0a15.85,15.85,0,0,0-13.76,7.84l-15.64,26.39a4,4,0,0,0,0,4.07l26.8,45.47a8.13,8.13,0,0,1-1.89,10.55,8,8,0,0,1-11.8-2.26L101.79,71.88a16,16,0,0,0-27.58,0L1.11,195.94a8,8,0,0,0,1,9.52A8.23,8.23,0,0,0,8.23,208H247.77a8.29,8.29,0,0,0,6.09-2.55A8,8,0,0,0,254.88,195.92ZM64.43,120,88,80l23.57,40ZM140,52a24,24,0,1,1,24,24A24,24,0,0,1,140,52Z' },
  "tree": { file: 'tree', group: 'nature', de: "Laubbaum", d: 'M128,187.85a72.44,72.44,0,0,0,8,4.62V232a8,8,0,0,1-16,0V192.47A72.44,72.44,0,0,0,128,187.85ZM198.1,62.59a76,76,0,0,0-140.2,0A71.71,71.71,0,0,0,16,127.8C15.9,166,48,199,86.14,200A72.22,72.22,0,0,0,120,192.47V156.94L76.42,135.16a8,8,0,1,1,7.16-14.32L120,139.06V88a8,8,0,0,1,16,0v27.06l36.42-18.22a8,8,0,1,1,7.16,14.32L136,132.94v59.53A72.17,72.17,0,0,0,168,200l1.82,0C208,199,240.11,166,240,127.8A71.71,71.71,0,0,0,198.1,62.59Z' },
  "tree-evergreen": { file: 'tree-evergreen', group: 'nature', de: "Tanne", d: 'M231.19,195.51A8,8,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a8,8,0,0,1-6.31-12.91l46-59.09H48a8,8,0,0,1-6.34-12.88l80-104a8,8,0,0,1,12.68,0l80,104A8,8,0,0,1,208,128H184.36l45.95,59.09A8,8,0,0,1,231.19,195.51Z' },
  "leaf": { file: 'leaf', group: 'nature', de: "Blatt", d: 'M223.45,40.07a8,8,0,0,0-7.52-7.52C139.8,28.08,78.82,51,52.82,94a87.09,87.09,0,0,0-12.76,49A101.72,101.72,0,0,0,46.7,175.2a4,4,0,0,0,6.61,1.43l85-86.3a8,8,0,0,1,11.32,11.32L56.74,195.94,42.55,210.13a8.2,8.2,0,0,0-.6,11.1,8,8,0,0,0,11.71.43l16.79-16.79c14.14,6.84,28.41,10.57,42.56,11.07q1.67.06,3.33.06A86.93,86.93,0,0,0,162,203.18C205,177.18,227.93,116.21,223.45,40.07Z' },
  "plant": { file: 'plant', group: 'nature', de: "Keimling", d: 'M205.41,159.07a60.9,60.9,0,0,1-31.83,8.86,71.71,71.71,0,0,1-27.36-5.66A55.55,55.55,0,0,0,136,194.51V224a8,8,0,0,1-8.53,8,8.18,8.18,0,0,1-7.47-8.25V211.31L81.38,172.69A52.5,52.5,0,0,1,63.44,176a45.82,45.82,0,0,1-23.92-6.67C17.73,156.09,6,125.62,8.27,87.79a8,8,0,0,1,7.52-7.52c37.83-2.23,68.3,9.46,81.5,31.25A46,46,0,0,1,103.74,140a4,4,0,0,1-6.89,2.43l-19.2-20.1a8,8,0,0,0-11.31,11.31l53.88,55.25c.06-.78.13-1.56.21-2.33a68.56,68.56,0,0,1,18.64-39.46l50.59-53.46a8,8,0,0,0-11.31-11.32l-49,51.82a4,4,0,0,1-6.78-1.74c-4.74-17.48-2.65-34.88,6.4-49.82,17.86-29.48,59.42-45.26,111.18-42.22a8,8,0,0,1,7.52,7.52C250.67,99.65,234.89,141.21,205.41,159.07Z' },
  "flower": { file: 'flower', group: 'nature', de: "Blume", d: 'M210.35,129.36c-.81-.47-1.7-.92-2.62-1.36.92-.44,1.81-.89,2.62-1.36a40,40,0,1,0-40-69.28c-.81.47-1.65,1-2.48,1.59.08-1,.13-2,.13-3a40,40,0,0,0-80,0c0,.94,0,1.94.13,3-.83-.57-1.67-1.12-2.48-1.59a40,40,0,1,0-40,69.28c.81.47,1.7.92,2.62,1.36-.92.44-1.81.89-2.62,1.36a40,40,0,1,0,40,69.28c.81-.47,1.65-1,2.48-1.59-.08,1-.13,2-.13,2.95a40,40,0,0,0,80,0c0-.94-.05-1.94-.13-2.95.83.57,1.67,1.12,2.48,1.59A39.79,39.79,0,0,0,190.29,204a40.43,40.43,0,0,0,10.42-1.38,40,40,0,0,0,9.64-73.28ZM128,156a28,28,0,1,1,28-28A28,28,0,0,1,128,156Z' },
  "flower-tulip": { file: 'flower-tulip', group: 'nature', de: "Tulpe", d: 'M208,48a87.48,87.48,0,0,0-35.36,7.43c-15.1-25.37-39.92-38-41.06-38.59a8,8,0,0,0-7.16,0c-1.14.58-26,13.22-41.06,38.59A87.48,87.48,0,0,0,48,48a8,8,0,0,0-8,8V96a88.11,88.11,0,0,0,80,87.63v35.43L83.58,200.84a8,8,0,1,0-7.16,14.32l48,24a8,8,0,0,0,7.16,0l48-24a8,8,0,0,0-7.16-14.32L136,219.06V183.63A88.11,88.11,0,0,0,216,96V56A8,8,0,0,0,208,48ZM56,96V64.44A72.1,72.1,0,0,1,120,136v31.56A72.1,72.1,0,0,1,56,96Zm144,0a72.1,72.1,0,0,1-64,71.56V136a72.1,72.1,0,0,1,64-71.56Z' },
  "cactus": { file: 'cactus', group: 'nature', de: "Kaktus", d: 'M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H88V136H80A64.07,64.07,0,0,1,16,72,24.07,24.07,0,0,1,40.08,48h.4A23.55,23.55,0,0,1,64,71.52V72h0A16,16,0,0,0,80,88h8V56a40,40,0,0,1,80,0v72h8a16,16,0,0,0,16-16h0v-.48A23.55,23.55,0,0,1,215.52,88h.4A24.07,24.07,0,0,1,240,112a64.07,64.07,0,0,1-64,64h-8v32h48A8,8,0,0,1,224,216Z' },
  "sun": { file: 'sun', group: 'nature', de: "Sonne", d: 'M120,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm8,24a64,64,0,1,0,64,64A64.07,64.07,0,0,0,128,64ZM58.34,69.66A8,8,0,0,0,69.66,58.34l-16-16A8,8,0,0,0,42.34,53.66Zm0,116.68-16,16a8,8,0,0,0,11.32,11.32l16-16a8,8,0,0,0-11.32-11.32ZM192,72a8,8,0,0,0,5.66-2.34l16-16a8,8,0,0,0-11.32-11.32l-16,16A8,8,0,0,0,192,72Zm5.66,114.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32-11.32ZM48,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H40A8,8,0,0,0,48,128Zm80,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V216A8,8,0,0,0,128,208Zm112-88H216a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z' },
  "moon": { file: 'moon', group: 'nature', de: "Mond", d: 'M235.54,150.21a104.84,104.84,0,0,1-37,52.91A104,104,0,0,1,32,120,103.09,103.09,0,0,1,52.88,57.48a104.84,104.84,0,0,1,52.91-37,8,8,0,0,1,10,10,88.08,88.08,0,0,0,109.8,109.8,8,8,0,0,1,10,10Z' },
  "snowflake": { file: 'snowflake', group: 'nature', de: "Schneeflocke", d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm42.37,119.22,18.94-6.76a8,8,0,1,1,5.38,15.08l-15.48,5.52,4.52,16.87a8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,176,184a8,8,0,0,1-7.73-5.93l-5.57-20.8L136,141.86v30.83l13.66,13.65a8,8,0,0,1-11.32,11.32L128,187.31l-10.34,10.35a8,8,0,0,1-11.32-11.32L120,172.69V141.86L93.3,157.27l-5.57,20.8A8,8,0,0,1,80,184a8.23,8.23,0,0,1-2.07-.27,8,8,0,0,1-5.66-9.8l4.52-16.87-15.48-5.52a8,8,0,0,1,5.38-15.08l18.94,6.76L112,128,85.63,112.78l-18.94,6.76A8.18,8.18,0,0,1,64,120a8,8,0,0,1-2.69-15.54l15.48-5.52L72.27,82.07a8,8,0,0,1,15.46-4.14l5.57,20.8L120,114.14V83.31L106.34,69.66a8,8,0,0,1,11.32-11.32L128,68.69l10.34-10.35a8,8,0,0,1,11.32,11.32L136,83.31v30.83l26.7-15.41,5.57-20.8a8,8,0,0,1,15.46,4.14l-4.52,16.87,15.48,5.52A8,8,0,0,1,192,120a8.18,8.18,0,0,1-2.69-.46l-18.94-6.76L144,128Z' },
  "paw-print": { file: 'paw-print', group: 'nature', de: "Pfote", d: 'M240,108a28,28,0,1,1-28-28A28,28,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28,28,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28,28,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28,28,0,0,0,164,88Zm23.12,60.86a35.3,35.3,0,0,1-16.87-21.14,44,44,0,0,0-84.5,0A35.25,35.25,0,0,1,69,148.82,40,40,0,0,0,88,224a39.48,39.48,0,0,0,15.52-3.13,64.09,64.09,0,0,1,48.87,0,40,40,0,0,0,34.73-72Z' },
  "dog": { file: 'dog', group: 'nature', de: "Hund", d: 'M239.71,125l-16.42-88a16,16,0,0,0-19.61-12.58l-.31.09L150.85,40h-45.7L52.63,24.56l-.31-.09A16,16,0,0,0,32.71,37.05L16.29,125a15.77,15.77,0,0,0,9.12,17.52A16.26,16.26,0,0,0,32.12,144,15.48,15.48,0,0,0,40,141.84V184a40,40,0,0,0,40,40h96a40,40,0,0,0,40-40V141.85a15.5,15.5,0,0,0,7.87,2.16,16.31,16.31,0,0,0,6.72-1.47A15.77,15.77,0,0,0,239.71,125ZM176,208H136V195.31l13.66-13.65a8,8,0,0,0-11.32-11.32L128,180.69l-10.34-10.35a8,8,0,0,0-11.32,11.32L120,195.31V208H80a24,24,0,0,1-24-24V123.11L107.93,56h40.14L200,123.11V184A24,24,0,0,1,176,208Zm-72-68a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm72,0a12,12,0,1,1-12-12A12,12,0,0,1,176,140Z' },
  "cat": { file: 'cat', group: 'nature', de: "Katze", d: 'M222.83,33.54a16,16,0,0,0-18.14,3.15c-.14.14-.26.27-.38.41L187.05,57A111.28,111.28,0,0,0,69,57L51.69,37.1c-.12-.14-.24-.27-.38-.41a16,16,0,0,0-18.14-3.15A16.4,16.4,0,0,0,24,48.46V136c0,49,40.06,89.63,91.56,95.32a4,4,0,0,0,4.44-4v-32l-13.42-13.43a8.22,8.22,0,0,1-.41-11.37,8,8,0,0,1,11.49-.18L128,180.68l10.34-10.35a8,8,0,0,1,11.49.18,8.22,8.22,0,0,1-.41,11.37L136,195.31v32a4,4,0,0,0,4.44,4C191.94,225.62,232,185,232,136V48.46A16.4,16.4,0,0,0,222.83,33.54ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,1,1-16,0V69a8,8,0,0,1,16,0Zm32,0a8,8,0,1,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69a8,8,0,0,1,16,0V88a8,8,0,1,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z' },
  "horse": { file: 'horse', group: 'nature', de: "Pferd", d: 'M202.05,55A103.24,103.24,0,0,0,128,24h-8a8,8,0,0,0-8,8V59.53L11.81,121.19a8,8,0,0,0-2.59,11.05l13.78,22,.3.43a31.84,31.84,0,0,0,31.34,12.83c13.93-2.36,38.62-6.54,61.4,3.29l-26.6,36.57A84.71,84.71,0,0,1,69.34,194,8,8,0,1,0,58.67,206a103.32,103.32,0,0,0,69.26,26l2.17,0a104,104,0,0,0,72-177ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z' },
  "bird": { file: 'bird', group: 'nature', de: "Vogel", d: 'M236.44,73.34,213.21,57.86A60,60,0,0,0,156,16h-.29C122.79,16.16,96,43.47,96,76.89V96.63L11.63,197.88l-.1.12A16,16,0,0,0,24,224h88A104.11,104.11,0,0,0,216,120V100.28l20.44-13.62a8,8,0,0,0,0-13.32ZM126.15,133.12l-60,72a8,8,0,1,1-12.29-10.24l60-72a8,8,0,1,1,12.29,10.24ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z' },
  "fish": { file: 'fish', group: 'nature', de: "Fisch", d: 'M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm48.72,67.64c-19.37,34.9-55.44,53.76-107.24,56.1l-22,51.41A8,8,0,0,1,80.1,256l-.51,0a8,8,0,0,1-7.19-5.78L57.6,198.39,5.8,183.56a8,8,0,0,1-1-15.05l51.41-22c2.35-51.78,21.21-87.84,56.09-107.22,24.75-13.74,52.74-15.84,71.88-15.18,18.64.64,36,4.27,38.86,6a8,8,0,0,1,2.83,2.83c1.69,2.85,5.33,20.21,6,38.85C232.55,90.89,230.46,118.89,216.72,143.64Zm-4.3-100.07c-14.15-3-64.1-11-100.3,14.75a81.21,81.21,0,0,0-16,15.07,36,36,0,0,0,39.35,38.44,8,8,0,0,1,8.73,8.73,36,36,0,0,0,38.47,39.34,80.81,80.81,0,0,0,15-16C223.42,107.73,215.42,57.74,212.42,43.57Z' },
  "butterfly": { file: 'butterfly', group: 'nature', de: "Schmetterling", d: 'M128,100.17a108.42,108.42,0,0,0-8-12.64V56a8,8,0,0,1,16,0V87.53A108.42,108.42,0,0,0,128,100.17ZM232.7,50.48C229,45.7,221.84,40,209,40c-16.85,0-38.46,11.28-57.81,30.16A140.07,140.07,0,0,0,136,87.53V180a8,8,0,0,1-16,0V87.53a140.07,140.07,0,0,0-15.15-17.37C85.49,51.28,63.88,40,47,40,34.16,40,27,45.7,23.3,50.48c-6.82,8.77-12.18,24.08-.21,71.2,6.05,23.83,19.51,33,30.63,36.42A44,44,0,0,0,128,205.27a44,44,0,0,0,74.28-47.17c11.12-3.4,24.57-12.59,30.63-36.42C239.63,95.24,244.85,66.1,232.7,50.48Z' },
  "cow": { file: 'cow', group: 'nature', de: "Kuh", d: 'M104,192a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16H96A8,8,0,0,1,104,192Zm72-8H160a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Zm68.39-61.88A16,16,0,0,1,232,128H200v32a40,40,0,0,1-24,72H80a40,40,0,0,1-24-72V128H24A16,16,0,0,1,8.31,109,56.13,56.13,0,0,1,63.22,64h1.64A55.83,55.83,0,0,1,48,24a8,8,0,0,1,16,0,40,40,0,0,0,40,40h48a40,40,0,0,0,40-40,8,8,0,0,1,16,0,55.83,55.83,0,0,1-16.86,40h1.64a56.13,56.13,0,0,1,54.91,45A15.82,15.82,0,0,1,244.39,122.12ZM144,124a12,12,0,1,0,12-12A12,12,0,0,0,144,124Zm-56,0a12,12,0,1,0,12-12A12,12,0,0,0,88,124ZM56,112v-8a39.81,39.81,0,0,1,8-24h-.8A40.09,40.09,0,0,0,24,112Zm144,80a24,24,0,0,0-24-24H80a24,24,0,0,0,0,48h96A24,24,0,0,0,200,192Zm32-80a40.08,40.08,0,0,0-39.2-32H192a39.81,39.81,0,0,1,8,24v8Z' },
  "flag-de": { file: 'flag-de', group: 'flags', de: "Flagge Deutschland", flag: 'de' },
  "flag-at": { file: 'flag-at', group: 'flags', de: "Flagge Österreich", flag: 'at' },
  "flag-ch": { file: 'flag-ch', group: 'flags', de: "Flagge Schweiz", flag: 'ch' },
  "flag-eu": { file: 'flag-eu', group: 'flags', de: "Flagge Europa", flag: 'eu' },
  "flag-gb": { file: 'flag-gb', group: 'flags', de: "Flagge Vereinigtes Königreich", flag: 'gb' },
  "flag-sct": { file: 'flag-sct', group: 'flags', de: "Flagge Schottland", flag: 'sct' },
  "flag-ie": { file: 'flag-ie', group: 'flags', de: "Flagge Irland", flag: 'ie' },
  "flag-us": { file: 'flag-us', group: 'flags', de: "Flagge USA", flag: 'us' },
  "flag-fr": { file: 'flag-fr', group: 'flags', de: "Flagge Frankreich", flag: 'fr' },
  "flag-it": { file: 'flag-it', group: 'flags', de: "Flagge Italien", flag: 'it' },
  "flag-nl": { file: 'flag-nl', group: 'flags', de: "Flagge Niederlande", flag: 'nl' },
  "flag-be": { file: 'flag-be', group: 'flags', de: "Flagge Belgien", flag: 'be' },
  "flag-lu": { file: 'flag-lu', group: 'flags', de: "Flagge Luxemburg", flag: 'lu' },
  "flag-es": { file: 'flag-es', group: 'flags', de: "Flagge Spanien", flag: 'es' },
  "flag-se": { file: 'flag-se', group: 'flags', de: "Flagge Schweden", flag: 'se' },
  "flag-dk": { file: 'flag-dk', group: 'flags', de: "Flagge Dänemark", flag: 'dk' },
  "flag-no": { file: 'flag-no', group: 'flags', de: "Flagge Norwegen", flag: 'no' },
  "flag-fi": { file: 'flag-fi', group: 'flags', de: "Flagge Finnland", flag: 'fi' },
  "flag-pl": { file: 'flag-pl', group: 'flags', de: "Flagge Polen", flag: 'pl' },
  "flag-cz": { file: 'flag-cz', group: 'flags', de: "Flagge Tschechien", flag: 'cz' },
  "flag-tr": { file: 'flag-tr', group: 'flags', de: "Flagge Türkei", flag: 'tr' },
  "flag-lb": { file: 'flag-lb', group: 'flags', de: "Flagge Libanon", flag: 'lb' },
  "flag-sy": { file: 'flag-sy', group: 'flags', de: "Flagge Syrien", flag: 'sy' },
  "flag-af": { file: 'flag-af', group: 'flags', de: "Flagge Afghanistan", flag: 'af' }
};
var SYMBOL_GROUPS = [
  { id: 'classic', items: ["clover", "star", "heart", "spade", "club", "diamond", "crown", "crown-simple", "gem", "shield", "euro", "dollar", "lightning", "anchor", "airplane", "rocket"] },
  { id: 'golf', items: ["golf", "flag", "pennant", "flag-checkered", "trophy", "medal", "target", "timer", "soccer-ball", "tennis-ball", "basketball", "bicycle", "sailboat", "barbell", "person-simple-run"] },
  { id: 'party', items: ["beer-stein", "beer-bottle", "wine", "champagne", "martini", "cake", "gift", "confetti", "balloon", "smiley", "handshake", "music-notes", "fire", "sparkle"] },
  { id: 'nature', items: ["mountains", "tree", "tree-evergreen", "leaf", "plant", "flower", "flower-tulip", "cactus", "sun", "moon", "snowflake", "paw-print", "dog", "cat", "horse", "bird", "fish", "butterfly", "cow"] },
  { id: 'flags', items: ["flag-de", "flag-at", "flag-ch", "flag-eu", "flag-gb", "flag-sct", "flag-ie", "flag-us", "flag-fr", "flag-it", "flag-nl", "flag-be", "flag-lu", "flag-es", "flag-se", "flag-dk", "flag-no", "flag-fi", "flag-pl", "flag-cz", "flag-tr", "flag-lb", "flag-sy", "flag-af"] }
];


// FLAGS-BEGIN — Landesflaggen als Zeichenbefehle in Flaggen-Einheiten (w x h = amtliches Seitenverhaeltnis).
// Einzige Quelle fuer Vorschau, Druckdatei und die Master-SVGs (03_SHOP/konfigurator/symbols/build-flags.mjs).
// Ops: ['r', x, y, w, h, farbe] | ['p', d, farbe] | ['s', d, linienbreite, farbe, clipD?]
// Farben = Name fuer die Produktion (Property „Symbolfarben“). Spanien als Dienstflagge ohne Wappen.
function flagStar(cx, cy, r) {
  var d = '', ri = r * 0.382;
  for (var i = 0; i < 10; i++) {
    var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? ri : r;
    d += (i ? 'L' : 'M') + (cx + rr * Math.cos(a)).toFixed(3) + ',' + (cy + rr * Math.sin(a)).toFixed(3);
  }
  return d + 'Z';
}
function flagStripesH(w, cols) {
  return cols.map(function (c, i) { return ['r', 0, i, w, 1, c]; });
}
function flagStripesV(h, cols) {
  return cols.map(function (c, i) { return ['r', i, 0, 1, h, c]; });
}
var FLAG_DEFS = (function () {
  var eu = (function () {
    var d = '';
    for (var i = 0; i < 12; i++) {
      var a = i * Math.PI / 6;
      d += flagStar(13.5 + 6 * Math.sin(a), 9 - 6 * Math.cos(a), 1);
    }
    return d;
  })();
  var us = (function () {
    var ops = [['r', 0, 0, 190, 100, '#FFFFFF']];
    for (var i = 0; i < 13; i += 2) ops.push(['r', 0, i * 100 / 13, 190, 100 / 13, '#B22234']);
    ops.push(['r', 0, 0, 76, 700 / 13, '#3C3B6E']);
    var d = '';
    for (var row = 0; row < 9; row++) {
      var n = row % 2 ? 5 : 6;
      for (var j = 0; j < n; j++) d += flagStar(6.3 * (row % 2 ? 2 * j + 2 : 2 * j + 1), 5.4 * (row + 1), 3.08);
    }
    ops.push(['p', d, '#FFFFFF']);
    return ops;
  })();
  return {
    de: { w: 5, h: 3, colors: ['Schwarz', 'Rot', 'Gold'], ops: flagStripesH(5, ['#000000', '#DD0000', '#FFCE00']) },
    at: { w: 4.5, h: 3, colors: ['Rot', 'Weiß'], ops: flagStripesH(4.5, ['#C8102E', '#FFFFFF', '#C8102E']) },
    ch: { w: 32, h: 32, colors: ['Rot', 'Weiß'], ops: [['r', 0, 0, 32, 32, '#DA291C'], ['r', 13, 6, 6, 20, '#FFFFFF'], ['r', 6, 13, 20, 6, '#FFFFFF']] },
    eu: { w: 27, h: 18, colors: ['Blau', 'Gelb'], ops: [['r', 0, 0, 27, 18, '#003399'], ['p', eu, '#FFCC00']] },
    gb: { w: 60, h: 30, colors: ['Blau', 'Rot', 'Weiß'], ops: [
      ['r', 0, 0, 60, 30, '#012169'],
      ['s', 'M0,0L60,30M60,0L0,30', 6, '#FFFFFF'],
      ['s', 'M0,0L60,30M60,0L0,30', 4, '#C8102E', 'M30,15h30v15zv15h-30zh-30v-15zv-15h30z'],
      ['s', 'M30,0v30M0,15h60', 10, '#FFFFFF'],
      ['s', 'M30,0v30M0,15h60', 6, '#C8102E']] },
    sct: { w: 25, h: 15, colors: ['Blau', 'Weiß'], ops: [['r', 0, 0, 25, 15, '#005EB8'], ['s', 'M0,0L25,15M25,0L0,15', 3, '#FFFFFF']] },
    ie: { w: 3, h: 1.5, colors: ['Grün', 'Weiß', 'Orange'], ops: flagStripesV(1.5, ['#169B62', '#FFFFFF', '#FF883E']) },
    us: { w: 190, h: 100, colors: ['Rot', 'Weiß', 'Blau'], ops: us },
    fr: { w: 3, h: 2, colors: ['Blau', 'Weiß', 'Rot'], ops: flagStripesV(2, ['#0055A4', '#FFFFFF', '#EF4135']) },
    it: { w: 3, h: 2, colors: ['Grün', 'Weiß', 'Rot'], ops: flagStripesV(2, ['#009246', '#FFFFFF', '#CE2B37']) },
    nl: { w: 4.5, h: 3, colors: ['Rot', 'Weiß', 'Blau'], ops: flagStripesH(4.5, ['#AE1C28', '#FFFFFF', '#21468B']) },
    be: { w: 3, h: 2.6, colors: ['Schwarz', 'Gelb', 'Rot'], ops: flagStripesV(2.6, ['#000000', '#FDDA24', '#EF3340']) },
    lu: { w: 5, h: 3, colors: ['Rot', 'Weiß', 'Hellblau'], ops: flagStripesH(5, ['#EA141D', '#FFFFFF', '#51ADDA']) },
    es: { w: 6, h: 4, colors: ['Rot', 'Gelb'], ops: [['r', 0, 0, 6, 4, '#AA151B'], ['r', 0, 1, 6, 2, '#F1BF00']] },
    se: { w: 16, h: 10, colors: ['Blau', 'Gelb'], ops: [['r', 0, 0, 16, 10, '#006AA7'], ['r', 5, 0, 2, 10, '#FECC02'], ['r', 0, 4, 16, 2, '#FECC02']] },
    dk: { w: 37, h: 28, colors: ['Rot', 'Weiß'], ops: [['r', 0, 0, 37, 28, '#C8102E'], ['r', 12, 0, 4, 28, '#FFFFFF'], ['r', 0, 12, 37, 4, '#FFFFFF']] },
    no: { w: 22, h: 16, colors: ['Rot', 'Weiß', 'Blau'], ops: [['r', 0, 0, 22, 16, '#BA0C2F'], ['r', 6, 0, 4, 16, '#FFFFFF'], ['r', 0, 6, 22, 4, '#FFFFFF'], ['r', 7, 0, 2, 16, '#00205B'], ['r', 0, 7, 22, 2, '#00205B']] },
    fi: { w: 18, h: 11, colors: ['Weiß', 'Blau'], ops: [['r', 0, 0, 18, 11, '#FFFFFF'], ['r', 5, 0, 3, 11, '#002F6C'], ['r', 0, 4, 18, 3, '#002F6C']] },
    pl: { w: 8, h: 5, colors: ['Weiß', 'Rot'], ops: [['r', 0, 0, 8, 2.5, '#FFFFFF'], ['r', 0, 2.5, 8, 2.5, '#DC143C']] },
    cz: { w: 6, h: 4, colors: ['Weiß', 'Rot', 'Blau'], ops: [['r', 0, 0, 6, 2, '#FFFFFF'], ['r', 0, 2, 6, 2, '#D7141A'], ['p', 'M0,0L3,2L0,4Z', '#11457E']] },
    // Tuerkei, Libanon, Syrien: Geometrie aus den gemeinfreien Wikimedia-SVGs (Libanon-Zeder auf 0,1 gerundet).
    // Syrien in der seit 2025 gueltigen Fassung. Afghanistan als Trikolore 2013–2021 ohne Emblem (auf dem Ball nicht
    // druckbar); die heutige Flagge traegt das Glaubensbekenntnis als Schrift (Inhaber-Abstimmung).
    tr: { w: 90000, h: 60000, colors: ['Rot', 'Weiß'], ops: [['r', 0, 0, 90000, 60000, '#E30A17'],
      ['p', 'M41750 30000l13568-4408-8386 11541V22867l8386 11541zm925 8021a15000 15000 0 1 1 0-16042 12000 12000 0 1 0 0 16042z', '#FFFFFF']] },
    lb: { w: 2880, h: 1920, colors: ['Rot', 'Weiß', 'Grün'], ops: [['r', 0, 0, 2880, 1920, '#D31624'], ['r', 0, 480, 2880, 960, '#FFFFFF'],
      ['p', 'M1426 480c-13.4 24.6-28.2 49.4-51.5 66.2a258.4 258.4 0 0 0-11.7 8.4l-2.2 1.7a720.3 720.3 0 0 0-6.2 4.7L1352 563c-7.2 5.6-13.9 11.6-20.4 18.1a937.4 937.4 0 0 1-4.8 4.8c-7.7 7.7-17.2 15.9-21.7 26.0 2.2 0 2.2 0 8.7-1.8l2.7-.795a363.1 363.1 0 0 0 21.3-6.7c5.6-2.0 10.1-2.9 16.1-2.6-.268 2.0-.61 4.0-1 6-11.2 16.8-34.1 30.3-52.3 38.2-5.4 2.3-10.7 4.6-15.8 7.8L1282 654c-12.7 8.4-25.3 16.1-34 29l2 4c1.7.02 3.4.037 5.1.049l2.1.014c3.3.04 6.6.2 9.8-.555 2.0-.613 2.0-.613 4.7-.676l3.1-.02c3.0-.09 3.0-.09 6 .188 2.8.93 3.8 1.8 5.7 4.2 3.4 6.2 5.7 11.5 4.2 18.7-4.8 4.8-11.2 5.2-17.8 5.6-6.0.255-10.1 1.2-15.6 3.8-12.1 5.9-25.1 14.9-29.8 28.2L1227 750c-18.7 22.1-18.7 22.1-46.3 34.1-7.7 3.8-15.3 7.8-22.7 12.4a426.3 426.3 0 0 1-6.0 3.6c-13.9 8.2-27.9 17.0-40.0 27.9-3.0 3.2-4.4 5.2-4.5 9.8C1108 842 1108 842 1109 843c4.0 2.4 7.1 3.3 11.8 3.3l2.1-.066c1.5-.033 3.0-.068 4.5-.105 1.4-.052 2.9-.1 4.4-.145 15.9.057 31.5-5.0 46.5-10.2 4.5-1.6 7.6-2.3 12.4-.77 5.9 4.9 5.9 4.9 9.3 11.9l1.4 3.0c1.9 3.9 3.8 7.7 5.1 11.9 1.0 7.5.067 14.4-3.8 21.1l-2.1 3.0c-3.9 5.5-8.2 10.8-12.6 16.0L1186 905c-4.2 5.1-8.6 9.7-13.7 14.1L1170 921c-8.1 7.2-18.3 11.0-28.8 13.4-5.7 1.2-11.1 2.7-16.5 5.1l-2.1.97c-13.8 6.1-25.2 16.6-35.6 27.4-2.2 2.3-4.6 4.7-6.9 7.0l-1.6 1.7c-3.4 3.5-6.8 6.9-10.5 10.1-1.7 1.4-3.4 2.9-5.1 4.5-5.4 5.2-10.9 10.3-17.0 14.8l-1.8 1.3c-3.2 2.3-6.2 4.2-9.9 5.6l-2.5.727c.125 2.1.125 2.1 1 5 5.8 6.1 14.3 10.2 22.5 12.3 18.9 3.3 35.2-6.0 50.3-16.5 4.1-2.8 8.3-5.7 12.6-8.5l2.9-1.9c5.0-3.4 9.3-6.7 15.6-6.8 6.2.722 9.8 3.9 13.7 8.5 6.7 9.0 10.8 19.3 9.1 30.8-3.3 7.8-9.9 13.4-17.2 17.7l-2.6 1.4c-7.2 4.1-14.6 8.2-22.0 12.1-22.1 11.7-42.8 25.3-61.7 41.8-1.0.941-2.1 1.8-3.2 2.7-9.1 7.1-17.2 15.0-25.3 23.3-14.0 14.4-28.1 30.9-49.5 31.4l-3.7.017c-3.6.072-7.3.143-10.9.176L960 1168c1.9 3.0 3.8 6.0 6 9 7.4 7.6 15.6 12.0 26.2 12.4l2.2.041c12.4.343 12.4.344 40.4-8.8l2.0-.686c29.7-9.7 60.7-20.2 86.8-37.8 5.5-3.8 11.0-7.8 17.0-11.1 14.0-6.5 28.8-7.0 43.4-1.8 5.5 2.1 9.9 4.2 12.5 9.8.831 3.7.442 6.8-1 10.5-56.0 42.4-56.0 42.4-125.4 61.3-19.2 5.3-38.5 11.3-56.5 20.1l-.313 3c.05 4.9 1.9 8.4 5.3 12 9.5 6.7 21.4 8.3 32.8 8.3l3.8-.054c10.4-.094 20.7-.238 31.0-1.9L1089 1252c13.4-2.2 26.1-5.3 38.7-10.4a711.2 711.2 0 0 1 12.4-4.9c25.4-9.9 50.8-19.9 75.7-31.1l2.7-1.2c4.4-2.0 8.8-4.0 13.2-6.0 10.4-4.8 21.8-11.2 33.5-11.4 14.4 1.3 28.6 9.3 38.8 19.2 9.6 10.3 14.6 20.5 14.8 34.8-.065 40.2-32.8 82.8-60.0 110.2l-2.6 2.6c-9.0 9.2-18.4 16.8-29.8 22.9l-2.8 1.4c-8.4 4.3-16.7 7.9-25.7 10.6-8.1 2.4-16.5 4.8-24.2 8.4-16.1 8.6-33.6 25.2-39.8 42.8h12.7c.883-.273 1.5-.604 2.1-1.1 12.9-16.8 29.4-30.0 51.0-33.8 3.2-.285 6.5-.361 9.8-.438 34.3-1.3 68.6-13.4 94.1-36.9 18.2-15.9 45.4-37.8 70.5-22.5 10.4 5.3 21.7 4.4 32.6.969l3.3-1.0c7.2-2.3 13.8-3.5 20.9-.188 3.9 3.6 5.5 6.2 5.8 11.5.6 7.6 4.0 13.7 9.6 18.9 4.3 3.6 9.0 6.6 13.7 9.7 5.6 3.7 10.8 7.9 16.1 12.1l2.7 2.1c6.0 4.8 11.7 9.9 17.2 15.3 5.1 4.8 9.7 7.5 16.9 8.4-1.9-11.0-6.6-20.3-12.7-29.6-2.0-3.6-1.6-6.1-1.2-10.3 10.7-7.1 32.9-1.3 45.3.188l2.5.296c10.5 1.2 19.9 3.1 28.4 6.5 5.8 1.9 11.3 4.6 15.9 8.7 4.0 3.0 7.9 6.7 11.7 11.1 2.7 3.0 5.7 5.9 8.6 8.8 1.9 2.0 3.8 4.1 5.6 6.2 3.3 3.9 7.2 7.0 11.3 10.1 2.2 1.7 2.2 1.7 5.1 4.7.12.0.382.0.504.0H1663v-1c-8.7-12.8-19.7-24.1-31.8-33.8-2.7-2.1-5.3-4.2-7.9-6.5-3.5-3.2-7.0-6.5-10.8-9.6-5.9-4.7-11.5-9.7-17.1-15.0-3.4-3.2-6.8-6.5-10.3-9.7-17.1-14.8-30.4-30.7-38.8-52.1L1545 1309c-2.9-7.6-4.2-14.9-4.8-23.0l-.24-3.4c-.902-12.9-1.1-25.8-1.1-38.7.012-3.9.025-7.9.011-11.8-.01-2.6-.01-5.3-.01-7.9l.006-3.7c-.03-8.6.436-16.2 3.0-24.5 4.4-10.2 11.6-19.2 22.2-23.5 9.1-1.3 17.1.589 25.5 4.3l2.0.941a368.9 368.9 0 0 1 15.5 7.3c1.2.62 2.4 1.2 3.7 1.8 1.8.937 3.7 1.8 5.6 2.8 17.2 8.8 32.4 11.2 51.7 11.2 4.5-.02 9.1-.037 13.7-.022 8.4.031 16.9.03 25.3.02 9.2-.011 18.4-.021 27.6.008 4.0.014 8.0.021 12.0.004 12.6-.057 24.6-.177 36.8 3.4L1787 1205c24.9 10.9 24.9 10.9 47.9 25.8 2.4 1.5 4.8 3 7.2 4.4 6.9 4.2 13.7 8.5 20.3 13.2 8.9 6.3 18.1 13.7 28.8 16.9 7.4 1.1 16.7 2.1 23.0-2.2 3.8-3.4 5.2-6.5 6.1-11.5-1.9-13.2-14.7-24.5-24.8-32.4L1894 1218c-20.5-15.9-42.2-31.0-65.3-43a554.7 554.7 0 0 1-20.6-11.1c-5.7-3.2-11.4-6.5-17.1-9.6-17.6-9.6-40.2-19.0-50.8-37.1-.726-3.4-.348-6.7.625-10.1 3.2-4.3 7.8-7.3 12.5-9.8l1.8-.98c4.8-2.5 9.6-4.7 14.8-6.4 20.5-.546 20.5-.546 38.8 10.3 11.3 6.2 23.5 14.3 36.6 15.9l2.6.184c10.5 1.0 10.5 1.0 37-5v-2l-1.4-1.2a230.4 230.4 0 0 1-12.4-9.4c-1.3-1.1-2.7-2.2-4.1-3.3l-2.1-1.7a672.0 672.0 0 0 0-6.6-5.3c-4.8-3.8-9.5-7.7-14.1-11.7-3.3-2.8-6.6-5.7-10.0-8.4-4.6-3.7-9.1-7.5-13.5-11.5-2.6-2.4-5.2-4.7-8.0-7.0-5.2-4.1-10.1-8.5-14.9-13.2l-2.2-2.2c-4.1-4.1-8.1-8.2-12-12.7A606.1 606.1 0 0 0 1780 1017c-15.5-15.9-38.0-22.9-59.8-23.6-8.3-.14-18.5.663-25.1-5.3-1.2-3.4-1.2-3.4-1-7 5.1-6.2 15.3-8.3 23.0-9.6l3.0-.453c21.7-2.4 21.7-2.4 43.6-3.1l3.1-.105c1.9-.068 3.9-.136 5.9-.201 4.8-.14 9.6-.285 14.4-.905 2.0-.274 4.0-.52 6.1-.664l2.0-.072 2.3-.096c6.5-.26 12.9-.467 19.3-1.9 1.5-.384 3.1-.751 4.6-1.0 1.5-.312 3.0-.63 4.5-.955l2.3-.502A68.2 68.2 0 0 0 1837 959c2.0-1.8 2.0-1.8 3-4 .004-2.0.004-2.0-1-4-9.6-7.6-9.6-7.6-37.2-15.8a829.3 829.3 0 0 1-6.1-1.8c-4.8-1.4-9.6-2.9-14.4-4.4L1775 927c-10.6-3.2-21.2-6.3-32.0-8.9l-2.9-.715c-4.9-1.2-9.9-2.4-14.9-3.6-1.9-.451-3.8-.908-5.7-1.3l-2.7-.66c-8.8-2.0-17.9-5.1-23.6-12.6-.377-3.2-.444-5.1 1-8 3.4-3.5 6.1-4.5 11.1-4.6l2.5.043c10.3.091 20.3 1.5 30.5 3.1 10.9 1.7 21.8 3.2 32.8 4.4l2.3.261c9.0 1.0 18.5 2.7 27.5 1.6 2.5-1.0 3.6-1.4 5.0-3.8-.016-2.1-.016-2.1-1.7-4.5l-2.5-2.4c-6.7-6.7-6.7-6.7-25.8-17.3-9.7-5.3-19.5-10.8-29.0-16.7L1745 850c-24.3-14.9-49.5-30.8-70.4-50.5-12.5-12.0-25.4-23.6-39.3-34.0-1.0-.804-2.1-1.6-3.2-2.4-8.4-6.6-17.1-11.7-26.8-16.6-4.1-2.0-8.2-4.0-12.1-6.3-4.1-2.9-8.4-5.6-9.6-10.7-.172-3.3-.266-6.0 1.7-8.8 5.0-3.8 9.2-4.7 15.4-4.8l2.8.032c12.0.102 21.4 2.2 32.2 7.8 4.6 2.4 9.0 4.3 14.1 5.7l2.3.652c9.1 2.6 18.3 3.2 27.7 3.2l2.7-.015c2.9-.005 5.9-.01 8.9-.022 2.0-.009 4.1-.016 6.1-.021 6.0-.012 12.1-.03 18.1-.055-1.1-2.1-1.1-2.1-6.8-4.5-23.3-9.2-45.2-22.1-65.3-37.1L1642 690c-10.0-7.4-25.5-15.9-30-28a6878.1 6878.1 0 0 1 20.3-.063c12.8-.057 25.5.07 38.3.846L1674 663c-1-3-.999-3-2.5-4.4l-2.0-1.5-2.2-1.7-2.4-1.8c-2.4-1.9-4.9-3.8-7.4-5.7a1137.2 1137.2 0 0 1-5.7-4.3L1648.5 641a930.9 930.9 0 0 1-8.5-6.5c-10.0-7.9-20.1-15.7-30.7-22.9L1607 610c-11.1-7.5-22.3-14.1-34.9-19.1L1570 590c-6.4-2.5-12.9-4.8-19.6-6.4l-2.0-.476a587.3 587.3 0 0 0-16.2-3.5c-2.3-.48-4.7-.964-7.0-1.4-1.5-.325-3.1-.65-4.7-.972-9.5-1.8-18.4-3.5-26.9-8.6L1491 567c-12.6-7.6-22.6-17.5-31.7-29.1L1457 535c-10.7-13.8-19.2-28.8-25.5-45.1l-.976-2.6-.902-2.4c-.956-2.6-.999-3.4-3.5-4.7zm-106.5 181.6c1.7.003 3.5.187 5.5.363 4.2.968 7.8 1.8 11 5-.785 7.7-9.2 14.5-14.7 19.2-7.4 5.8-7.4 5.8-11.5 5.5C1308 691 1308 691 1307 690c-.307-3.2-.278-6.4-.313-9.6l-.087-2.7c-.055-5.7.486-9.1 4.4-13.5 2.8-1.8 5.5-2.3 8.4-2.3zm158.4 15.6c2.9-.009 5.8.635 8.7 1.9 3.5 2.3 5.9 4.1 8.2 7.7.406 2.3.406 2.3.5 4.9l.156 2.5c-.654 2.4-.656 2.4-3.0 4.7-4.7 2.2-8.5 2.2-13.6 2.0l-2.6-.004c-5.5-.075-10.1-.23-14.2-4.3-.605-4.4-.493-8.6 1.0-12.8 4.0-4.4 9.3-6.8 14.8-6.8zm62.7 4.2c3.9.546 5.6 1.5 8.3 4.4 2.0 6.4-1.0 14.2-4 20-3.2 4.0-7.9 6.8-13 8-11.2 1.1-11.2 1.1-15.3-1.5-2.2-3.3-2.1-5.7-2.1-9.8l-.031-3.8c.757-5.3 3.3-9.1 7.4-12.4 5.0-3.6 8.8-4.5 15.0-4.6l3.6-.086zm-108.5.018c1.2.029 2.5.17 3.8.443 3.1 1.7 5.3 3.7 7 7 .529 6.7.911 13.3-3 19-7.1 5.9-15.1 8.7-24 11l-2.3.684c-5.9 1.5-12.0 1.5-18.1 1.6l-2.7.054-2.5-.004-2.3.01L1386 721c-2.0-3.1-2.6-5.0-2.4-8.7 1.6-7.5 8.6-12.3 14.6-16.4 4.9-3.1 10.1-5.7 15.3-8.2l3.2-1.6c5.1-2.5 9.9-4.4 15.3-4.3zm-70.8 33.3c.584.0 1.1.05 1.7.105 2.5 1.5 2.5 1.5 4 4 1.4 7.8-2.1 15.2-6 22-9.2 13.3-23.9 19.9-39 25-2.0.12-4.0.175-6.0.188l-3.2.042C1310 766 1310 766 1308 764c-.775-6.0.141-9.1 3.8-13.9l1.6-2.0 1.6-2.1c10.3-13.0 28.0-31.5 46.1-31.0zm132.1 60.9c.549 0 1.0.043 1.6.131 2.9 1.8 5.4 3.8 7 7 .657 7.6.947 14.8-4 21-5.7 5.9-14.3 8.0-22.4 8.3-3.5-.375-3.5-.375-6.1-1.3-2.0-2.9-1.8-4.9-1.2-8.4 2.8-9.3 13.9-26.7 25.1-26.7zm-54.7 1.8c3.7.066 6.6 1.6 11.3 4.2 2 3 2 3 1.9 6.3-1.7 6.5-6.6 9.2-12.1 12.6-5.4 3.1-11.5 3.0-17.7 2.0-7.1-2.0-14.1-5.0-21-8v-2c22.7-11.1 31.3-15.3 37.6-15.2zm116.5 16.2c8.6-.128 17.8 2.6 26.9 7.5 3.3 2.6 4.6 5.3 5.3 9.5.15 8.8-1.2 15.6-6.5 22.8-6.0 4.6-14.6 3.9-22 3-6.1-1.1-12.0-3.0-18-5l-3.4-1.1c-11.2-3.9-11.2-3.9-14.5-8.8-.747-4.6-.004-7.5 2.4-11.4 8.3-11.4 18.5-16.3 29.7-16.5zm-256.7 4.5 3.9.035 3.9-.035 3.8.012 3.4.01c3.8.456 7.4 1.5 10.2 4.3.78 3.9.576 5.9-1.4 9.5-19.4 27.2-19.4 27.2-29.4 28.9-3.5-.569-4.7-1.5-6.8-4.4-5.3-8.9-9.9-19.4-8.2-30.0 4.3-5.9 9.3-8.3 16.6-8.3l3.8-.012zm-66.6 9.9c5.2.007 10.5 1.3 14.9 3.9 8.1 5.5 12.3 13.2 17.1 21.5a568.9 568.9 0 0 0 3.2 5.5c1.6 2.7 3.2 5.5 4.8 8.3-3.9 4.7-10.3 6.0-16 8l-2.7.988c-5.2 1.7-10.6 3.3-16.2 2.0-9.7-5.5-16.2-17.2-21.5-26.8l-1.0-1.8c-2.2-4.2-2.8-7.5-2.3-12.3 4.5-6.5 12.1-9.4 19.8-9.4zm396.5 61.7c3.3.059 6.6.685 9.4 1.8 4.4 2.8 8.1 5.9 10.2 10.8.861 6.4.78 12.6-2.6 18.3-3.3 4.1-6.9 6.3-12.2 7.1-9.8.385-15.1-2.6-22.5-8.7-4.3-4.1-4.3-4.1-5.3-8.2 2.1-8.3 6.3-14.8 13.6-19.6 2.8-1.1 6.2-1.6 9.5-1.5zm-224.8 32.0c.783-.009 1.6.038 2.5.12 2.9.78 4.3 2.1 6.0 4.5 2.6 5.2 1.1 11.4-.625 16.7-1.9 4.9-3.7 7.6-8.3 10.2-2.6.125-2.6.125-5-1-4.5-4.6-6.3-9.3-6.5-15.8.112-5.6 1.3-8.8 5.4-12.8 2.3-1.4 4.2-2.0 6.6-2.0zm-73.7 13.4c9.2.535 17.7 5.9 24.3 12.1 2.9 3.4 4.2 5.7 4.4 10.2L1358 942c-3.0 2.0-4.9 2.6-8.6 2.5-9.6-2.0-17.5-10.7-23.4-18.0-1.3-3.4-.748-5.9.063-9.4 1-1 1-1 3.7-1.1zM1446 919c6.8 1.4 9.9 4.0 14.0 9.9A407.5 407.5 0 0 1 1466 939l1.6 2.8c3.6 7.0 4.7 14.2 3.3 22.2-2.1 3.3-3.1 4.7-7 6-8.3 1.4-14.6-3.9-21.1-8.5-5.1-4.0-8.1-8.5-9.2-15.0-.62-9.5 3.7-17.5 9.8-24.7L1446 919zm42 24c3.7.104 4.9.93 7.6 3.6 5.3 7.1 6.3 13.5 5.3 22.3-1.0 2.8-1.0 2.8-2 5-4.0.478-5.7.179-9.1-2-4.9-4.6-5.9-10.0-6.1-16.6.125-4.7.876-8.8 4.3-12.3zm-263.5 24.0c16.4.067 32.6 2.7 43.5 9.9 2 3 2 3 1.9 5.8-2.4 8.3-9.7 12.0-16.9 16.1-17.6 9.5-35.9 16.5-56.0 18.0l-3.1.285c-6.8.361-6.8.361-10.9-2.3-3.2-2.9-5.0-6.3-6.9-10.3l-1.0-2.1c-9.0-19.2-9.0-19.2-8.9-23.8.91-1.6.91-1.6 2.7-2.6l2.3-.648 2.2-.664L1176 974l3.0-.984c12.1-3.4 28.9-6.0 45.4-5.9zm407.8 60.1c7.5-.03 14.7 1.7 20.7 5.7 2.9 3.9 3.6 6.8 3.4 11.6-.887 4.3-3.5 7.1-6.4 10.3l-1.6 1.8c-7.6 8.2-18.1 14.0-29.4 14.5a212.4 212.4 0 0 1-5.2.004l-2.8-.026c-11.3-.28-19.5-3.5-27.8-11.4-2.1-3.2-2.5-4.2-2-8 10.1-13.1 31.9-24.7 51.2-24.7zm84.4 18.4c1.8.04 3.7.545 6.0 1.4 6.8 3.1 16.7 7.8 20.2 14.9.578 5.8-.474 8.5-4.1 13.0l-1.3 1.6c-13.9 16.9-13.9 16.9-20.5 20.2-14.3-.093-31.8-1.2-42.6-11.5-1.3-2.5-1.3-2.5-1.3-4.9 5.8-14.8 23.8-26.6 37.6-33.5 2.3-.959 4.1-1.3 6.0-1.3zm-424.1 25.9c7.9.152 14.3 2.7 19.8 8.5 8.6 11.5 7.9 26.0 6.1 39.7-.946 4.4-1.9 7.3-4.7 10.9-3.8 1.6-5.7 1.5-9.7.187-13.0-10.4-16.9-33.3-19-49-.178-2.7-.15-5.2 0-8 2.6-2.6 3.8-2.3 7.5-2.4zm118.5 9.2c.676-.013 1.4.038 2.2.032 11.7.165 25.7 2.5 35.6 9.1-1.5 4.4-3.8 8.3-6.3 12.3l-1.3 2.0c-3.3 5.2-6.9 10.3-10.6 15.3l-1.5 2.0c-2.5 3.3-5.0 6.3-8.1 9.2-12.6-36.7-12.6-36.7-13-49 .984-.984 1.9-1.1 3.0-1.2zm-55.0 11.0c5.5.005 9.9 1.3 14.9 5.2 4.6 4.3 6.7 7.6 7.2 14.0l.074 3.3.114 3.3c-.518 3.8-1.6 5.4-4.4 8.1-3.3.375-3.3.375-7-1-7.5-6.9-13.2-18.2-16-28 .375-2.8.375-2.8 1-5a43.0 43.0 0 0 1 4.0-.205z', '#008C3E']] },
    sy: { w: 900, h: 600, colors: ['Grün', 'Weiß', 'Schwarz', 'Rot'], ops: [['r', 0, 0, 900, 600, '#000000'], ['r', 0, 0, 900, 400, '#FFFFFF'], ['r', 0, 0, 900, 200, '#007A3D'],
      ['p', 'm176.26 375 48.738-150 48.738 150-127.6-92.705h157.72m322.4 92.705 48.738-150 48.738 150-127.6-92.705h157.72m-352.6 92.705 48.738-150 48.738 150-127.6-92.705h157.72', '#CE1126']] },
    af: { w: 900, h: 600, colors: ['Schwarz', 'Rot', 'Grün'], ops: [['r', 0, 0, 300, 600, '#000000'], ['r', 300, 0, 300, 600, '#D32011'], ['r', 600, 0, 300, 600, '#007A36']] }
  };
})();
// Kontur: duenne schwarze Linie, damit weisse Flaechen auf dem weissen Ball sichtbar bleiben (zaehlt als Farbe).
// Im Druck fest ~0,22 mm (FLAG_OUTLINE_PA = Anteil der Druckflaechen-Kante); FLAG_OUTLINE nur fuer Vorschau/SVG.
var FLAG_OUTLINE = 0.035; // Anteil der Flaggenhoehe
var FLAG_OUTLINE_PA = 0.009;
function flagColors(code) {
  var c = FLAG_DEFS[code].colors.slice();
  if (c.indexOf('Schwarz') < 0) c.push('Schwarz (Kontur)');
  return c;
}
function drawFlag(ctx, code, x, y, w, h, lineW) {
  var f = FLAG_DEFS[code];
  if (!f) return;
  ctx.save();
  ctx.translate(x, y); ctx.scale(w / f.w, h / f.h);
  ctx.beginPath(); ctx.rect(0, 0, f.w, f.h); ctx.clip();
  f.ops.forEach(function (o) {
    if (o[0] === 'r') { ctx.fillStyle = o[5]; ctx.fillRect(o[1], o[2], o[3], o[4]); }
    else if (o[0] === 'p') { ctx.fillStyle = o[2]; ctx.fill(new Path2D(o[1])); }
    else {
      ctx.save();
      if (o[4]) ctx.clip(new Path2D(o[4]));
      ctx.strokeStyle = o[3]; ctx.lineWidth = o[2]; ctx.lineCap = 'butt';
      ctx.stroke(new Path2D(o[1]));
      ctx.restore();
    }
  });
  ctx.restore();
  var lw = lineW || h * FLAG_OUTLINE;
  ctx.save();
  ctx.strokeStyle = '#000000'; ctx.lineWidth = lw;
  ctx.strokeRect(x + lw / 2, y + lw / 2, w - lw, h - lw);
  ctx.restore();
}
// FLAGS-END

var _symbolPaths = {};
function symbolPath(id) {
  if (!_symbolPaths[id] && SYMBOLS[id] && typeof Path2D !== 'undefined') _symbolPaths[id] = new Path2D(SYMBOLS[id].d);
  return _symbolPaths[id] || null;
}
function isFlag(id) { return !!(id && SYMBOLS[id] && SYMBOLS[id].flag); }
function isSymbol(id) { return !!(id && SYMBOLS[id] && (SYMBOLS[id].flag || symbolPath(id))); }
function flagRatio(id) { var f = FLAG_DEFS[SYMBOLS[id].flag]; return f.w / f.h; }

// ==========================================================================
// INHALT
// ==========================================================================
function activeTextLines() {
  return state.text.lines.map(function (l) { return l.trim(); }).filter(function (l) { return l !== ''; });
}
function effectiveLayout() {
  if (!state.symbol.id) return 'none';
  if (state.symbol.layout === 'only') return 'only';
  var n = activeTextLines().length;
  if (n === 0) return 'only';
  if (state.symbol.layout === 'left' && n > 1) return 'above';
  return state.symbol.layout;
}
function hasTextContent() {
  if (state.symbol.id) return true;
  return activeTextLines().length > 0;
}
function hasContent() {
  return state.mode === 'logo' ? !!state.logo : hasTextContent();
}

// ==========================================================================
// GESTALTUNG ZEICHNEN — im Koordinatensystem der Druckflaeche (Quadrat W x H)
// Gemeinsame Quelle fuer Druckdatei (300 DPI), Druckflaechen-Ansicht und Ball-Textur.
// ==========================================================================
function clipPrintShape(ctx, W, H, pa) {
  ctx.beginPath();
  if (pa.shape === 'circle') ctx.arc(W / 2, H / 2, W / 2, 0, Math.PI * 2);
  else ctx.rect(0, 0, W, H);
  ctx.clip();
}

// Logo-Geometrie in Druckflaechen-Koordinaten (identisch zur v1.2-Exportlogik)
function logoRectInArea(W, H, pa) {
  var p = state.placement;
  var img = state.logo.image;
  var maxLogoSize;
  if (pa.shape === 'circle') {
    maxLogoSize = W * (pa.maxLogoDiameter / pa.diameter);
  } else {
    maxLogoSize = Math.min(W * (pa.maxLogoWidth / pa.width), H * (pa.maxLogoHeight / pa.height));
  }
  var logoSize = maxLogoSize * p.scale;
  var aspect = img.width / img.height;
  var logoW, logoH;
  if (aspect >= 1) { logoW = logoSize; logoH = logoSize / aspect; }
  else { logoH = logoSize; logoW = logoSize * aspect; }
  var relX, relY;
  if (pa.shape === 'circle') {
    relX = (p.x - (pa.centerX - pa.diameter / 2)) / pa.diameter;
    relY = (p.y - (pa.centerY - pa.diameter / 2)) / pa.diameter;
  } else {
    relX = (p.x - (pa.centerX - pa.width / 2)) / pa.width;
    relY = (p.y - (pa.centerY - pa.height / 2)) / pa.height;
  }
  var cx = relX * W, cy = relY * H;
  return { x: cx - logoW / 2, y: cy - logoH / 2, w: logoW, h: logoH, cx: cx, cy: cy };
}

function drawDesign(ctx, W, H) {
  var pa = getActivePrintArea();
  ctx.save();
  clipPrintShape(ctx, W, H, pa);
  if (state.mode === 'logo') {
    if (state.logo && state.logo.image) {
      var r = logoRectInArea(W, H, pa);
      ctx.drawImage(state.logo.image, r.x, r.y, r.w, r.h);
    }
  } else {
    drawTextSymbol(ctx, W, H, pa);
  }
  ctx.restore();
}

// Text & Symbol: Layout wird so lange verkleinert, bis alles in die Druckflaeche passt.
function layoutTextSymbol(ctx, S, pa) {
  var lines = activeTextLines();
  var layout = effectiveLayout();
  if (layout === 'only') lines = [];
  var fp = fontPresets[state.text.font] || fontPresets.klassisch;
  var n = lines.length;
  var f0 = S * (n <= 1 ? 0.2 : n === 2 ? 0.155 : 0.125);
  var sym = isSymbol(state.symbol.id) ? state.symbol.id : null;
  if (sym && layout === 'above') f0 *= 0.82;
  var s0 = 0;
  if (sym) s0 = layout === 'only' ? S * 0.6 : layout === 'left' ? f0 * 1.25 : S * 0.3;
  // Symbol-Box: Icons quadratisch, Flaggen im amtlichen Seitenverhaeltnis (etwas groesser, damit sie lesbar bleiben)
  var sw = s0, sh = s0;
  if (sym && isFlag(sym)) {
    var ar = flagRatio(sym);
    if (layout === 'only') { sw = s0 * 1.1; sh = sw / ar; if (sh > s0) { sh = s0; sw = sh * ar; } }
    else if (layout === 'left') { sh = s0 * 0.85; sw = sh * ar; }
    else { sh = s0 * 0.78; sw = sh * ar; }
  }
  ctx.font = fp.weight + ' ' + f0 + 'px ' + fp.family;
  var widths = lines.map(function (l) { return ctx.measureText(l).width; });
  var lh = f0 * 1.16;
  var gapV = S * 0.05, gapH = S * 0.045;
  var items = [];
  var blockW, blockH;
  if (layout === 'left') {
    blockW = sw + gapH + widths[0];
    blockH = Math.max(sh, f0 * 1.1);
    items.push({ t: 'sym', x: -blockW / 2, y: -sh / 2, w: sw, h: sh });
    items.push({ t: 'txt', text: lines[0], x: -blockW / 2 + sw + gapH, y: -f0 * 0.55, w: widths[0], h: f0 * 1.1, align: 'left' });
  } else {
    blockW = Math.max(sym ? sw : 0, widths.length ? Math.max.apply(null, widths) : 0);
    blockH = (sym ? sh : 0) + (sym && n ? gapV : 0) + n * lh;
    var y = -blockH / 2;
    if (sym) { items.push({ t: 'sym', x: -sw / 2, y: y, w: sw, h: sh }); y += sh + (n ? gapV : 0); }
    lines.forEach(function (l, i) {
      items.push({ t: 'txt', text: l, x: -widths[i] / 2, y: y + (lh - f0 * 1.1) / 2, w: widths[i], h: f0 * 1.1, align: 'center' });
      y += lh;
    });
  }
  // Einpassen: alle Eckpunkte innerhalb der sicheren Druckzone
  var limit = pa.shape === 'circle' ? S * 0.5 * 0.88 : S * 0.5 * 0.9;
  function fits(k) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var xs = [it.x * k, (it.x + it.w) * k], ys = [it.y * k, (it.y + it.h) * k];
      for (var a = 0; a < 2; a++) for (var b = 0; b < 2; b++) {
        if (pa.shape === 'circle') { if (Math.hypot(xs[a], ys[b]) > limit) return false; }
        else if (Math.abs(xs[a]) > limit || Math.abs(ys[b]) > limit) return false;
      }
    }
    return true;
  }
  var k = 1;
  while (!fits(k) && k > 0.15) k *= 0.97;
  return { items: items, k: k, f0: f0, fp: fp, sym: sym };
}

function drawTextSymbol(ctx, W, H, pa) {
  if (!hasTextContent()) return;
  var S = Math.min(W, H);
  var L = layoutTextSymbol(ctx, S, pa);
  ctx.save();
  ctx.translate(W / 2, H / 2);
  ctx.scale(L.k, L.k);
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'middle';
  ctx.font = L.fp.weight + ' ' + L.f0 + 'px ' + L.fp.family;
  L.items.forEach(function (it) {
    if (it.t === 'sym' && isFlag(L.sym)) {
      drawFlag(ctx, SYMBOLS[L.sym].flag, it.x, it.y, it.w, it.h, S * FLAG_OUTLINE_PA / L.k);
    } else if (it.t === 'sym') {
      var path = symbolPath(L.sym);
      if (!path) return;
      ctx.save();
      ctx.translate(it.x, it.y);
      ctx.scale(it.w / 256, it.h / 256);
      ctx.fill(path);
      ctx.restore();
    } else {
      ctx.textAlign = it.align === 'left' ? 'left' : 'center';
      ctx.fillText(it.text, it.align === 'left' ? it.x : 0, it.y + it.h / 2);
    }
  });
  ctx.restore();
}

// ==========================================================================
// DRUCKDATEI (PNG, 300 DPI, transparent) — Geometrie unveraendert seit v1.2
// ==========================================================================
function exportPrintFile() {
  var pa = getActivePrintArea();
  var dpi = state.product.exportSettings.dpi;
  var pixelW, pixelH;
  if (pa.shape === 'circle') {
    var px = Math.round((pa.physicalDiameterMM / 25.4) * dpi);
    pixelW = pixelH = px;
  } else {
    pixelW = Math.round((pa.physicalWidthMM / 25.4) * dpi);
    pixelH = Math.round((pa.physicalHeightMM / 25.4) * dpi);
  }
  var c = document.createElement('canvas');
  c.width = pixelW; c.height = pixelH;
  drawDesign(c.getContext('2d'), pixelW, pixelH);
  return c.toDataURL('image/png');
}

// Druckflaechen-Textur fuer die Ball-Ansichten (gecacht je designVersion + Form)
var _tex = { version: -1, shape: null, canvas: null, data: null };
var TEX_SIZE = 512;
function getPrintTexture() {
  if (_tex.version === state.designVersion && _tex.shape === state.printShape && _tex.canvas) return _tex;
  var c = _tex.canvas || document.createElement('canvas');
  c.width = TEX_SIZE; c.height = TEX_SIZE;
  var g = c.getContext('2d');
  g.clearRect(0, 0, TEX_SIZE, TEX_SIZE);
  drawDesign(g, TEX_SIZE, TEX_SIZE);
  var data = null;
  try { data = g.getImageData(0, 0, TEX_SIZE, TEX_SIZE).data; } catch (e) { data = null; /* Canvas tainted (z. B. SVG in altem Safari) */ }
  _tex = { version: state.designVersion, shape: state.printShape, canvas: c, data: data };
  return _tex;
}

// Bogenlaengen-Projektion: Punkt auf der Einheitskugel (Front = +z, rechts = +x, unten = +y)
// -> Texel der Druckflaechen-Textur oder null
function sampleDecal(data, mx, my, mz, half) {
  if (!data || mz <= Math.cos(half * 1.02)) return null;
  var th = Math.acos(Math.min(1, mz));
  var rho = Math.hypot(mx, my) || 1e-6;
  var u = Math.floor((th * mx / rho / half * 0.5 + 0.5) * TEX_SIZE);
  var v = Math.floor((th * my / rho / half * 0.5 + 0.5) * TEX_SIZE);
  if (u < 0 || u >= TEX_SIZE || v < 0 || v >= TEX_SIZE) return null;
  var k = (v * TEX_SIZE + u) * 4;
  if (data[k + 3] === 0) return null;
  return k;
}


// ==========================================================================
// ASSETS (Ball-Foto, Normal-/ORM-Map) — lazy, gecacht
// ==========================================================================
function loadImg(url) {
  return new Promise(function (resolve, reject) {
    if (!url) { reject(new Error('no url')); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { resolve(img); };
    img.onerror = function () { reject(new Error('load ' + url)); };
    img.src = url;
  });
}
function imgData(img) {
  var c = document.createElement('canvas');
  c.width = img.naturalWidth; c.height = img.naturalHeight;
  var g = c.getContext('2d');
  g.drawImage(img, 0, 0);
  return { w: c.width, h: c.height, data: g.getImageData(0, 0, c.width, c.height).data };
}

var MAPS = { osn: null, orm: null, photo: {}, _p: null, _photoP: {} };
function ensureMaps() {
  if (MAPS._p) return MAPS._p;
  MAPS._p = Promise.all([loadImg(ASSETS.osNormal), loadImg(ASSETS.orm)]).then(function (r) {
    MAPS.osn = imgData(r[0]);
    MAPS.orm = imgData(r[1]);
    requestRender();
  }).catch(function (e) { console.warn('[bc] Ball-Maps nicht geladen', e); });
  return MAPS._p;
}
function ensurePhoto(color) {
  if (MAPS._photoP[color]) return MAPS._photoP[color];
  var url = color === 'yellow' ? ASSETS.photoYellow : ASSETS.photoWhite;
  MAPS._photoP[color] = loadImg(url).then(function (img) {
    MAPS.photo[color] = { img: img, lref: {} };
    requestRender();
  }).catch(function (e) { console.warn('[bc] Ball-Foto nicht geladen', e); });
  return MAPS._photoP[color];
}

// Modellname fuer die Seitenansicht (wie auf dem echten Ball)
var _side = { name: null, data: null, canvas: null };
function sideTexture() {
  var name = state.product.name.toUpperCase();
  if (_side.name === name && _side.data) return _side;
  var c = document.createElement('canvas'); c.width = 512; c.height = 128;
  var g = c.getContext('2d');
  g.fillStyle = '#2A2A2A'; g.textAlign = 'center'; g.textBaseline = 'middle';
  g.font = '800 54px Inter, Arial, sans-serif';
  g.fillText(name, 256, 66);
  _side = { name: name, canvas: c, data: g.getImageData(0, 0, 512, 128).data };
  return _side;
}
var SIDE_U = 0.44, SIDE_V = 0.11;

// Werksaufdrucke fuer die 3D-Ansicht nach dem TaylorMade-Layout (Artwork Approval Form, 2 Pole) und dem
// aktuellen Ballaufdruck (TP5-Produktfoto, 2026-10-08):
// Pol 1 = Kundendruck (+z), Pol 2 gegenueber (-z, bleibt frei), Modellname mit Doppellinien auf der Naht (-x),
// T-Zeichen + „aylorMade“ + Ballnummer auf den Polen (+y / -y). Von -y aus gesehen liegt der Modellname links
// und laeuft von unten nach oben, wie auf dem Foto. right x up = Aussennormale, sonst waere der Aufdruck gespiegelt.
// Der Modellname ist bewusst generisch gesetzt (eine Gestaltung fuer alle Modelle, keine Modell-Artworks).
var BALL_NUMBER = '1';
// T-Zeichen aus dem offiziellen TaylorMade-Logo (Header-SVG taylormadegolf.eu), Einheiten 0..158 x 0..153
var TM_T_PATH = 'M87.7,0.0 C54.2,0.2 25.4,13.9 8.5,33.6 C69.8,20.8 120.1,25.5 157.6,31.5 C157.7,30.5 157.9,29.4 158.1,28.5 C158.1,28.2 158.0,28.0 158.1,27.7 L158.1,27.0 C158.3,22.3 155.8,17.8 151.6,15.7 C129.7,4.5 107.8,-0.1 87.7,0.0 L87.7,0.0 Z M62.2,59.6 C60.6,59.6 58.8,59.7 56.9,59.9 C30.9,63.4 10.7,70.0 -0.0,74.2 C0.4,76.5 1.0,77.9 1.0,78.1 C1.1,78.1 1.2,78.6 1.2,78.6 C5.6,93.5 20.2,110.7 44.6,129.8 C45.5,130.5 46.4,131.2 47.2,131.8 C61.6,110.6 69.4,94.4 74.9,77.4 C79.2,64.1 74.0,59.2 62.2,59.6 L62.2,59.6 Z M140.4,60.0 C139.2,60.1 138.0,60.2 136.8,60.3 C121.7,61.6 116.0,71.9 107.7,85.0 C101.3,95.3 80.4,132.0 71.4,147.9 C82.0,153.0 91.8,153.3 102.6,149.9 C110.0,147.5 113.7,145.6 117.9,142.6 C119.3,141.5 120.6,140.5 121.5,139.2 L121.8,138.7 C122.0,138.5 122.1,138.4 122.2,138.2 C135.8,117.0 145.5,84.7 150.1,67.2 C150.7,65.2 151.2,63.0 151.7,60.9 C147.6,60.2 143.9,60.0 140.4,60.0 L140.4,60.0 Z';
var STAMP_FONT = 'Inter, "Helvetica Neue", Helvetica, Arial, sans-serif';
function stampCanvas(w, h, draw) {
  var c = document.createElement('canvas'); c.width = w; c.height = h;
  var g = c.getContext('2d');
  g.fillStyle = '#1E1E1E'; g.textBaseline = 'alphabetic';
  draw(g);
  return g.getImageData(0, 0, w, h).data;
}
// Pol-Aufdruck in Canvas-Pixeln (720 x 400, Mitte = Pol): T-Zeichen + „aylorMade“ + Ballnummer.
// T zu Schrift wie im offiziellen Logo-SVG (relativ zur T-Hoehe): Versalien-Oberkante 0,157, Grundlinie 0,712.
// „1“ 1,12 T hoch, 0,65 T unter der Grundlinie, mittig unter dem „r“ von Taylor (Inhaber-Abstimmung 2026-10-08).
// Schrift laeuft auf dem Ball breiter als Inter -> leichte Sperrung.
var WM = { w: 720, h: 400, th: 150, y0: 12, txt: 'aylorMade' };
function wordmarkStamp(g) {
  var th = WM.th, k = th / 153, tw = 158 * k, gap = 0.05 * th;
  var fs = Math.round((0.712 - 0.157) * th / 0.727);      // Inter: Versalhoehe 0,727 em
  g.font = '400 ' + fs + 'px ' + STAMP_FONT;
  if ('letterSpacing' in g) g.letterSpacing = Math.round(fs * 0.06) + 'px';
  var txtW = g.measureText(WM.txt).width, ww = tw + gap + txtW, x0 = (WM.w - ww) / 2, tx = x0 + tw + gap;
  var rX = tx + (g.measureText('aylo').width + g.measureText('aylor').width) / 2;
  g.save(); g.translate(x0, WM.y0); g.scale(k, k); g.fill(new Path2D(TM_T_PATH)); g.restore();
  g.fillText(WM.txt, tx, WM.y0 + 0.712 * th);
  if ('letterSpacing' in g) g.letterSpacing = '0px';
  var nh = 1.12 * th, nfs = Math.round(nh / 0.727);
  g.font = '400 ' + nfs + 'px ' + STAMP_FONT; g.textAlign = 'center';
  g.fillText(BALL_NUMBER, rX, WM.y0 + (0.712 + 0.65) * th + nh);
}
function modelStamp(g) {
  var name = state.product.name;
  g.font = 'italic 800 84px ' + STAMP_FONT; g.textAlign = 'center';
  var tw = g.measureText(name).width, cx = 512, gap = 26, sk = 10;
  g.fillText(name, cx, 94);
  // Doppellinien vor und nach dem Namen (wie TP5-Sidestamp), Enden kursiv angeschnitten
  [[34, 0], [60, 46]].forEach(function (ln) {
    var y = ln[0], inset = ln[1];
    [-1, 1].forEach(function (dir) {
      var xi = cx + dir * (tw / 2 + gap), xo = dir < 0 ? 40 + inset : 984 - inset;
      if (dir * (xo - xi) <= 20) return;
      g.beginPath();
      g.moveTo(xi + sk, y); g.lineTo(xo + sk, y); g.lineTo(xo - sk, y + 8); g.lineTo(xi - sk, y + 8);
      g.closePath(); g.fill();
    });
  });
}
function factoryStamps() {
  var wordmark = stampCanvas(WM.w, WM.h, wordmarkStamp);
  var model = stampCanvas(1024, 128, modelStamp);
  // Pol-Aufdruck orthografisch (flaches Motiv entlang der Pol-Achse aufgebracht, wie beim Tampondruck):
  // senkrechte Linien liegen in Ebenen parallel zur Achse und bleiben beim Kippen gerade. Die Bogenlaengen-
  // Projektion bog Schriftzug und „1“ (Inhaber-Feedback 2026-10-08).
  // Massstab am TP5-Foto: T ~4,6 mm hoch (150 px), Gesamtbreite ~22 mm
  var hu = 0.5, hv = hu * WM.h / WM.w;
  return [
    { data: model, w: 1024, h: 128, hu: 0.7, hv: 0.7 * 128 / 1024, axis: [-1, 0, 0], right: [0, 0, 1], up: [0, 1, 0] },
    // Gegenpol so ausgerichtet, dass er nach einer halben Drehung um die Senkrechte aufrecht steht
    { data: wordmark, w: WM.w, h: WM.h, hu: hu, hv: hv, ortho: true, axis: [0, -1, 0], right: [1, 0, 0], up: [0, 0, 1] },
    { data: wordmark, w: WM.w, h: WM.h, hu: hu, hv: hv, ortho: true, axis: [0, 1, 0], right: [-1, 0, 0], up: [0, 0, 1] }
  ];
}
// Aufdruck per Bogenlaengen-Projektion um die Stempel-Achse in die Equirect-Farbkarte schreiben
function paintStamp(g, W, H, s) {
  var r0 = Math.hypot(s.hu, s.hv), TWO_PI = Math.PI * 2;
  var m = (s.ortho ? Math.asin(Math.min(1, r0)) : r0) + 0.03; // ortho: hu/hv sind Sinus-Einheiten
  var ax = s.axis, thA = Math.acos(ax[1]);
  var j0 = Math.max(0, Math.floor((thA - m) / Math.PI * H)), j1 = Math.min(H, Math.ceil((thA + m) / Math.PI * H));
  var reg = g.getImageData(0, j0, W, j1 - j0), d = reg.data, cosM = Math.cos(m);
  for (var j = j0; j < j1; j++) {
    var th = (j + 0.5) / H * Math.PI, st = Math.sin(th), y = Math.cos(th);
    for (var i = 0; i < W; i++) {
      var ph = (i + 0.5) / W * TWO_PI;
      var x = -Math.cos(ph) * st, z = Math.sin(ph) * st;
      var dot = x * ax[0] + y * ax[1] + z * ax[2];
      if (dot <= cosM) continue;
      var uu, vv;
      if (s.ortho) {
        uu = x * s.right[0] + y * s.right[1] + z * s.right[2];
        vv = x * s.up[0] + y * s.up[1] + z * s.up[2];
      } else {
        var tx = x - ax[0] * dot, ty = y - ax[1] * dot, tz = z - ax[2] * dot;
        var a = Math.acos(Math.min(1, dot)), tl = Math.hypot(tx, ty, tz) || 1e-6;
        uu = a * (tx * s.right[0] + ty * s.right[1] + tz * s.right[2]) / tl;
        vv = a * (tx * s.up[0] + ty * s.up[1] + tz * s.up[2]) / tl;
      }
      if (uu <= -s.hu || uu >= s.hu || vv <= -s.hv || vv >= s.hv) continue;
      var su = ((uu / s.hu * 0.5 + 0.5) * s.w) | 0, sv = ((0.5 - vv / s.hv * 0.5) * s.h) | 0;
      var sk = (sv * s.w + su) * 4, al = s.data[sk + 3] / 255 * 0.95;
      if (al <= 0) continue;
      var o = ((j - j0) * W + i) * 4;
      d[o] = d[o] * (1 - al) + s.data[sk] * al; d[o + 1] = d[o + 1] * (1 - al) + s.data[sk + 1] * al; d[o + 2] = d[o + 2] * (1 - al) + s.data[sk + 2] * al;
    }
  }
  g.putImageData(reg, 0, j0);
}

// ==========================================================================
// KONTAKTSCHATTEN
// ==========================================================================
function drawContactShadow(ctx, S) {
  var R = S * BALL.r, cx = S * BALL.cx, cy = S * BALL.cy;
  ctx.save(); ctx.translate(cx, cy + R * 1.0); ctx.scale(1, 0.13);
  var sh = ctx.createRadialGradient(0, 0, 0, 0, 0, R * 1.05);
  sh.addColorStop(0, 'rgba(20,18,14,0.38)'); sh.addColorStop(0.45, 'rgba(20,18,14,0.14)'); sh.addColorStop(1, 'rgba(20,18,14,0)');
  ctx.fillStyle = sh; ctx.fillRect(-R * 1.1, -R * 1.1, R * 2.2, R * 2.2); ctx.restore();
  ctx.save(); ctx.translate(cx, cy + R * 0.985); ctx.scale(1, 0.09);
  sh = ctx.createRadialGradient(0, 0, 0, 0, 0, R * 0.45);
  sh.addColorStop(0, 'rgba(10,8,6,0.5)'); sh.addColorStop(1, 'rgba(10,8,6,0)');
  ctx.fillStyle = sh; ctx.fillRect(-R, -R, 2 * R, 2 * R); ctx.restore();
}

// ==========================================================================
// PROZEDURALER BALL (V1, drehbar) — Normalen + AO aus gebackenen Equirect-Maps
// Licht: Key oben links, Fill rechts, Softbox-Reflexion mit Fresnel, weiche Tonkurve.
// ==========================================================================
function nrm3(x, y, z) { var l = Math.hypot(x, y, z); return [x / l, y / l, z / l]; }
var LIGHT = (function () {
  var L1 = nrm3(-0.55, -0.70, 0.72), L2 = nrm3(0.80, 0.10, 0.55);
  return { L1: L1, L2: L2, H1: nrm3(L1[0], L1[1], L1[2] + 1), LS: nrm3(-0.45, -0.80, 0.40) };
})();
function tone(c) {
  c = c < 0 ? 0 : c * 1.26;
  if (c > 0.82) { var e = c - 0.82; c = 0.82 + e / (1 + e / 0.17); }
  return c > 1 ? 255 : c * 255;
}

function renderProcedural(ctx, S, angleDeg, color) {
  var osn = MAPS.osn, orm = MAPS.orm;
  var R = S * BALL.r, cx = S * BALL.cx, cy = S * BALL.cy;
  var a = angleDeg * Math.PI / 180, ca = Math.cos(a), sa = Math.sin(a);
  drawContactShadow(ctx, S);
  var W = Math.ceil(2 * R) + 4, x0 = Math.floor(cx - R) - 2, y0 = Math.floor(cy - R) - 2;
  var off = document.createElement('canvas'); off.width = W; off.height = W;
  var octx = off.getContext('2d');
  var img = octx.createImageData(W, W), d = img.data;
  var alb = color === 'yellow' ? [1.0, 0.95, 0.22] : [0.965, 0.962, 0.95];
  var L = LIGHT, L1 = L.L1, L2 = L.L2, H1 = L.H1, LS = L.LS;
  var tex = getPrintTexture(), td = tex.data;
  var half = printHalfAngle(getActivePrintArea());
  var side = sideTexture(), sd = side.data, cosSide = Math.cos(SIDE_U + 0.05);
  var MW = osn.w, MH = osn.h, on = osn.data, om = orm.data, TWO_PI = Math.PI * 2;

  for (var j = 0; j < W; j++) {
    for (var i = 0; i < W; i++) {
      var sx = (x0 + i + 0.5 - cx) / R, sy = (y0 + j + 0.5 - cy) / R;
      var r2 = sx * sx + sy * sy;
      if (r2 >= 1.0) continue;
      var dist = Math.sqrt(r2);
      var edge = (1 - dist) * R + 0.5; edge = edge > 1 ? 1 : edge;
      var sz = Math.sqrt(1 - r2);
      // Modellraum (Front = +z, rechts = +x, unten = +y)
      var mx = ca * sx - sa * sz, my = sy, mz = sa * sx + ca * sz;
      // Equirect-Lookup im Bake-Raum (y nach oben)
      var phi = Math.atan2(mz, -mx); if (phi < 0) phi += TWO_PI;
      var u = (phi / TWO_PI * MW) | 0; if (u >= MW) u = MW - 1;
      var v = (Math.acos(-my < -1 ? -1 : -my > 1 ? 1 : -my) / Math.PI * MH) | 0; if (v >= MH) v = MH - 1;
      var k = (v * MW + u) * 4;
      var nx = on[k] / 127.5 - 1, ny = -(on[k + 1] / 127.5 - 1), nz = on[k + 2] / 127.5 - 1;
      var ao = 1 - (1 - om[k] / 255) * 0.35;
      // zurueck in den Bildraum
      var qx = ca * nx + sa * nz, qy = ny, qz = -sa * nx + ca * nz;

      var ar = alb[0], ag = alb[1], ab = alb[2];
      var tk = sampleDecal(td, mx, my, mz, half);
      if (tk !== null) {
        var al = td[tk + 3] / 255 * 0.97;
        ar = ar * (1 - al) + td[tk] / 255 * al; ag = ag * (1 - al) + td[tk + 1] / 255 * al; ab = ab * (1 - al) + td[tk + 2] / 255 * al;
      }
      if (-mx > cosSide) {
        var th = Math.acos(-mx > 1 ? 1 : -mx), rho = Math.hypot(my, mz) || 1e-6;
        var uu = th * mz / rho, vv = th * my / rho;
        if (uu > -SIDE_U && uu < SIDE_U && vv > -SIDE_V && vv < SIDE_V) {
          var su = ((uu / SIDE_U * 0.5 + 0.5) * 512) | 0, sv = ((vv / SIDE_V * 0.5 + 0.5) * 128) | 0;
          var sk = (sv * 512 + su) * 4, sal = sd[sk + 3] / 255 * 0.95;
          if (sal > 0) { ar = ar * (1 - sal) + sd[sk] / 255 * sal; ag = ag * (1 - sal) + sd[sk + 1] / 255 * sal; ab = ab * (1 - sal) + sd[sk + 2] / 255 * sal; }
        }
      }

      var d1 = qx * L1[0] + qy * L1[1] + qz * L1[2]; if (d1 < 0) d1 = 0;
      var d2 = qx * L2[0] + qy * L2[1] + qz * L2[2]; if (d2 < 0) d2 = 0;
      var sky = 0.5 - 0.5 * qy;
      var diff = (0.34 + 0.12 * sky + 0.50 * d1 + 0.12 * d2) * ao;
      var nh = qx * H1[0] + qy * H1[1] + qz * H1[2]; if (nh < 0) nh = 0;
      var spec = (0.10 * Math.pow(nh, 200) + 0.025 * Math.pow(nh, 20)) * (0.6 + 0.4 * ao);
      var rx = 2 * qz * qx, ry = 2 * qz * qy, rz = 2 * qz * qz - 1;
      var sb = rx * LS[0] + ry * LS[1] + rz * LS[2];
      var box = sb > 0.8 ? Math.min(1, (sb - 0.8) / 0.12) : 0;
      var fres = 0.025 + 0.28 * Math.pow(1 - (qz > 0 ? qz : 0), 5);
      var env = fres * (0.55 * (0.5 - 0.5 * ry) + 1.3 * box);
      var limb = 0.84 + 0.16 * Math.pow(sz, 0.6);
      var o = (j * W + i) * 4;
      d[o] = tone(ar * diff * limb + spec + env);
      d[o + 1] = tone(ag * diff * limb + spec + env);
      d[o + 2] = tone(ab * diff * limb + spec + env);
      d[o + 3] = 255 * edge;
    }
  }
  octx.putImageData(img, 0, 0);
  ctx.drawImage(off, x0, y0);
}

// ==========================================================================
// FOTO-FRONT (V1, Vorderseite) — Logo/Text wird auf das Ball-Foto projiziert:
// Druckfarbe x Foto-Helligkeit (Dimples schattieren die Farbe) + Glanz.
// ==========================================================================
function renderPhotoFront(ctx, S, color) {
  var ph = MAPS.photo[color];
  ctx.drawImage(ph.img, 0, 0, S, S);
  // Fotorand weich ausblenden, damit der Foto-Hintergrund nahtlos in die Buehne uebergeht
  ctx.save();
  ctx.globalCompositeOperation = 'destination-in';
  var fade = ctx.createRadialGradient(S * 0.5, S * 0.5, S * 0.42, S * 0.5, S * 0.5, S * 0.5);
  fade.addColorStop(0, 'rgba(0,0,0,1)'); fade.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = fade; ctx.fillRect(0, 0, S, S);
  ctx.restore();
  var tex = getPrintTexture(), td = tex.data;
  var pa = getActivePrintArea(), half = printHalfAngle(pa);
  var R = S * BALL.r, cx = S * BALL.cx, cy = S * BALL.cy;
  if (!td) {
    // Fallback (Textur nicht lesbar): flach in die Druckflaeche legen
    var side = 2 * Math.sin(half) * R;
    ctx.drawImage(tex.canvas, cx - side / 2, cy - side / 2, side, side);
    return;
  }
  var ext = Math.ceil(Math.sin(Math.min(half * 1.05, 1.5)) * R) + 2;
  var x0 = Math.max(0, Math.floor(cx - ext)), y0 = Math.max(0, Math.floor(cy - ext));
  var w = Math.min(S - x0, 2 * ext), h = Math.min(S - y0, 2 * ext);
  var id = ctx.getImageData(x0, y0, w, h), d = id.data;
  var lref = ph.lref[S];
  if (!lref) {
    var samples = [];
    for (var yy = 0; yy < h; yy += 3) for (var xx = 0; xx < w; xx += 3) {
      var q = (yy * w + xx) * 4;
      samples.push(0.2126 * d[q] + 0.7152 * d[q + 1] + 0.0722 * d[q + 2]);
    }
    samples.sort(function (p1, p2) { return p1 - p2; });
    lref = ph.lref[S] = samples[Math.floor(samples.length * 0.75)] || 230;
  }
  for (var j = 0; j < h; j++) {
    for (var i = 0; i < w; i++) {
      var nx = (x0 + i + 0.5 - cx) / R, ny = (y0 + j + 0.5 - cy) / R, r2 = nx * nx + ny * ny;
      if (r2 >= 0.985) continue;
      var tk = sampleDecal(td, nx, ny, Math.sqrt(1 - r2), half);
      if (tk === null) continue;
      var a = td[tk + 3] / 255 * 0.97;
      var k = (j * w + i) * 4;
      var shade = (0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2]) / lref;
      var s = shade < 1 ? shade : 1, gloss = shade > 1 ? (shade - 1) * 255 * 0.85 : 0;
      for (var ch = 0; ch < 3; ch++) {
        var ink = td[tk + ch] * (0.35 + 0.65 * s) + gloss;
        d[k + ch] = d[k + ch] * (1 - a) + (ink > 255 ? 255 : ink) * a;
      }
    }
  }
  ctx.putImageData(id, x0, y0);
}

// Einfacher Platzhalter-Ball, solange Maps/Foto laden (kein Layout-Sprung)
function renderPlaceholder(ctx, S, color) {
  var R = S * BALL.r, cx = S * BALL.cx, cy = S * BALL.cy;
  drawContactShadow(ctx, S);
  var isY = color === 'yellow';
  var g = ctx.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.05, cx, cy, R);
  g.addColorStop(0, isY ? '#FBF27A' : '#FFFFFF'); g.addColorStop(0.6, isY ? '#EBDA3A' : '#EDEDEA'); g.addColorStop(1, isY ? '#C7B526' : '#CFCFCB');
  ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill();
  var tex = getPrintTexture(), half = printHalfAngle(getActivePrintArea()), side = 2 * Math.sin(half) * R;
  ctx.drawImage(tex.canvas, cx - side / 2, cy - side / 2, side, side);
}

// Realansicht 2D: Foto vorne, sonst prozedural; waehrend Laden Platzhalter
function renderReal2D(ctx, S, angleDeg) {
  var color = state.color;
  if (angleDeg === 0 && MAPS.photo[color]) { renderPhotoFront(ctx, S, color); return 'photo'; }
  if (angleDeg === 0) ensurePhoto(color);
  if (MAPS.osn && MAPS.orm) { renderProcedural(ctx, S, angleDeg, color); return 'procedural'; }
  ensureMaps();
  renderPlaceholder(ctx, S, color);
  return 'placeholder';
}

// ==========================================================================
// DRUCKFLAECHEN-ANSICHT (flach, Bemassung) — hier wird das Logo positioniert
// ==========================================================================
var printGeom = null; // in CSS-Pixeln, fuer Pointer-Mapping
function renderPrintView(ctx, S) {
  var pa = getActivePrintArea();
  ctx.fillStyle = '#F7F5F1'; ctx.fillRect(0, 0, S, S);
  var side = Math.round(S * 0.72), x0 = Math.round((S - side) / 2), y0 = Math.round(S * 0.08);
  ctx.save();
  ctx.beginPath();
  if (pa.shape === 'circle') ctx.arc(x0 + side / 2, y0 + side / 2, side / 2, 0, Math.PI * 2);
  else ctx.rect(x0, y0, side, side);
  ctx.fillStyle = '#FFFFFF'; ctx.fill();
  ctx.restore();
  var off = document.createElement('canvas'); off.width = side; off.height = side;
  drawDesign(off.getContext('2d'), side, side);
  ctx.drawImage(off, x0, y0);
  // Rahmen, Hilfslinien
  var lw = Math.max(1, S / 400);
  ctx.save();
  ctx.strokeStyle = 'rgba(0,96,57,0.18)'; ctx.lineWidth = lw; ctx.setLineDash([6 * lw, 6 * lw]);
  ctx.beginPath(); ctx.moveTo(x0 + side / 2, y0); ctx.lineTo(x0 + side / 2, y0 + side);
  ctx.moveTo(x0, y0 + side / 2); ctx.lineTo(x0 + side, y0 + side / 2); ctx.stroke();
  ctx.setLineDash([]);
  ctx.strokeStyle = state.ui.dragging ? 'rgba(0,96,57,0.9)' : '#006039'; ctx.lineWidth = 1.5 * lw;
  ctx.beginPath();
  if (pa.shape === 'circle') ctx.arc(x0 + side / 2, y0 + side / 2, side / 2, 0, Math.PI * 2);
  else ctx.rect(x0, y0, side, side);
  ctx.stroke();
  // Bemassung
  var yb = y0 + side + S * 0.06;
  ctx.strokeStyle = '#555555'; ctx.lineWidth = lw;
  ctx.beginPath();
  ctx.moveTo(x0, yb); ctx.lineTo(x0 + side, yb);
  ctx.moveTo(x0, yb - S * 0.012); ctx.lineTo(x0, yb + S * 0.012);
  ctx.moveTo(x0 + side, yb - S * 0.012); ctx.lineTo(x0 + side, yb + S * 0.012);
  ctx.stroke();
  ctx.fillStyle = '#111111'; ctx.textAlign = 'center'; ctx.textBaseline = 'top';
  ctx.font = '600 ' + Math.round(S * 0.032) + 'px Inter, Arial, sans-serif';
  ctx.fillText(pa.shape === 'circle' ? t('chipAreaCircle') : t('chipAreaSquare'), x0 + side / 2, yb + S * 0.022);
  ctx.restore();
  printGeom = { x0: x0 / DPR, y0: y0 / DPR, side: side / DPR };
}


// ==========================================================================
// V2: ECHTES 3D (WebGL, three.js r128 self-hosted) — wird nur bei ball=webgl geladen.
// Studio-HDRI (Poly Haven studio_small_08, CC0) als Base64-JS, Normal- + ORM-Map gebacken.
// Faellt bei jedem Fehler auf V1 zurueck.
// ==========================================================================
var GL = { status: 'idle', p: null, rot: { x: 0, y: 0 }, front: true, colorKey: null, version: -1, shape: null };
var GL_CAM_DIST = 6.84;     // Ballradius 0.38 der Canvas-Kante bei FOV 22
var GL_BALL_Y = 0.08;       // Ballmitte bei 0.47 der Kante (wie Foto/prozedural)
var GL_MAP_W = 2048, GL_MAP_H = 1024;
// Material pro Farbe. Gelb wirkte mit den Weiss-Werten spiegelnd und mit harten Dimple-Schatten
// (Inhaber-Feedback 2026-10-08): weniger Lack, weicherer Reflex, flachere Dimples, schwaecheres AO.
var GL_LOOK = {
  white:  { coat: 0.7,  coatRough: 0.08, env: 0.8, refl: 0.5,  normal: 1.8, ao: 1.0 },
  yellow: { coat: 0.15, coatRough: 0.4,  env: 0.7, refl: 0.25, normal: 1.1, ao: 0.45 }
};

function loadScript(url) {
  return new Promise(function (resolve, reject) {
    if (!url) { reject(new Error('no url')); return; }
    var s = document.createElement('script');
    s.src = url; s.async = true;
    s.onload = function () { resolve(); };
    s.onerror = function () { reject(new Error('script ' + url)); };
    document.head.appendChild(s);
  });
}

function glFail(e) {
  console.warn('[bc] WebGL-Ansicht nicht verfuegbar, Rueckfall auf V1', e);
  GL.status = 'failed';
  BALL_MODE = 'photo_procedural';
  var c = $('#ballCanvasGL'); if (c) c.style.display = 'none';
  requestRender();
}

function ensureGL() {
  if (GL.p) return GL.p;
  GL.status = 'loading';
  GL.p = loadScript(ASSETS.three)
    .then(function () { return loadScript(ASSETS.rgbe); })
    .then(function () { return loadScript(ASSETS.hdr); })
    .then(initGL)
    .catch(glFail);
  return GL.p;
}

function initGL() {
  var T = window.THREE;
  if (!T || !T.RGBELoader || !window.BC_STUDIO_HDR) throw new Error('three/rgbe/hdr fehlt');
  var canvas = $('#ballCanvasGL');
  var renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, preserveDrawingBuffer: true });
  renderer.setPixelRatio(DPR);
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.physicallyCorrectLights = true;
  var scene = new T.Scene();
  var camera = new T.PerspectiveCamera(22, 1, 0.1, 50);
  camera.position.set(0, 0, GL_CAM_DIST);

  // Kontaktschatten als Ebene
  var sc = document.createElement('canvas'); sc.width = sc.height = 256;
  var sg = sc.getContext('2d');
  var gr = sg.createRadialGradient(128, 128, 0, 128, 128, 128);
  gr.addColorStop(0, 'rgba(20,16,10,0.55)'); gr.addColorStop(0.35, 'rgba(20,16,10,0.22)'); gr.addColorStop(1, 'rgba(20,16,10,0)');
  sg.fillStyle = gr; sg.fillRect(0, 0, 256, 256);
  var shadow = new T.Mesh(new T.PlaneGeometry(2.6, 2.6), new T.MeshBasicMaterial({ map: new T.CanvasTexture(sc), transparent: true, depthWrite: false, toneMapped: false }));
  shadow.rotation.x = -Math.PI / 2; shadow.position.y = -1 + GL_BALL_Y; shadow.scale.set(1, 0.9, 1);
  scene.add(shadow);

  var geo = new T.SphereGeometry(1, 192, 128);
  geo.setAttribute('uv2', geo.attributes.uv);
  var colorCanvas = document.createElement('canvas');
  colorCanvas.width = GL_MAP_W; colorCanvas.height = GL_MAP_H;
  var colorTex = new T.CanvasTexture(colorCanvas);
  colorTex.encoding = T.sRGBEncoding;
  colorTex.anisotropy = renderer.capabilities.getMaxAnisotropy();
  // Auf das Ball-Foto abgestimmt (2026-10-07): schaerfere Dimples, Fuehrungslicht oben links, etwas weniger Lackreflex
  var mat = new T.MeshPhysicalMaterial({ map: colorTex, roughness: 1.0, metalness: 0, clearcoat: 0.7, clearcoatRoughness: 0.08, envMapIntensity: 0.8 });
  // Normal-Map zum Silhouettenrand ausblenden: sonst kippen die Dimple-Normalen am Rand von der Kamera weg
  // und spiegeln das Studio als weisse Sicheln (Inhaber-Screenshot 2026-10-08)
  mat.onBeforeCompile = function (sh) {
    sh.fragmentShader = sh.fragmentShader.replace('#include <normal_fragment_maps>',
      '#include <normal_fragment_maps>\n' +
      'float bcNdv = clamp(dot(geometryNormal, normalize(vViewPosition)), 0.0, 1.0);\n' +
      'normal = normalize(mix(geometryNormal, normal, smoothstep(0.03, 0.34, bcNdv)));');
  };
  var ball = new T.Mesh(geo, mat);
  ball.position.y = GL_BALL_Y;
  // Erst kippen (x), dann um die Bildschirm-Senkrechte drehen (y): seitliches Ziehen dreht den Ball immer
  // nach links/rechts. Mit XYZ rollte er nach dem Hochkippen in der Bildebene (Logo/Nummer schief, 2026-10-08).
  ball.rotation.order = 'YXZ';
  scene.add(ball);
  var key = new T.DirectionalLight(0xffffff, 2.0);
  key.position.set(-3, 4, 5);
  scene.add(key);
  GL.renderer = renderer; GL.scene = scene; GL.camera = camera; GL.ball = ball; GL.mat = mat;
  GL.colorCanvas = colorCanvas; GL.colorTex = colorTex;

  var bin = atob(window.BC_STUDIO_HDR);
  var bytes = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  var hdrUrl = URL.createObjectURL(new Blob([bytes]));
  var tl = new T.TextureLoader();
  tl.setCrossOrigin('anonymous');
  function load(u) { return new Promise(function (res, rej) { tl.load(u, res, undefined, rej); }); }
  var hdr = new Promise(function (res, rej) { new T.RGBELoader().setDataType(T.UnsignedByteType).load(hdrUrl, res, undefined, rej); });

  // Werksaufdrucke werden einmal in die Farbkarte gebacken: vorher Inter laden, sonst bleibt der Fallback-Font stehen
  var fonts = document.fonts ? Promise.all(['400 100px Inter', 'italic 800 84px Inter'].map(function (f) {
    return document.fonts.load(f);
  })).catch(function () {}) : null;
  return Promise.all([hdr, load(ASSETS.normal), load(ASSETS.orm), fonts]).then(function (r) {
    var pmrem = new T.PMREMGenerator(renderer);
    var envScene = new T.Scene();
    var sky = new T.Mesh(new T.SphereGeometry(10, 64, 32), new T.MeshBasicMaterial({ map: r[0], side: T.BackSide }));
    sky.rotation.y = -0.9; // Hauptlicht von links
    envScene.add(sky);
    scene.environment = pmrem.fromScene(envScene, 0).texture;
    URL.revokeObjectURL(hdrUrl);
    var an = renderer.capabilities.getMaxAnisotropy();
    r[1].anisotropy = an; r[2].anisotropy = an;
    mat.normalMap = r[1]; mat.normalScale = new T.Vector2(1.8, 1.8); mat.aoMap = r[2]; mat.roughnessMap = r[2];
    mat.needsUpdate = true;
    GL.status = 'ready';
    // hybrid: wurde vor dem Laden schon gedreht, dort in 3D weitermachen
    if (BALL_MODE === 'hybrid' && state.angle > 0 && ROT_PRESETS[state.angle]) {
      GL.front = false; GL.rot = { x: ROT_PRESETS[state.angle].x, y: ROT_PRESETS[state.angle].y };
    }
    requestRender();
  });
}

// Farbkarte: Grundfarbe + Werksaufdrucke (Modell -x, TaylorMade +-y) + Druckflaechen-Decal (Front, +z)
function glUpdateColorMap() {
  var colorKey = state.color + '|' + state.product.id;
  var full = GL.colorKey !== colorKey;
  if (!full && GL.version === state.designVersion && GL.shape === state.printShape) return;
  var g = GL.colorCanvas.getContext('2d');
  var base = state.color === 'yellow' ? [255, 222, 0] : [247, 247, 244];
  var baseCss = 'rgb(' + base.join(',') + ')';
  var W = GL_MAP_W, H = GL_MAP_H, TWO_PI = Math.PI * 2;
  if (full) {
    g.fillStyle = baseCss; g.fillRect(0, 0, W, H);
    factoryStamps().forEach(function (st) { paintStamp(g, W, H, st); });
  }
  // Decal-Bereich um die Front (phi = PI/2 -> Spalte W/4, theta = PI/2 -> Zeile H/2)
  var tex = getPrintTexture(), td = tex.data, half = printHalfAngle(getActivePrintArea());
  var hmax = 0.62;
  var cw2 = Math.ceil(hmax / TWO_PI * W) + 2, rh2 = Math.ceil(hmax / Math.PI * H) + 2;
  var x0 = Math.floor(W / 4 - cw2), y0 = Math.floor(H / 2 - rh2), w = 2 * cw2, h = 2 * rh2;
  g.fillStyle = baseCss; g.fillRect(x0, y0, w, h);
  if (td) {
    var reg = g.getImageData(x0, y0, w, h), rd = reg.data;
    for (var jj = 0; jj < h; jj++) {
      var th2 = (y0 + jj + 0.5) / H * Math.PI, st2 = Math.sin(th2), ct2 = Math.cos(th2);
      for (var ii = 0; ii < w; ii++) {
        var ph2 = (x0 + ii + 0.5) / W * TWO_PI;
        var x = -Math.cos(ph2) * st2, y = ct2, z = Math.sin(ph2) * st2;
        var tk = sampleDecal(td, x, -y, z, half);
        if (tk === null) continue;
        var al2 = td[tk + 3] / 255 * 0.97, q = (jj * w + ii) * 4;
        rd[q] = rd[q] * (1 - al2) + td[tk] * al2; rd[q + 1] = rd[q + 1] * (1 - al2) + td[tk + 1] * al2; rd[q + 2] = rd[q + 2] * (1 - al2) + td[tk + 2] * al2;
      }
    }
    g.putImageData(reg, x0, y0);
  }
  GL.colorTex.needsUpdate = true;
  GL.colorKey = colorKey; GL.version = state.designVersion; GL.shape = state.printShape;
}

function glRender(cssSize) {
  var T = window.THREE, r = GL.renderer;
  var yellow = state.color === 'yellow';
  // Weiss: ACES (natuerliche Lichter); Gelb: linear (ACES zieht Gelb ins Olive)
  var tm = yellow ? T.LinearToneMapping : T.ACESFilmicToneMapping;
  if (r.toneMapping !== tm) { r.toneMapping = tm; GL.mat.needsUpdate = true; }
  r.toneMappingExposure = yellow ? 1.2 : 1.4;
  var lk = yellow ? GL_LOOK.yellow : GL_LOOK.white, m = GL.mat;
  m.clearcoat = lk.coat; m.clearcoatRoughness = lk.coatRough; m.envMapIntensity = lk.env; m.reflectivity = lk.refl;
  m.normalScale.set(lk.normal, lk.normal); m.aoMapIntensity = lk.ao;
  r.setSize(cssSize, cssSize, false);
  glUpdateColorMap();
  GL.ball.rotation.set(GL.rot.x, GL.rot.y, 0);
  r.render(GL.scene, GL.camera);
}

var _glAnim = null;
function glRotateTo(x, y, done) {
  if (_glAnim) cancelAnimationFrame(_glAnim);
  if (REDUCED_MOTION) { GL.rot.x = x; GL.rot.y = y; if (done) done(); requestRender(); return; }
  var sx = GL.rot.x, sy = GL.rot.y, t0 = performance.now(), dur = 320;
  (function step(now) {
    var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
    GL.rot.x = sx + (x - sx) * e; GL.rot.y = sy + (y - sy) * e;
    if (k >= 1 && done) done();
    renderNow();
    if (k < 1) _glAnim = requestAnimationFrame(step); else _glAnim = null;
  })(t0);
}
// Hybrid: zurueck zur Vorderseite -> nach der Drehung wieder auf das Foto ueberblenden
function glToFront() {
  glRotateTo(0, 0, function () { GL.front = true; });
}
function glNearFront() {
  var y = GL.rot.y % (Math.PI * 2); if (y > Math.PI) y -= Math.PI * 2; if (y < -Math.PI) y += Math.PI * 2;
  return Math.abs(GL.rot.x) < 0.09 && Math.abs(y) < 0.09;
}


// ==========================================================================
// BUEHNE: Groesse, Render-Planung, Mini-Ball, Hinweise
// ==========================================================================
var cv2d = null, ctx2d = null, cvGL = null, wrapper = null, miniCv = null;
var _rafPending = false, _lastReal = null, _lastRealKind = null;

function stageCssSize() {
  if (!wrapper) return 400;
  var s = Math.floor(Math.min(wrapper.clientWidth, wrapper.clientHeight));
  return s > 80 ? s : 320;
}

function requestRender() {
  if (_rafPending) return;
  _rafPending = true;
  requestAnimationFrame(function () { _rafPending = false; renderNow(); });
}

// true, wenn Drehen in der Realansicht ueber WebGL laeuft (webgl immer, hybrid sobald geladen)
function useGL() {
  if (state.view !== 'real' || GL.status === 'failed') return false;
  if (BALL_MODE === 'webgl') return true;
  return BALL_MODE === 'hybrid' && GL.status === 'ready';
}
function setGLVisible(on) {
  if (!cvGL) return;
  cvGL.style.display = '';
  cvGL.style.opacity = on ? '1' : '0';
  cvGL.style.pointerEvents = on ? '' : 'none';
}

function renderNow() {
  if (!cv2d) return;
  var css = stageCssSize();
  var glActive = useGL();
  if (BALL_MODE !== 'photo_procedural' && GL.status === 'idle') ensureGL();
  var glReady = state.view === 'real' && BALL_MODE !== 'photo_procedural' && GL.status === 'ready';
  // hybrid: Foto, solange die Vorderseite gezeigt wird; beim Drehen echtes 3D darueber
  var showGL = glReady && (BALL_MODE === 'webgl' || !GL.front);

  if (state.view === 'size') {
    // Ball 42,67 mm: Canvas-Kante = 42,67 / (2 * 0.38) mm
    var mm = 42.67 / (2 * BALL.r);
    var px = Math.round(mm * 3.7795 * DPR);
    cv2d.style.width = mm.toFixed(2) + 'mm'; cv2d.style.height = mm.toFixed(2) + 'mm';
    if (cv2d.width !== px) { cv2d.width = px; cv2d.height = px; }
    ctx2d.clearRect(0, 0, px, px);
    renderReal2D(ctx2d, px, 0);
    show(cv2d, true); show(cvGL, false);
    _lastRealKind = 'photo';
  } else if (state.view === 'print') {
    sizeCanvas(cv2d, css);
    renderPrintView(ctx2d, cv2d.width);
    show(cv2d, true); show(cvGL, false);
  } else if (glReady && BALL_MODE === 'webgl') {
    cvGL.style.width = css + 'px'; cvGL.style.height = css + 'px';
    glRender(css);
    setGLVisible(true); show(cv2d, false);
    _lastReal = cvGL; _lastRealKind = 'webgl';
  } else {
    sizeCanvas(cv2d, css);
    ctx2d.clearRect(0, 0, cv2d.width, cv2d.height);
    var kind = renderReal2D(ctx2d, cv2d.width, (glActive || BALL_MODE === 'webgl') ? 0 : state.angle);
    show(cv2d, true);
    if (glReady) {
      // hybrid: 3D immer mitrendern (fuer die Ueberblendung), sichtbar nur beim Drehen
      cvGL.style.width = css + 'px'; cvGL.style.height = css + 'px';
      glRender(css);
      setGLVisible(showGL);
    } else if (cvGL) {
      cvGL.style.display = 'none';
    }
    _lastReal = showGL ? cvGL : cv2d; _lastRealKind = showGL ? 'webgl' : kind;
  }
  state.ui.photoVisible = state.view !== 'print' && !showGL && _lastRealKind === 'photo' || (state.view === 'size' && !!MAPS.photo[state.color]);
  cv2d.classList.toggle('is-draggable', state.view === 'print' ? (state.mode === 'logo' && !!(state.logo && state.logo.image)) : (state.view === 'real' && !glActive));
  updateMini();
  updateStageNote();
  if (peek.on) renderPeek();
}

function sizeCanvas(c, css) {
  c.style.width = css + 'px'; c.style.height = css + 'px';
  var px = Math.round(css * DPR);
  if (c.width !== px || c.height !== px) { c.width = px; c.height = px; }
}

function updateMini() {
  if (!miniCv || !_lastReal || state.view !== 'real') return;
  var m = miniCv.getContext('2d'), S = _lastReal.width, R = S * BALL.r;
  m.clearRect(0, 0, miniCv.width, miniCv.height);
  try {
    m.drawImage(_lastReal, S * BALL.cx - R * 1.04, S * BALL.cy - R * 1.04, R * 2.08, R * 2.08, 0, 0, miniCv.width, miniCv.height);
  } catch (e) { /* WebGL-Canvas ohne Puffer */ }
}

// Mobil: schwebende Druckflaechen-Vorschau, solange die Platzierung (Groessenregler, Druckform) sichtbar ist und
// die Buehne nicht — so sieht man Groessenaenderungen live, ohne nach oben zu scrollen (Inhaber-Feedback 2026-10-08)
var peek = { el: null, cv: null, placeVisible: false, stageVisible: true, on: false };
var MOBILE_MQ = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
function initPeek() {
  peek.el = $('#placePeek'); peek.cv = $('#peekCanvas');
  var place = $('#placementBlock');
  if (!peek.el || !peek.cv || !place || !wrapper || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (es) { peek.placeVisible = es[0].isIntersecting; updatePeek(); }, { threshold: 0 }).observe(place);
  new IntersectionObserver(function (es) { peek.stageVisible = es[0].intersectionRatio > 0.35; updatePeek(); }, { threshold: [0, 0.35, 1] }).observe(wrapper);
  if (MOBILE_MQ && MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', updatePeek);
}
function updatePeek() {
  if (!peek.el) return;
  var on = !!(MOBILE_MQ && MOBILE_MQ.matches) && peek.placeVisible && !peek.stageVisible && hasContent();
  if (on !== peek.on) { peek.on = on; peek.el.classList.toggle('is-on', on); }
  if (on) renderPeek();
}
function renderPeek() {
  var css = 128, px = Math.round(css * DPR), c = peek.cv;
  if (c.width !== px) { c.width = px; c.height = px; c.style.width = css + 'px'; c.style.height = css + 'px'; }
  var g = c.getContext('2d'), pa = getActivePrintArea();
  var side = Math.round(px * 0.86), x0 = Math.round((px - side) / 2);
  g.clearRect(0, 0, px, px);
  g.save();
  g.beginPath();
  if (pa.shape === 'circle') g.arc(px / 2, px / 2, side / 2, 0, Math.PI * 2); else g.rect(x0, x0, side, side);
  g.fillStyle = '#FFFFFF'; g.fill();
  g.restore();
  var off = document.createElement('canvas'); off.width = side; off.height = side;
  drawDesign(off.getContext('2d'), side, side);
  g.drawImage(off, x0, x0);
  g.strokeStyle = '#006039'; g.lineWidth = Math.max(1, DPR);
  g.beginPath();
  if (pa.shape === 'circle') g.arc(px / 2, px / 2, side / 2, 0, Math.PI * 2); else g.rect(x0, x0, side, side);
  g.stroke();
}

function updateStageNote() {
  var note = $('#stageNote');
  var ai = $('#aiPhotoLabel');
  show(ai, !!state.ui.photoVisible);
  if (!note) return;
  var msg = '';
  if (state.mode === 'logo' && state.logo && state.logo.isPDF) msg = t('pdfNote');
  else if (state.view === 'real' && (useGL() || BALL_MODE === 'hybrid')) msg = t('dragHint');
  note.textContent = msg;
}

// ==========================================================================
// ZEIGER: Druckflaeche = Logo verschieben/skalieren; Realansicht = drehen
// ==========================================================================
var SNAP = 0.03, MIN_SCALE = 0.1, MAX_SCALE = 1.5;
var drag = null, pinch = null, pointers = {};

function paSpan(pa) { return pa.shape === 'circle' ? pa.diameter : pa.width; }

function pointerToArea(e) {
  var rect = cv2d.getBoundingClientRect();
  var px = e.clientX - rect.left, py = e.clientY - rect.top;
  if (!printGeom) return null;
  return { u: (px - printGeom.x0) / printGeom.side, v: (py - printGeom.y0) / printGeom.side };
}
function logoHit(uv) {
  if (!state.logo || !state.logo.image) return false;
  var r = logoRectInArea(1, 1, getActivePrintArea());
  return uv.u >= r.x && uv.u <= r.x + r.w && uv.v >= r.y && uv.v <= r.y + r.h;
}

function onPointerDown(e) {
  pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
  var ids = Object.keys(pointers);
  if (state.view === 'print' && state.mode === 'logo' && state.logo && state.logo.image && ids.length === 2) {
    var a = pointers[ids[0]], b = pointers[ids[1]];
    pinch = { d: Math.hypot(b.x - a.x, b.y - a.y), scale: state.placement.scale };
    drag = null;
    return;
  }
  if (state.view === 'print') {
    if (state.mode !== 'logo') return;
    var uv = pointerToArea(e);
    if (!uv || !logoHit(uv)) return;
    drag = { kind: 'move', u: uv.u, v: uv.v, x: state.placement.x, y: state.placement.y };
  } else if (state.view === 'real') {
    drag = { kind: 'rotate', cx: e.clientX, cy: e.clientY, angle: state.angle, rx: GL.rot.x, ry: GL.rot.y, moved: false };
  } else {
    return;
  }
  try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) { /* ignorieren */ }
}

function onPointerMove(e) {
  if (pointers[e.pointerId]) pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
  if (pinch) {
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      var s = pinch.scale * Math.hypot(b.x - a.x, b.y - a.y) / (pinch.d || 1);
      setScale(s);
    }
    return;
  }
  if (!drag) return;
  if (drag.kind === 'move') {
    var uv = pointerToArea(e); if (!uv) return;
    var pa = getActivePrintArea(), span = paSpan(pa);
    var nx = drag.x + (uv.u - drag.u) * span, ny = drag.y + (uv.v - drag.v) * span;
    if (Math.abs(nx - pa.centerX) < SNAP * span) nx = pa.centerX;
    if (Math.abs(ny - pa.centerY) < SNAP * span) ny = pa.centerY;
    state.placement.x = nx; state.placement.y = ny;
    state.ui.dragging = true;
    cv2d.classList.add('dragging');
    designChanged();
  } else if (drag.kind === 'rotate') {
    var dx = e.clientX - drag.cx, dy = e.clientY - drag.cy;
    if (!drag.moved && Math.hypot(dx, dy) < 3) return;
    drag.moved = true;
    if (useGL()) {
      GL.front = false;
      GL.rot.y = drag.ry + dx * 0.012;
      GL.rot.x = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, drag.rx + dy * 0.012)); // bis auf die Pole (TaylorMade-Aufdruck)
      cvGL.classList.add('dragging');
      requestRender();
    } else {
      var ang = Math.max(0, Math.min(90, Math.round(drag.angle + dx * 0.35)));
      if (ang !== state.angle) { state.angle = ang; syncRotateButtons(); requestRender(); }
    }
  }
}

function onPointerUp(e) {
  delete pointers[e.pointerId];
  if (Object.keys(pointers).length < 2) pinch = null;
  if (drag) {
    state.ui.dragging = false;
    if (cv2d) cv2d.classList.remove('dragging');
    if (cvGL) cvGL.classList.remove('dragging');
    // hybrid: fast frontal losgelassen -> einrasten und zurueck aufs Foto
    if (drag.kind === 'rotate' && drag.moved && BALL_MODE === 'hybrid' && useGL() && glNearFront()) {
      state.angle = 0; syncRotateButtons(); glToFront();
    } else if (drag.kind === 'rotate' && drag.moved && useGL()) {
      state.angle = -1; syncRotateButtons();
    }
    drag = null;
    requestRender();
  }
}

function onWheel(e) {
  if (state.view !== 'print' || state.mode !== 'logo' || !state.logo || !state.logo.image) return;
  e.preventDefault();
  setScale(state.placement.scale + (e.deltaY > 0 ? -0.02 : 0.02));
}

function setScale(s) {
  s = Math.max(MIN_SCALE, Math.min(MAX_SCALE, s));
  if (s === state.placement.scale) return;
  state.placement.scale = s;
  var slider = $('#sizeSlider'); if (slider) slider.value = Math.round(s * 100);
  designChanged();
}

function bindPointer(c) {
  c.addEventListener('pointerdown', onPointerDown);
  c.addEventListener('pointermove', onPointerMove);
  c.addEventListener('pointerup', onPointerUp);
  c.addEventListener('pointercancel', onPointerUp);
  c.addEventListener('wheel', onWheel, { passive: false });
}

// ==========================================================================
// BALL-VORSCHAU FUER DEN KORREKTURABZUG (JPEG 600 px, weisser Hintergrund)
// Immer prozedurale Frontansicht — deterministisch, ohne WebGL und ohne KI-Foto.
// ==========================================================================
function exportBallPreview() {
  var size = 600;
  var c = document.createElement('canvas'); c.width = size; c.height = size;
  var g = c.getContext('2d');
  g.fillStyle = '#ffffff'; g.fillRect(0, 0, size, size);
  if (MAPS.osn && MAPS.orm) renderProcedural(g, size, 0, state.color);
  else renderPlaceholder(g, size, state.color);
  return c.toDataURL('image/jpeg', 0.85);
}


// ==========================================================================
// UPLOAD — Validierung unveraendert (Endung, Groesse, MIME, Magic Bytes, DPI)
// ==========================================================================
var ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'svg', 'pdf'];
var ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml', 'application/pdf'];
var MAX_FILE_SIZE = 10 * 1024 * 1024;
var MIN_DIMENSION = 100;
var MAX_DIMENSION = 8000;

var dropzone, fileInput, feedbackEl, previewEl, filenameEl, dpiBadgeEl;

function validateFile(file) {
  var errors = [], warnings = [], infos = [];
  var ext = file.name.split('.').pop().toLowerCase();
  if (ALLOWED_EXTENSIONS.indexOf(ext) === -1) { errors.push(t('errFormat')); return { errors: errors, warnings: warnings, infos: infos, ext: ext }; }
  if (file.size > MAX_FILE_SIZE) {
    errors.push(t('errSize', { size: (file.size / 1024 / 1024).toFixed(1) }));
    return { errors: errors, warnings: warnings, infos: infos, ext: ext };
  }
  if (file.type && ALLOWED_MIME_TYPES.indexOf(file.type) === -1) { errors.push(t('errMime')); return { errors: errors, warnings: warnings, infos: infos, ext: ext }; }
  if (ext === 'svg') infos.push(t('infoSvg'));
  if (ext === 'pdf') infos.push(t('infoPdf'));
  return { errors: errors, warnings: warnings, infos: infos, ext: ext };
}

function checkDPI(width, height, printArea) {
  var printAreaMM = printArea.shape === 'square'
    ? Math.max(printArea.physicalWidthMM, printArea.physicalHeightMM)
    : printArea.physicalDiameterMM;
  var effectiveDPI = Math.round(Math.min(width, height) / (printAreaMM / 25.4));
  var level, message;
  if (effectiveDPI < 150) { level = 'bad'; message = t('dpiBad', { dpi: effectiveDPI }); }
  else if (effectiveDPI < 300) { level = 'warn'; message = t('dpiWarn', { dpi: effectiveDPI }); }
  else { level = 'good'; message = t('dpiGood', { dpi: effectiveDPI }); }
  return { effectiveDPI: effectiveDPI, level: level, message: message };
}

function checkTransparency(image) {
  try {
    var c = document.createElement('canvas'); c.width = 32; c.height = 32;
    var g = c.getContext('2d');
    g.drawImage(image, 0, 0, 32, 32);
    var data = g.getImageData(0, 0, 32, 32).data;
    for (var i = 3; i < data.length; i += 4) if (data[i] < 250) return true;
  } catch (e) { /* tainted */ }
  return false;
}

// Datei-Signatur (Magic Bytes) muss zur Endung passen
async function checkSignature(file, ext) {
  try {
    var buf = new Uint8Array(await file.slice(0, 512).arrayBuffer());
    var hex = Array.from(buf.slice(0, 4)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    if (ext === 'png') return hex === '89504e47';
    if (ext === 'jpg' || ext === 'jpeg') return hex.indexOf('ffd8ff') === 0;
    if (ext === 'pdf') return hex === '25504446';
    if (ext === 'svg') {
      var head = new TextDecoder('utf-8').decode(buf).replace(/^﻿/, '').replace(/^\s+/, '').toLowerCase();
      return head.indexOf('<?xml') === 0 || head.indexOf('<svg') !== -1;
    }
    return false;
  } catch (e) {
    return false;
  }
}

function loadLogoImage(file, ext) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    if (ext === 'svg') {
      var url = URL.createObjectURL(file);
      img.onload = function () { resolve({ image: img, dataUrl: url }); };
      img.onerror = reject;
      img.src = url;
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      img.onload = function () { resolve({ image: img, dataUrl: reader.result }); };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

async function processFile(file) {
  var validation = validateFile(file);
  if (validation.errors.length) { showFeedback('error', validation.errors[0]); return; }
  if (!(await checkSignature(file, validation.ext))) { showFeedback('error', t('errSignature')); return; }

  if (validation.ext === 'pdf') {
    state.logo = { file: file, image: null, dataUrl: null, width: 0, height: 0, dpi: null, format: 'pdf', isPDF: true };
    showFeedback('info', validation.infos[0]);
    showPreview(file.name, null);
    logoChanged();
    return;
  }
  try {
    var result = await loadLogoImage(file, validation.ext);
    var image = result.image;
    var w = image.naturalWidth || image.width, h = image.naturalHeight || image.height;
    if (w > MAX_DIMENSION || h > MAX_DIMENSION) { showFeedback('error', t('errPx', { w: w, h: h, max: MAX_DIMENSION })); return; }
    var dpiResult = validation.ext !== 'svg' ? checkDPI(w, h, getActivePrintArea()) : null;
    if (validation.ext !== 'jpg' && validation.ext !== 'jpeg' && checkTransparency(image)) validation.infos.push(t('infoTransparent'));
    state.logo = {
      file: file, image: image, dataUrl: result.dataUrl, width: w, height: h,
      dpi: (dpiResult && dpiResult.effectiveDPI) ? dpiResult.effectiveDPI : null,
      format: validation.ext, isPDF: false
    };
    if (w < MIN_DIMENSION || h < MIN_DIMENSION) showFeedback('warning', t('warnSmall', { w: w, h: h }));
    else if (validation.infos.length) showFeedback('info', validation.infos[0]);
    else if (dpiResult && dpiResult.level !== 'good') showFeedback(dpiResult.level === 'bad' ? 'error' : 'warning', dpiResult.message);
    else hideFeedback();
    showPreview(file.name, dpiResult);
    logoChanged();
  } catch (err) {
    showFeedback('error', t('errLoad'));
    console.error('[bc] Upload', err);
  }
}

function showFeedback(type, message) {
  if (!feedbackEl) return;
  feedbackEl.style.display = '';
  feedbackEl.className = 'upload-feedback ' + type;
  feedbackEl.textContent = message;
}
function hideFeedback() { if (feedbackEl) feedbackEl.style.display = 'none'; }

function showPreview(filename, dpiResult) {
  if (!previewEl) return;
  previewEl.style.display = '';
  if (filenameEl) filenameEl.textContent = filename;
  if (dpiBadgeEl) {
    if (dpiResult) { dpiBadgeEl.className = 'dpi-badge ' + dpiResult.level; dpiBadgeEl.textContent = dpiResult.message; }
    else if (state.logo && state.logo.format === 'svg') { dpiBadgeEl.className = 'dpi-badge good'; dpiBadgeEl.textContent = t('badgeSvg'); }
    else if (state.logo && state.logo.isPDF) { dpiBadgeEl.className = 'dpi-badge info'; dpiBadgeEl.textContent = t('badgePdf'); }
    else { dpiBadgeEl.textContent = ''; }
  }
  if (dropzone) dropzone.classList.add('has-file');
}
function hidePreview() {
  if (previewEl) previewEl.style.display = 'none';
  if (dropzone) dropzone.classList.remove('has-file');
}
function removeLogo() {
  state.logo = null;
  hidePreview();
  hideFeedback();
  if (fileInput) fileInput.value = '';
  logoChanged();
}
function logoChanged() {
  designChanged();
  bus.emit('content:changed');
}

function uploadInit() {
  dropzone = $('#dropzone');
  fileInput = $('#fileInput');
  feedbackEl = $('#uploadFeedback');
  previewEl = $('#uploadPreview');
  filenameEl = $('#previewFilename');
  dpiBadgeEl = $('#dpiBadge');
  if (!dropzone) return;
  function pick() { if (fileInput) fileInput.click(); }
  dropzone.addEventListener('click', pick);
  dropzone.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  var rep = $('#replaceLogoBtn'); if (rep) rep.addEventListener('click', pick);
  if (fileInput) fileInput.addEventListener('change', function (e) { var f = e.target.files[0]; if (f) processFile(f); });
  dropzone.addEventListener('dragover', function (e) { e.preventDefault(); dropzone.classList.add('drag-over'); });
  dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('drag-over'); });
  dropzone.addEventListener('drop', function (e) {
    e.preventDefault(); dropzone.classList.remove('drag-over');
    var f = e.dataTransfer.files[0]; if (f) processFile(f);
  });
  var rm = $('#removeLogoBtn'); if (rm) rm.addEventListener('click', function (e) { e.stopPropagation(); removeLogo(); });
}


// ==========================================================================
// SCHRITTE (Akkordeon, Route A)
// ==========================================================================
function stepDone(n) {
  if (n === 1) return true;
  if (n === 2) return designReady();
  return false;
}
function designReady() {
  return hasContent() && (state.mode !== 'logo' || state.rightsConfirmed);
}
// Gestaltung startet offen: Modell + Farbe sind vorbelegt, mobil soll der Upload sofort sichtbar sein
var START_STEP = 2;
function openStep(n, focus) {
  state.step = n;
  $$('.bck-step').forEach(function (s) {
    var open = Number(s.getAttribute('data-step')) === n;
    s.classList.toggle('is-open', open);
    var head = s.querySelector('.bck-step-head');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  updateProgress();
  updateCta();
  if (focus) {
    var step = $('.bck-step[data-step="' + n + '"]');
    if (step && step.scrollIntoView) step.scrollIntoView({ behavior: REDUCED_MOTION ? 'auto' : 'smooth', block: 'start' });
  }
}
function updateProgress() {
  var steps = $$('.bck-progress-step');
  steps.forEach(function (b) {
    var n = Number(b.getAttribute('data-step'));
    b.classList.toggle('is-active', n === state.step);
    b.classList.toggle('is-done', n !== state.step && n < state.step + 1 && stepDone(n) && n < 3);
    if (n === state.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
  });
  var lines = $$('.bck-progress-line');
  if (lines[0]) lines[0].classList.toggle('is-done', state.step > 1);
  if (lines[1]) lines[1].classList.toggle('is-done', state.step > 2 && stepDone(2));
}
function updateStepSummaries() {
  var s1 = $('#stepSum1'), s2 = $('#stepSum2'), s3 = $('#stepSum3');
  if (s1) s1.textContent = state.product.name + ' · ' + (state.color === 'yellow' ? t('colorYellow') : t('colorWhite'));
  if (s2) {
    var txt = '';
    if (state.mode === 'logo') txt = state.logo ? state.logo.file.name : '';
    else {
      var parts = [];
      if (state.symbol.id) parts.push(symbolLabel(state.symbol.id));
      var lines = activeTextLines();
      if (lines.length && effectiveLayout() !== 'only') parts.push('„' + lines.join(' / ') + '“');
      txt = parts.join(' + ');
    }
    s2.textContent = txt;
  }
  if (s3) s3.textContent = t('qtyWithBalls', { qty: state.quantity, balls: state.quantity * 12 });
}

function initSteps() {
  $$('.bck-step-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var n = Number(head.parentNode.getAttribute('data-step'));
      if (n !== state.step) openStep(n, false);
    });
  });
  $$('.bck-progress-step').forEach(function (b) {
    b.addEventListener('click', function () { openStep(Number(b.getAttribute('data-step')), true); });
  });
}

// ==========================================================================
// MODELL & FARBE
// ==========================================================================
function initProductGrid() {
  var grid = $('#productGrid');
  if (!grid) return;
  products.forEach(function (p, i) {
    var b = el('button', 'bck-model');
    b.type = 'button';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
    b.setAttribute('data-product-id', p.id);
    var imgUrl = IMAGE_MAP[p.shopifyHandle];
    if (imgUrl) {
      var im = el('img');
      im.src = imgUrl; im.alt = ''; im.loading = 'lazy'; im.width = 44; im.height = 44;
      b.appendChild(im);
    }
    var tx = el('span', 'bck-model-text');
    tx.appendChild(el('span', 'bck-model-name', p.name));
    tx.appendChild(el('span', 'bck-model-cat', (IS_EN ? p.specsEn : p.specs).kategorie + ' · ' + (IS_EN ? p.specsEn : p.specs).schichten));
    var price = tierPrice(p, state.color, TIERS[0]);
    tx.appendChild(el('span', 'bck-model-price', price !== null ? t('priceFrom', { price: formatPrice(price) }) : '—'));
    b.appendChild(tx);
    grid.appendChild(b);
  });
  grid.addEventListener('click', function (e) {
    var card = e.target.closest('.bck-model');
    if (!card) return;
    var p = products.filter(function (x) { return x.id === card.getAttribute('data-product-id'); })[0];
    if (!p || p === state.product) return;
    state.product = p;
    setChecked($$('.bck-model'), function (b) { return b === card; });
    productChanged();
  });
}
function productChanged() {
  updateSpecs();
  updatePricingUI();
  updateStepSummaries();
  designChanged();
}
function initColorSelector() {
  var sel = $('#colorSelector');
  if (!sel) return;
  sel.addEventListener('click', function (e) {
    var b = e.target.closest('[data-color]');
    if (!b || b.getAttribute('data-color') === state.color) return;
    state.color = b.getAttribute('data-color');
    setChecked($$('#colorSelector [data-color]'), function (x) { return x === b; });
    updatePricingUI();
    updateStepSummaries();
    requestRender();
  });
}
function updateSpecs() {
  var dl = $('#ballSpecs');
  if (!dl) return;
  var s = IS_EN ? state.product.specsEn : state.product.specs;
  var rows = [['specConstruction', s.schichten], ['specCover', s.cover], ['specCompression', s.kompression], ['specCategory', s.kategorie]];
  dl.innerHTML = '';
  rows.forEach(function (r) {
    var d = el('div');
    d.appendChild(el('dt', '', t(r[0])));
    d.appendChild(el('dd', '', r[1]));
    dl.appendChild(d);
  });
}

// ==========================================================================
// GESTALTUNG: Modus, Logo-Platzierung, Text & Symbol
// ==========================================================================
function setMode(mode) {
  if (mode === state.mode) return;
  state.mode = mode;
  state.text.enabled = mode === 'text';
  setChecked($$('#modeSwitch [data-mode]'), function (b) { return b.getAttribute('data-mode') === mode; });
  show($('#logoPanel'), mode === 'logo');
  show($('#textPanel'), mode === 'text');
  show($('#logoSizeRow'), mode === 'logo');
  show($('#positionHint'), mode === 'logo');
  designChanged();
  bus.emit('content:changed');
}
function initModeSwitch() {
  var sw = $('#modeSwitch');
  if (!sw) return;
  sw.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mode]');
    if (b) setMode(b.getAttribute('data-mode'));
  });
}
function initRights() {
  var cb = $('#logoRightsCheckbox'), label = $('#logoRightsConfirm');
  if (!cb) return;
  cb.addEventListener('change', function () {
    state.rightsConfirmed = cb.checked;
    if (label) { label.classList.toggle('is-checked', cb.checked); label.classList.remove('is-missing'); }
    bus.emit('content:changed');
  });
}
function initPlacement() {
  var shapeSel = $('#printShapeSelector');
  if (shapeSel) shapeSel.addEventListener('click', function (e) {
    var b = e.target.closest('[data-shape]');
    if (!b || b.getAttribute('data-shape') === state.printShape) return;
    state.printShape = b.getAttribute('data-shape');
    setChecked($$('#printShapeSelector [data-shape]'), function (x) { return x === b; });
    var info = $('#printAreaInfo');
    if (info) info.textContent = state.printShape === 'circle' ? t('chipAreaCircle') : t('chipAreaSquare');
    designChanged();
  });
  var slider = $('#sizeSlider');
  if (slider) slider.addEventListener('input', function () { setScale(slider.value / 100); });
  var center = $('#centerBtn');
  if (center) center.addEventListener('click', function () {
    var pa = getActivePrintArea();
    state.placement.x = pa.centerX; state.placement.y = pa.centerY;
    designChanged();
  });
}

function initTextSymbol() {
  $$('.font-preset-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.getAttribute('data-font');
      if (f === state.text.font) return;
      state.text.font = f;
      setChecked($$('.font-preset-btn'), function (x) { return x === b; });
      var fp = fontPresets[f];
      if (document.fonts && document.fonts.load) document.fonts.load(fp.weight + ' 40px ' + fp.family).then(designChanged, designChanged);
      designChanged();
    });
  });
  $$('.text-line-input').forEach(function (input) {
    input.addEventListener('input', function () {
      var i = Number(input.getAttribute('data-line'));
      state.text.lines[i] = input.value;
      var rest = TEXT_MAX_CHARS - input.value.length;
      var counter = $('[data-counter="' + i + '"]');
      if (counter) {
        counter.textContent = rest;
        counter.classList.toggle('warn', rest <= 3 && rest > 0);
        counter.classList.toggle('full', rest === 0);
      }
      designChanged();
      bus.emit('content:changed');
    });
  });
  var grid = $('#symbolGrid'), tabs = $('#symbolTabs');
  if (grid) {
    var activeGroup = SYMBOL_GROUPS[0].id;
    var symbolButton = function (id) {
      var b = el('button', 'bck-symbol' + (isFlag(id) ? ' bck-symbol--flag' : ''));
      b.type = 'button'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', state.symbol.id === id ? 'true' : 'false');
      b.setAttribute('data-symbol', id); b.setAttribute('aria-label', symbolLabel(id)); b.title = symbolLabel(id);
      if (isFlag(id)) {
        var ar = flagRatio(id), fh = 18, fw = Math.round(fh * ar);
        if (fw > 30) { fw = 30; fh = Math.round(fw / ar); }
        var c = document.createElement('canvas');
        c.width = fw * 2; c.height = fh * 2; c.style.width = fw + 'px'; c.style.height = fh + 'px';
        c.setAttribute('aria-hidden', 'true');
        drawFlag(c.getContext('2d'), SYMBOLS[id].flag, 0, 0, c.width, c.height, 2);
        b.appendChild(c);
      } else {
        b.innerHTML = '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="' + SYMBOLS[id].d + '"/></svg>';
      }
      return b;
    };
    var renderSymbolGrid = function () {
      grid.innerHTML = '';
      var none = el('button', 'bck-symbol bck-symbol--none', t('symbolNone'));
      none.type = 'button'; none.setAttribute('role', 'radio'); none.setAttribute('data-symbol', '');
      none.setAttribute('aria-checked', state.symbol.id ? 'false' : 'true');
      grid.appendChild(none);
      SYMBOL_GROUPS.forEach(function (g) {
        if (g.id === activeGroup) g.items.forEach(function (id) { grid.appendChild(symbolButton(id)); });
      });
      if (tabs) $$('#symbolTabs [data-group]').forEach(function (tb) {
        var on = tb.getAttribute('data-group') === activeGroup;
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.tabIndex = on ? 0 : -1;
      });
    };
    if (tabs) {
      SYMBOL_GROUPS.forEach(function (g) {
        var tb = el('button', 'bck-symtab', symbolGroupLabel(g.id));
        tb.type = 'button'; tb.setAttribute('role', 'tab'); tb.setAttribute('data-group', g.id);
        tb.setAttribute('aria-controls', 'symbolGrid');
        tabs.appendChild(tb);
      });
      tabs.addEventListener('click', function (e) {
        var tb = e.target.closest('[data-group]');
        if (!tb || tb.getAttribute('data-group') === activeGroup) return;
        activeGroup = tb.getAttribute('data-group');
        renderSymbolGrid();
      });
      // Pfeiltasten zwischen den Reitern (WAI-ARIA Tabs)
      tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var ids = SYMBOL_GROUPS.map(function (g) { return g.id; });
        var i = (ids.indexOf(activeGroup) + (e.key === 'ArrowRight' ? 1 : ids.length - 1)) % ids.length;
        activeGroup = ids[i];
        renderSymbolGrid();
        var tb = $('#symbolTabs [data-group="' + activeGroup + '"]'); if (tb) tb.focus();
        e.preventDefault();
      });
    }
    renderSymbolGrid();
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-symbol]');
      if (!b) return;
      state.symbol.id = b.getAttribute('data-symbol') || null;
      setChecked($$('#symbolGrid [data-symbol]'), function (x) { return x === b; });
      show($('#symbolLayoutField'), !!state.symbol.id);
      updateInkHint();
      updateTextInputsState();
      designChanged();
      bus.emit('content:changed');
    });
  }
  var lay = $('#symbolLayout');
  if (lay) lay.addEventListener('click', function (e) {
    var b = e.target.closest('[data-layout]');
    if (!b) return;
    state.symbol.layout = b.getAttribute('data-layout');
    setChecked($$('#symbolLayout [data-layout]'), function (x) { return x === b; });
    updateTextInputsState();
    designChanged();
    bus.emit('content:changed');
  });
  var wish = $('#colorWish');
  if (wish) wish.addEventListener('input', function () { state.colorWish = wish.value; });
}
// "Nur Symbol": Textzeilen werden nicht gedruckt -> Eingaben sichtbar deaktivieren
function updateTextInputsState() {
  var off = !!state.symbol.id && state.symbol.layout === 'only';
  $$('.text-line-input').forEach(function (i) { i.disabled = off; });
}

// ==========================================================================
// ANSICHT + DREHEN
// ==========================================================================
var ROT_PRESETS = { 0: { x: 0, y: 0 }, 35: { x: 0.12, y: 0.61 }, 90: { x: 0, y: Math.PI / 2 } };
function syncRotateButtons() {
  setChecked($$('#rotateSwitch [data-angle]'), function (b) { return Number(b.getAttribute('data-angle')) === state.angle; });
}
function initViewControls() {
  var vs = $('#viewSwitch');
  if (vs) vs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-view]');
    if (!b) return;
    state.view = b.getAttribute('data-view');
    setChecked($$('#viewSwitch [data-view]'), function (x) { return x === b; });
    show($('#rotateSwitch'), state.view === 'real');
    requestRender();
  });
  var rs = $('#rotateSwitch');
  if (rs) rs.addEventListener('click', function (e) {
    var b = e.target.closest('[data-angle]');
    if (!b) return;
    state.angle = Number(b.getAttribute('data-angle'));
    syncRotateButtons();
    if (useGL()) {
      var p = ROT_PRESETS[state.angle];
      if (BALL_MODE === 'hybrid' && state.angle === 0) glToFront();
      else { GL.front = false; glRotateTo(p.x, p.y); }
    }
    else requestRender();
  });
}

// ==========================================================================
// MENGE + PREISE
// ==========================================================================
function setQuantity(qty) {
  qty = Math.max(MOQ, Math.min(MAX_QTY, parseInt(qty, 10) || MOQ));
  state.quantity = qty;
  var input = $('#qtyInput');
  if (input) input.value = qty;
  updatePricingUI();
  updateStepSummaries();
}
function initQuantity() {
  var input = $('#qtyInput');
  if (!input) return;
  var minus = $('#qtyMinus'), plus = $('#qtyPlus');
  if (minus) minus.addEventListener('click', function () { setQuantity(state.quantity - 1); });
  if (plus) plus.addEventListener('click', function () { setQuantity(state.quantity + 1); });
  input.addEventListener('change', function () { setQuantity(input.value); });
  var grid = $('#tierGrid');
  if (grid) {
    TIERS.forEach(function (tier) {
      var b = el('button', 'bck-tier');
      b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      b.setAttribute('data-min', tier.min);
      b.appendChild(el('span', 'bck-tier-qty', tier.min + '–' + tier.max + ' ' + t('tierUnit')));
      b.appendChild(el('span', 'bck-tier-price'));
      b.appendChild(el('span', 'bck-tier-save'));
      grid.appendChild(b);
    });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.bck-tier');
      if (b) setQuantity(Number(b.getAttribute('data-min')));
    });
  }
}
function updatePricingUI() {
  var p = state.product, c = state.color;
  var base = tierPrice(p, c, TIERS[0]);
  var current = getTierForQuantity(state.quantity);
  $$('.bck-tier').forEach(function (b) {
    var tier = getTierForQuantity(Number(b.getAttribute('data-min')));
    var price = tierPrice(p, c, tier);
    b.setAttribute('aria-checked', tier === current ? 'true' : 'false');
    b.querySelector('.bck-tier-price').textContent = formatPrice(price);
    var save = '';
    if (price !== null && base !== null && tier !== TIERS[0]) {
      var pct = Math.round((1 - price / base) * 100);
      if (pct > 0) save = '−' + pct + ' %';
    }
    b.querySelector('.bck-tier-save').textContent = save;
  });
  // Naechste Staffel
  var nudge = $('#tierNudge');
  if (nudge) {
    var idx = TIERS.indexOf(current), next = TIERS[idx + 1], np = next ? tierPrice(p, c, next) : null;
    nudge.textContent = next && np !== null ? t('tierNext', { qty: next.min, price: formatPrice(np) }) : '';
  }
  // ab-Preise auf den Modellkarten (Einstiegsstaffel = zahlbarer Preis bei MOQ)
  $$('.bck-model').forEach(function (b) {
    var prod = products.filter(function (x) { return x.id === b.getAttribute('data-product-id'); })[0];
    var pr = prod ? tierPrice(prod, c, TIERS[0]) : null;
    var span = b.querySelector('.bck-model-price');
    if (span) span.textContent = pr !== null ? t('priceFrom', { price: formatPrice(pr) }) : '—';
  });
  updateSummary();
}
function updateSummary() {
  var ppd = currentPricePerDozen();
  var total = ppd !== null ? ppd * state.quantity : null;
  var qtyTxt = t('qtyWithBalls', { qty: state.quantity, balls: state.quantity * 12 });
  var set = function (id, v) { var n = $(id); if (n) n.textContent = v; };
  set('#summaryProduct', state.product.name + ' · ' + (state.color === 'yellow' ? t('colorYellow') : t('colorWhite')));
  set('#summaryQty', qtyTxt);
  set('#summaryPricePerDozen', formatPrice(ppd));
  set('#summaryTotal', formatPrice(total));
  set('#barTotal', formatPrice(total));
  var narrow = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  set('#barMeta', narrow ? qtyTxt : state.product.name + ' · ' + qtyTxt + ' · ' + formatPrice(ppd) + ' ' + t('perDozen'));
  updateQuoteLink();
  updateCta();
}
function updateQuoteLink() {
  var a = $('#quoteLink');
  if (!a) return;
  if (!QUOTE_URL) { show(a, false); return; }
  var id = null;
  try { id = getShopifyVariantId(); } catch (e) { id = null; }
  show(a, !!id);
  if (id) {
    var title = state.product.name + ' · ' + (state.color === 'yellow' ? t('colorYellow') : t('colorWhite'));
    a.href = QUOTE_URL + (QUOTE_URL.indexOf('?') === -1 ? '?' : '&') + 'variant=' + id + '&qty=' + state.quantity + '&title=' + encodeURIComponent(title);
  }
}

// ==========================================================================
// BESTELL-LEISTE / CTA
// ==========================================================================
function ctaBlocker() {
  if (state.step >= 2 && !hasContent()) return 'design';
  if (state.step >= 2 && state.mode === 'logo' && !state.rightsConfirmed) return 'rights';
  if (state.step === 3 && currentPricePerDozen() === null) return 'price';
  return null;
}
function updateCta() {
  var btn = $('#addToCartBtn');
  if (!btn) return;
  var label = state.step === 1 ? t('ctaNextDesign') : state.step === 2 ? t('ctaNextQuantity') : t('ctaAdd');
  var txt = btn.querySelector('.cta-text');
  if (txt) txt.textContent = label;
  var blocker = ctaBlocker();
  btn.setAttribute('aria-disabled', blocker ? 'true' : 'false');
  var reason = $('#ctaReason');
  if (reason) reason.textContent = blocker === 'design' ? t('reasonDesign') : blocker === 'rights' ? t('reasonRights') : blocker === 'price' ? t('reasonPrice') : '';
}
function initCta() {
  var btn = $('#addToCartBtn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    if (state.ui.busy) return;
    var blocker = ctaBlocker();
    if (blocker === 'design' || blocker === 'rights') {
      if (state.step !== 2) openStep(2, true);
      if (blocker === 'rights') {
        var label = $('#logoRightsConfirm'), cb = $('#logoRightsCheckbox');
        if (label) label.classList.add('is-missing');
        if (cb) cb.focus();
      }
      return;
    }
    if (blocker) return;
    if (state.step === 1) { openStep(2, true); return; }
    if (state.step === 2) { openStep(3, true); return; }
    addToCart();
  });
  var retry = $('#cartRetry');
  if (retry) retry.addEventListener('click', function () { addToCart(); });
  var another = $('#configureAnother');
  if (another) another.addEventListener('click', function () {
    resetDesign();
    show($('#cartSuccess'), false);
    openStep(2, true);
  });
}

function setBusy(on) {
  state.ui.busy = on;
  var btn = $('#addToCartBtn');
  if (!btn) return;
  btn.classList.toggle('is-busy', on);
  btn.setAttribute('aria-busy', on ? 'true' : 'false');
  var sp = btn.querySelector('.cta-spinner');
  if (sp) sp.style.display = on ? '' : 'none';
}

// ==========================================================================
// RESET
// ==========================================================================
function resetDesign() {
  removeLogo();
  state.placement = { x: DEFAULT_PLACEMENT.x, y: DEFAULT_PLACEMENT.y, scale: DEFAULT_PLACEMENT.scale };
  state.text.lines = ['', '', ''];
  state.symbol = { id: null, layout: 'above' };
  state.colorWish = '';
  state.rightsConfirmed = false;
  var cb = $('#logoRightsCheckbox'); if (cb) cb.checked = false;
  var label = $('#logoRightsConfirm'); if (label) label.classList.remove('is-checked', 'is-missing');
  $$('.text-line-input').forEach(function (i) { i.value = ''; i.disabled = false; });
  $$('.char-counter').forEach(function (c) { c.textContent = TEXT_MAX_CHARS; c.className = 'char-counter'; });
  setChecked($$('#symbolGrid [data-symbol]'), function (b) { return !b.getAttribute('data-symbol'); });
  setChecked($$('#symbolLayout [data-layout]'), function (b) { return b.getAttribute('data-layout') === 'above'; });
  show($('#symbolLayoutField'), false);
  updateInkHint();
  var wish = $('#colorWish'); if (wish) wish.value = '';
  var slider = $('#sizeSlider'); if (slider) slider.value = Math.round(DEFAULT_PLACEMENT.scale * 100);
  designChanged();
  bus.emit('content:changed');
}
function resetConfigurator() {
  resetDesign();
  setMode('logo');
  state.product = products[0];
  setChecked($$('.bck-model'), function (b, i) { return b.getAttribute('data-product-id') === products[0].id; });
  state.color = 'white';
  setChecked($$('#colorSelector [data-color]'), function (b) { return b.getAttribute('data-color') === 'white'; });
  state.printShape = 'circle';
  setChecked($$('#printShapeSelector [data-shape]'), function (b) { return b.getAttribute('data-shape') === 'circle'; });
  var info = $('#printAreaInfo'); if (info) info.textContent = t('chipAreaCircle');
  state.text.font = 'klassisch';
  setChecked($$('.font-preset-btn'), function (b) { return b.getAttribute('data-font') === 'klassisch'; });
  state.view = 'real';
  setChecked($$('#viewSwitch [data-view]'), function (b) { return b.getAttribute('data-view') === 'real'; });
  show($('#rotateSwitch'), true);
  state.angle = 0; syncRotateButtons(); GL.rot = { x: 0, y: 0 }; GL.front = true;
  state.wishDate = '';
  var wd = $('#wishDate'); if (wd) wd.value = '';
  // A1: Menge zurueck auf die Mindestmenge (v1.2 setzte hier 1 -> falsche Staffel im Warenkorb)
  setQuantity(MOQ);
  show($('#cartSuccess'), false); show($('#cartError'), false);
  productChanged();
  openStep(START_STEP, false);
}


// ==========================================================================
// SHOPIFY: Variante, Uploads (Cloudflare Worker -> R2), Warenkorb
// ==========================================================================
var WORKER_URL = 'https://brandcaddie-proof-sheet.brandcaddie.workers.dev';
var isShopify = typeof window.Shopify !== 'undefined';

function getShopifyVariantId() {
  var handle = state.product.shopifyHandle || state.product.id;
  var color = state.color === 'white' ? 'weiss' : 'gelb';
  var tier = getTierForQuantity(state.quantity);
  var key = handle + '-' + color + '-' + tier.min;
  var id = VARIANT_MAP[key];
  // Fallback: hoechste Staffel <= Bestellmenge (Staffelgrenzen Admin vs. JS auseinander)
  if (!id) {
    var prefix = handle + '-' + color + '-', bestMin = -1;
    Object.keys(VARIANT_MAP).forEach(function (k) {
      if (k.indexOf(prefix) !== 0) return;
      var m = parseInt(k.slice(prefix.length), 10);
      if (!isNaN(m) && m <= state.quantity && m > bestMin) { bestMin = m; id = VARIANT_MAP[k]; }
    });
  }
  // Ohne throw ginge id:undefined an /cart/add.js -> 4xx ohne Diagnose.
  if (!id) throw new Error('Variante nicht gefunden: ' + key);
  return id;
}

async function uploadPrintFile(dataUrl, metadata) {
  var base64 = dataUrl.split(',')[1];
  if (!base64) throw new Error('Invalid data URL');
  var res = await fetch(WORKER_URL + '/upload', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ printFile: base64, metadata: metadata })
  });
  if (!res.ok) throw new Error('Upload failed: ' + res.status);
  return (await res.json()).url;
}
function fileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var r = new FileReader();
    r.onload = function () { resolve(String(r.result).split(',')[1]); };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
async function uploadOriginalFile(file, metadata) {
  var base64 = await fileToBase64(file);
  var res = await fetch(WORKER_URL + '/upload-original', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fileData: base64, filename: file.name, metadata: metadata })
  });
  if (!res.ok) throw new Error('Original upload failed: ' + res.status);
  return (await res.json()).url;
}

// Property-Vertrag: bestehende Keys/Werte unveraendert, neue nur additiv (v1.3).
function buildProperties() {
  var tier = getTierForQuantity(state.quantity);
  var pa = getActivePrintArea();
  var specs = state.product.specs || {};
  var props = {
    'Modell': state.product.name,
    'Farbe': state.color === 'white' ? 'Weiß' : 'Gelb',
    'Konstruktion': specs.schichten || '',
    'Cover': specs.cover || '',
    'Kompression': specs.kompression || '',
    'Druckverfahren': specs.druck || '',
    'Druckfläche': state.printShape === 'circle' ? 'Rund, Ø 25 mm' : 'Eckig, 18.5 × 18.5 mm',
    // 'Menge' NICHT umbenennen — der Korrekturabzug-Worker liest props['Menge'].
    'Menge': state.quantity + ' Dutzend (' + (state.quantity * 12) + ' Bälle)',
    'Preis/DZ': formatPriceDE(currentPricePerDozen()),
    'Preisstaffel': tier.label,
    '_logo_placement_x': state.placement.x.toFixed(4),
    '_logo_placement_y': state.placement.y.toFixed(4),
    '_logo_placement_scale': state.placement.scale.toFixed(4),
    '_product_id': state.product.id,
    '_product_color': state.color,
    '_print_shape': state.printShape,
    '_print_area_mm': pa.shape === 'circle' ? 'Ø' + pa.physicalDiameterMM + 'mm' : pa.physicalWidthMM + '×' + pa.physicalHeightMM + 'mm',
    '_konfigurator_version': '1.3',
    '_design_mode': state.mode
  };
  if (state.mode === 'logo' && state.logo && state.logo.file) {
    props['Logo'] = state.logo.file.name;
    props['_logo_filename'] = state.logo.file.name;
    props['_logo_format'] = state.logo.format;
    props['_logo_dpi'] = state.logo.dpi || 'svg';
    // Urheberrecht/Nutzungsrechte-Bestaetigung (Pflicht laut AGB)
    props['_logo_rights_confirmed'] = state.rightsConfirmed ? 'true' : 'false';
  }
  if (state.mode === 'text') {
    var layout = effectiveLayout();
    var lines = layout === 'only' ? [] : activeTextLines();
    if (lines.length) {
      props['Text'] = lines.join(' | ');
      var fp = fontPresets[state.text.font];
      props['Schrift'] = fp ? fp.label : state.text.font;
      props['_text_lines'] = JSON.stringify(layout === 'only' ? ['', '', ''] : state.text.lines);
      props['_text_font'] = state.text.font;
    }
    if (state.symbol.id) {
      props['Symbol'] = SYMBOLS[state.symbol.id].de;
      props['_symbol_id'] = SYMBOLS[state.symbol.id].file;
      props['_symbol_layout'] = layout;
      // Flaggen werden farbig gedruckt: Farbliste fuer die Produktion (sichtbar, additiv seit 2026-10-08)
      if (isFlag(state.symbol.id)) props['Symbolfarben'] = flagColors(SYMBOLS[state.symbol.id].flag).join(', ');
    }
    if (state.colorWish.trim()) props['Farbwunsch'] = state.colorWish.trim();
  }
  if (state.wishDate.trim()) props['Wunschtermin'] = state.wishDate.trim();
  return props;
}

async function addToCart() {
  if (state.ui.busy) return;
  show($('#cartSuccess'), false); show($('#cartError'), false);
  setBusy(true);
  try {
    var variantId = getShopifyVariantId();
    var props = buildProperties();
    var meta = { product: state.product.id, color: state.color, shape: state.printShape, timestamp: new Date().toISOString() };
    var isLogo = state.mode === 'logo' && state.logo;
    var wantPrintFile = isLogo ? !state.logo.isPDF : hasTextContent();
    if (state.mode === 'text' && document.fonts && document.fonts.ready) { try { await document.fonts.ready; } catch (e) { /* weiter */ } }

    // Originaldatei ist die Produktionsgrundlage -> Fehler bricht ab (kein Artikel ohne Datei)
    if (isLogo) {
      try { props['_original_file_url'] = await uploadOriginalFile(state.logo.file, meta); }
      catch (e) { var err = new Error('upload'); err.kind = 'upload'; err.cause = e; throw err; }
    }
    var jobs = [];
    if (wantPrintFile) {
      jobs.push(uploadPrintFile(exportPrintFile(), meta)
        .then(function (url) { props['_print_file_url'] = url; })
        .catch(function (e) { console.warn('[bc] Druckdatei-Upload fehlgeschlagen', e); props['_print_file_ref'] = 'upload_failed'; }));
    }
    jobs.push(ensureMaps().then(function () {
      var bm = {}; for (var k in meta) bm[k] = meta[k]; bm.type = 'ball-preview';
      return uploadPrintFile(exportBallPreview(), bm).then(function (url) { props['_ball_preview_url'] = url; });
    }).catch(function (e) { console.warn('[bc] Ball-Vorschau-Upload fehlgeschlagen', e); }));
    await Promise.all(jobs);

    if (isShopify) {
      var res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: state.quantity, properties: props }] })
      });
      if (!res.ok) { var e2 = new Error('cart ' + res.status); e2.kind = 'cart'; throw e2; }
      updateCartCount();
    } else {
      console.log('[bc] Mock-Warenkorb', variantId, state.quantity, props);
    }
    var st = $('#cartSuccessText');
    if (st) st.textContent = t('addedText', { qty: state.quantity, model: state.product.name });
    show($('#cartSuccess'), true);
  } catch (err) {
    console.error('[bc] Warenkorb-Fehler', err);
    var et = $('#cartErrorText');
    if (et) et.textContent = err && err.kind === 'upload' ? t('errorUpload') : t('errorCart');
    show($('#cartError'), true);
  } finally {
    setBusy(false);
  }
}

async function updateCartCount() {
  try {
    var cart = await (await fetch('/cart.js')).json();
    var countEl = document.getElementById('cartCount');
    if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count === 0 ? 'none' : ''; }
  } catch (e) { /* ignorieren */ }
}

// ==========================================================================
// INIT
// ==========================================================================
function init() {
  cv2d = $('#ballCanvas'); ctx2d = cv2d ? cv2d.getContext('2d') : null;
  cvGL = $('#ballCanvasGL'); wrapper = $('#canvasWrapper'); miniCv = $('#miniBall');
  if (miniCv) { miniCv.width = Math.round(44 * DPR); miniCv.height = Math.round(44 * DPR); }

  initSteps();
  initProductGrid();
  initColorSelector();
  initModeSwitch();
  uploadInit();
  initRights();
  initPlacement();
  initTextSymbol();
  initViewControls();
  initQuantity();
  initCta();
  var wd = $('#wishDate'); if (wd) wd.addEventListener('input', function () { state.wishDate = wd.value; });
  var reset = $('#resetBtn'); if (reset) reset.addEventListener('click', resetConfigurator);
  if (cv2d) bindPointer(cv2d);
  if (cvGL) bindPointer(cvGL);
  initPeek();

  bus.on('design:changed', function () { updateStepSummaries(); requestRender(); });
  bus.on('content:changed', function () { updateProgress(); updateCta(); updateStepSummaries(); updatePeek(); });

  updateSpecs();
  setQuantity(MOQ);
  openStep(START_STEP, false);

  // Assets vorladen: Foto (Front) + Maps (Drehen, PDF-Vorschau)
  ensurePhoto(state.color);
  ensureMaps();
  if (BALL_MODE !== 'photo_procedural') ensureGL();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { designChanged(); });

  var ro = window.ResizeObserver ? new ResizeObserver(function () { requestRender(); }) : null;
  if (ro && wrapper) ro.observe(wrapper); else window.addEventListener('resize', requestRender);
  requestRender();
  console.log('[bc] Konfigurator v1.3 — ' + (isShopify ? 'Shopify' : 'Standalone') + ', Ball: ' + BALL_MODE);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

})();
